import {
  Component,
  Input,
  EventEmitter,
  Output,
  HostListener,
  SimpleChanges,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { AlertMessageModel } from 'src/app/common/models/common.model';
import * as _ from 'lodash';
import { Subject, Subscription, forkJoin, of } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SnapshotSharedVariablesService } from '../../Services/snapshot-shared-variables.service';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { SnapshotService } from '../../Services/snapshot.service';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';
import {
  checkboxSelectionWithParentSnapshot,
  DataObjectSnapshot,
} from 'src/app/common/models/crosstab.model';
import { formatMmaLabelForDisplay } from 'src/app/common/utils/time-period-display.util';
import {
  injectMostRecentIntoSnapshotLevel2,
  isMostRecentTimePeriodLabel,
  resolveSnapshotMostRecentSelection,
  getResolvedTimePeriodChildKey,
  formatMostRecentSelectionLabel,
} from 'src/app/common/utils/most-recent-time-period.util';

import { UserProjectManagementService } from 'src/app/common/services/user-project-management.service';
import { CheckboxSelectionModel } from 'src/app/common/constants/common-constants';
import { EntrypointcolorService } from 'src/app/common/services/entrypointcolor.service';
import { threadId } from 'worker_threads';
import { de } from 'date-fns/locale';

interface MetricOptions {
  Name: string;
  isActive: boolean;
  responseCode: string;
}

interface Config {
  key: string;
  value: boolean;
}

interface Level2Item {
  Level2_value: string;
  [key: string]: any;
}

interface Level1Block {
  Level1_value: string;
  Level2: Level2Item[];
}

@Component({
  selector: 'app-leftpanel-snapshot',
  templateUrl: './leftpanel.component.html',
  styleUrls: ['./leftpanel.component.css'],
})
export class LeftpanelComponent implements OnDestroy {
  @Input() isCustomSnapshot: boolean = false;
  @Output() issubmitReset = new EventEmitter<boolean>();
  @Output() additionalFeatures = new EventEmitter<any>();
  @Output() IsEntrypointSelected = new EventEmitter<any>();
  @Input() isGlobalDefaultSelectionEnabled: boolean = false;
  @Input() selectedBrandFromConfig: any = null;
  @ViewChild('variablesScroll') variablesScroll!: ElementRef;

  isAdditionalFeatures: boolean = false;
  issavelaodcheck: boolean = true;
  isadditionalfeatureDropdownOpen: boolean = false;

  additionalFeaturesList: any = [
    { name: 'Custom Variable', value: 'Custom Variable' },
    { name: 'Custom Reports', value: 'Custom Reports' },
  ];

  singleorMultiSelectMandatory1: string = '';
  timeperiodMandatory2: string = '';
  brandMandatory3: string = '';

  entryPointsData: any;
  snapshotData: any;
  snapshotDataConfig: any;
  top: string = '0px';
  topLev1: string = '0px';
  topEP: string = '0px';

  level0EP: string[] = [];
  Level0Variables: string[] = [];
  level0Filters: string[] = [];
  snapshotcohortType: string = '';
  selectedObjects: any[] = [];

  levelNumFor3n4: number = 0;
  mandatoryVariableMapping: any;
  multiCohort: boolean = false;
  mandatoryMaxLimitReached: boolean = false;

  @Output() showOutput = new EventEmitter<void>();
  @Output() baseValuesChanged = new EventEmitter<{
    insufficientBase: number;
    lowBase: number;
  }>();
  @Output() isLoadSelection = new EventEmitter<boolean>();
  @Input() snapshotselected: any = '';
  @Input() sectionselected: any = '';
  @Input() subsectionselected: any = '';
  bgWidth: any = 0;

  compareacross: any = [
    { name: 'Market', value: 'standard', selected: true },
    { name: 'Brands', value: 'custom', selected: false },
    { name: 'Metrics', value: 'builder', selected: false },
  ];

  prevCompareAcrossValue: string = '';
  prevSectionValue: string = '';

  uniqueSelections: string[] = [];

  private destroy$ = new Subject<void>();
  $unSubscribeSubmitData1!: Subscription;
  $unSubscribeSubmitData2!: Subscription;
  // $unSubscribeSubmitData3!: Subscription;
  Reciveddata: any;

  selectionSummary: string = '';
  selectionSummaryTitle: string = '';
  audienceTooltip: string = 'No selections';

  variablesSummaryObj: any = [];
  variablesSummaryObjRadio: any = [];
  isMultiSelectEP: boolean = false;
  isLoader: boolean = false;

  private _isMirroringBrandSelection = false;

  private readonly fasTotalOption = 'FAS Total';
  private readonly fasSegmentOptions = [
    'FAS - Broker/Dealers',
    'FAS - RIAs',
    'FAS - Bank',
  ];

  private normalizeAudienceOptionLabel(label: string): string {
    return (label || '').trim().toLowerCase();
  }

  private isFasTotalLabel(label: string): boolean {
    return (
      this.normalizeAudienceOptionLabel(label) ===
      this.normalizeAudienceOptionLabel(this.fasTotalOption)
    );
  }

  private isFasSegmentLabel(label: string): boolean {
    const normalized = this.normalizeAudienceOptionLabel(label);
    return (
      this.fasSegmentOptions.some(
        (option) => this.normalizeAudienceOptionLabel(option) === normalized,
      ) || /^fas\s*-\s*(broker|ria|bank)/i.test((label || '').trim())
    );
  }

  /** Treat FAS Total as the three FAS segment labels for data/calc (not Topics BrandList). */
  private expandFasTotalNames(names: string[]): string[] {
    const source = (names || []).filter((name) => !!name);
    if (!source.some((name) => this.isFasTotalLabel(name))) {
      return source;
    }

    const expanded = source.filter((name) => !this.isFasTotalLabel(name));
    for (const segment of this.fasSegmentOptions) {
      if (
        !expanded.some(
          (name) =>
            this.normalizeAudienceOptionLabel(name) ===
            this.normalizeAudienceOptionLabel(segment),
        )
      ) {
        expanded.push(segment);
      }
    }
    return expanded;
  }

  private getFasSegmentOptionDetails(): Array<{
    Name: string;
    responseCode: string;
    Dependency_e1: string;
    Dependency_e2: string;
  }> {
    const fromPanel = (this.entryPanel_Lvl3 || [])
      .filter((item) => this.isFasSegmentLabel(item.MetricOptions))
      .map((item) => ({
        Name: item.MetricOptions,
        responseCode: item.responseCode,
        Dependency_e1: item.e1_variable_code,
        Dependency_e2: item.e2_variable_code,
      }));

    if (fromPanel.length > 0) {
      return fromPanel;
    }

    return (this.Reciveddata || [])
      .filter(
        (row: any) =>
          row?.Header === 'EntryPoint' &&
          this.isFasSegmentLabel(row?.MetricOption),
      )
      .map((row: any) => ({
        Name: row.MetricOption,
        responseCode: row.ResponseCode,
        Dependency_e1: row.e1_variable_code,
        Dependency_e2: row.e2_variable_code,
      }));
  }

  /**
   * Clone entry-point payload and replace FAS Total with the three FAS segments
   * so load / output / API filtering behave as if all three were selected.
   * UI selection state (dataArray) remains FAS Total for display.
   */
  private expandFasTotalInEntryPointData(sourceData: any[]): any[] {
    const payload = _.cloneDeep(sourceData || []);
    const fasSegments = this.getFasSegmentOptionDetails();
    if (fasSegments.length === 0) {
      return payload;
    }

    for (const entry of payload) {
      for (const key of Object.keys(entry || {})) {
        if (!key.startsWith('EntryPoint')) {
          continue;
        }
        const entryPoint = entry[key];
        if (!entryPoint?.Level2?.length) {
          continue;
        }

        for (const level2 of entryPoint.Level2) {
          const options = level2.MetricOptions || [];
          const hasFasTotal = options.some(
            (mo: any) =>
              this.isFasTotalLabel(mo?.Name) ||
              `${mo?.responseCode || ''}`.toUpperCase() === 'FAS_TOTAL',
          );
          if (!hasFasTotal) {
            continue;
          }

          level2.MetricOptions = options.filter(
            (mo: any) =>
              !this.isFasTotalLabel(mo?.Name) &&
              `${mo?.responseCode || ''}`.toUpperCase() !== 'FAS_TOTAL',
          );

          for (const segment of fasSegments) {
            const alreadyPresent = level2.MetricOptions.some(
              (mo: any) =>
                this.normalizeAudienceOptionLabel(mo?.Name) ===
                  this.normalizeAudienceOptionLabel(segment.Name) ||
                mo?.responseCode === segment.responseCode,
            );
            if (!alreadyPresent) {
              level2.MetricOptions.push({
                Name: segment.Name,
                responseCode: segment.responseCode,
                isActive: true,
                Dependency_e1: segment.Dependency_e1,
                Dependency_e2: segment.Dependency_e2,
              });
            }
          }
        }
      }
    }

    return payload;
  }

  private entryPointMetricOptionsHasFasTotal(epConfig: any): boolean {
    if (!epConfig) {
      return false;
    }
    if (Array.isArray(epConfig)) {
      return epConfig.some(
        (c: string) =>
          this.isFasTotalLabel(c) || `${c || ''}`.toUpperCase() === 'FAS_TOTAL',
      );
    }
    return (epConfig.Level2 || []).some((l2: any) =>
      (l2.MetricOptions || []).some(
        (mo: any) =>
          this.isFasTotalLabel(mo?.Name || '') ||
          `${mo?.responseCode || ''}`.toUpperCase() === 'FAS_TOTAL',
      ),
    );
  }

  private entryPointMetricOptionsMatchSelected(
    epConfig: any,
    selectedNames: string[],
    selectedCodes: string[] = [],
  ): boolean {
    if (!epConfig) {
      return true;
    }
    if (Array.isArray(epConfig)) {
      return epConfig.some(
        (c: string) =>
          selectedCodes.includes(c) || selectedNames.includes(c),
      );
    }
    return (epConfig.Level2 || []).some((l2: any) =>
      (l2.MetricOptions || []).some(
        (mo: any) =>
          selectedNames.includes(mo?.Name) ||
          selectedCodes.includes(mo?.responseCode) ||
          selectedNames.includes(mo?.responseCode),
      ),
    );
  }

  /**
   * Topics Default Brands matching (union across selected audiences):
   * - Non-FAS audiences → their Topics rows
   * - FAS Total → only the FAS Total Topics row
   * - FAS segment → that segment's own row; fall back to FAS Total only if none
   */
  private filterTopicsRowsForDefaultBrands(
    allRows: any[],
    ep1Names: string[],
    ep2Names: string[],
    ep3Names: string[],
    ep1Codes: string[] = [],
  ): any[] {
    const fasTotalSelected =
      ep1Names.some((n) => this.isFasTotalLabel(n)) ||
      ep1Codes.some((c) => `${c || ''}`.toUpperCase() === 'FAS_TOTAL');

    const nonFasNames = ep1Names.filter(
      (n) => !this.isFasTotalLabel(n) && !this.isFasSegmentLabel(n),
    );
    const fasSegmentNames = ep1Names.filter((n) => this.isFasSegmentLabel(n));
    const nonFasCodes = ep1Codes.filter(
      (c) =>
        `${c || ''}`.toUpperCase() !== 'FAS_TOTAL' &&
        !this.isFasTotalLabel(c) &&
        !this.isFasSegmentLabel(c),
    );
    const fasSegmentCodes = ep1Codes.filter((c) => this.isFasSegmentLabel(c));

    const matchesEp2Ep3 = (row: any): boolean => {
      const ep2Match =
        !ep2Names.length ||
        !row.EntryPoint2 ||
        this.entryPointMetricOptionsMatchSelected(row.EntryPoint2, ep2Names);
      const ep3Match =
        !ep3Names.length ||
        !row.EntryPoint3 ||
        this.entryPointMetricOptionsMatchSelected(row.EntryPoint3, ep3Names);
      return ep2Match && ep3Match;
    };

    const candidates = (allRows || []).filter(matchesEp2Ep3);

    if (!(ep1Names.length || ep1Codes.length)) {
      return candidates;
    }

    const matched: any[] = [];
    const pushUnique = (rows: any[]) => {
      for (const row of rows) {
        if (!matched.includes(row)) {
          matched.push(row);
        }
      }
    };

    if (nonFasNames.length || nonFasCodes.length) {
      pushUnique(
        candidates.filter((row) => {
          const ep1Config = row.EntryPoint1 || row.entryPoint1;
          return (
            !!ep1Config &&
            this.entryPointMetricOptionsMatchSelected(
              ep1Config,
              nonFasNames,
              nonFasCodes,
            )
          );
        }),
      );
    }

    if (fasTotalSelected) {
      pushUnique(
        candidates.filter((row) =>
          this.entryPointMetricOptionsHasFasTotal(
            row.EntryPoint1 || row.entryPoint1,
          ),
        ),
      );
    } else if (fasSegmentNames.length || fasSegmentCodes.length) {
      const dedicatedSegmentRows = candidates.filter((row) => {
        const ep1Config = row.EntryPoint1 || row.entryPoint1;
        return (
          !!ep1Config &&
          this.entryPointMetricOptionsMatchSelected(
            ep1Config,
            fasSegmentNames,
            fasSegmentCodes,
          ) &&
          !this.entryPointMetricOptionsHasFasTotal(ep1Config)
        );
      });
      if (dedicatedSegmentRows.length > 0) {
        pushUnique(dedicatedSegmentRows);
      } else {
        pushUnique(
          candidates.filter((row) =>
            this.entryPointMetricOptionsHasFasTotal(
              row.EntryPoint1 || row.entryPoint1,
            ),
          ),
        );
      }
    }

    if (matched.length > 0) {
      return matched;
    }

    return candidates.filter((row) => {
      const ep1Config = row.EntryPoint1 || row.entryPoint1;
      return (
        !ep1Config ||
        this.entryPointMetricOptionsMatchSelected(
          ep1Config,
          ep1Names,
          ep1Codes,
        )
      );
    });
  }

  private applyDefaultBrandListToBrandsPanel(): void {
    if (!this.defaultBrandList?.length || !this.variableList?.length) {
      return;
    }

    const brandsItem = this.variableList.find(
      (v: any) => v.Level0 === 'Brands',
    );
    const defaultLevel1 = brandsItem?.Level1?.find(
      (l1: any) => l1.Level1_value === 'Default',
    );
    if (!defaultLevel1 || !Array.isArray(defaultLevel1.Level2)) {
      return;
    }

    for (const l2 of defaultLevel1.Level2) {
      if (
        l2?.is_selected &&
        !this.defaultBrandList.includes(l2.Level2_value)
      ) {
        l2.is_selected = false;
      }
    }

    defaultLevel1.Level2 = defaultLevel1.Level2.filter((l2: any) =>
      this.defaultBrandList.includes(l2.Level2_value),
    );

    const brandsObj = this.selectedObjects?.find((obj: any) =>
      obj.hasOwnProperty('Brands'),
    );
    if (brandsObj?.Brands) {
      brandsObj.Brands = brandsObj.Brands.filter((b: any) => {
        if (b?.Level1 !== 'Default') {
          return true;
        }
        const label = b?.Level2 || b?.variable_label;
        return this.defaultBrandList.includes(label);
      });
    }
  }

  @Output() BindImageURL = new EventEmitter<any>();
  @Input() ImageURL: string = '';
  @Input() landingdata: any;
  @Input() ReceivedVarData: any;
  @Input() selected_study: string = '';
  @Input() selected_client: string = '';
  @Input() isSavedScenarioSelected: boolean = false;
  dimensionList: string[] = [];
  @Input() isbackButton: boolean = false;
  @Input() isChangeEntryPoint: boolean = false;
  @Input() isCreateCustomGroup: boolean = false;
  @Input() isCustomGroupClick: boolean = false;
  @Input() isBrandAnalysis: boolean = false;
  @Input() selectedScenarioData: any;
  @Input() output_data: any;

  custom_calculation: string[] = [];
  custom_group: string[] = [];
  custom_report: string[] = [];
  export_download: string[] = [];
  metricOption: string[] = [];
  isStudyPanel = false;
  sidePanelblock: boolean = false;
  entryFlag: boolean = false;
  isEntry_Point = false;
  isVariableTab = false;
  isEntry_Tab = true;
  left_panel_collapse: boolean = false;
  is_variable_expand: boolean = false;
  is_load_btn: boolean = true;
  isSingleEntryPointAutoLoaded: boolean = false;
  isEntryPointHiddenBySingleOption: boolean = false;
  isAudienceEntryPointHiddenBySingleOption: boolean = false;
  private autoLoadedEntryPointSnapshot: {
    dataArray: any[];
    variableListEpForOutput: any[];
    selectedEP1: string;
    selectedEP2: string;
    selectedEP3: string;
  } | null = null;
  isPanelLoaded: boolean = false;
  isSavedSelection: boolean = false;

  selectedEP1 = '';
  selectedEP2 = '';
  selectedEP3 = '';

  /* @Output() isBtnVisible = new EventEmitter<string>();*/
  @Output() selectedVariableLevel1 = new EventEmitter<any>();
  @Output() selectedVariableLevel0 = new EventEmitter<string>();
  @Output() entryListChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() dataListChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() selectedConfig = new EventEmitter<any>();
  @Output() LeftPanelClick = new EventEmitter<any>();
  @Output() btnVisible = new EventEmitter<any>();
  @Output() dimensionListChange: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  @Output() cancelEntryPointChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() snapNameNavHeader = new EventEmitter<any>();
  @Output() additionalList = new EventEmitter<any>();
  variable_expand: string = '';
  variable_expandLev1: string = '';
  variable_expandLev2: string = '';
  variable_expandLev3: string = '';
  variable_expandLev4: string = '';
  variable_expandLev5: string = '';
  variable_expandLev6: string = '';
  variable_expandLev7: string = '';
  variable_expandLev8: string = '';
  variable_expandLev9: string = '';

  entry_items_expand: string = '';
  entry_items_expand_lvl: boolean = false;
  entry_nested_items_expand: string = '';
  entry_nested_items_expand1: string = '';
  entry_nested_items_expand2: string = '';
  entry_nested_items_expand3: string = '';
  entry_nested_items_expand4: string = '';
  entry_nested_items_expand5: string = '';
  entry_nested_items_expand6: string = '';
  entry_nested_items_expand7: string = '';
  entry_nested_items_expand8: string = '';
  entry_nested_items_expand9: string = '';
  entry_nested_items_expandParent1: string = '';
  entry_nested_items_expandParent2: string = '';
  entry_nested_items_expandParent3: string = '';
  entry_nested_items_expandParent4: string = '';
  entry_nested_items_expandParent5: string = '';
  entry_nested_items_expandParent6: string = '';
  entry_nested_items_expandParent7: string = '';
  entry_nested_items_expandParent8: string = '';
  entry_nested_items_expandParent9: string = '';
  studyname: string = '';
  isLoadSubmitted: boolean = false;
  @Output() valueChange = new EventEmitter<boolean>();
  @Output() sendHelpGuide: EventEmitter<boolean> = new EventEmitter<boolean>();
  isSelectAll: boolean = false;
  isconfigCustomGrpPresent: boolean = false;
  selectAllCheck: number = 0;

  // ---- O(1) cache for toggleStatus / toggleStatusRadio ---------------------
  // Rebuilt whenever dataArray or EPdataFor_Multiple changes.
  // Without this, every CD cycle calls find+some+some for every row in the
  // entry-panel *ngFor, which is O(N×M×K) per item and accumulates badly.
  private _toggleStatusCache = new Map<string, boolean>();
  private _varCodeToEntryKeyCache = new Map<string, string>();
  // Cache for the .variableHeader element's top position (used for Level-0
  // expand positioning). The header never moves during a session, so we only
  // compute this once and reuse it on every subsequent Level-0 expand click.
  private _topLev1Cache: string | null = null;
  // Same cache for the .variables-sub-itemsLev1 panel (Level-1 expand positioning).
  private _topCache: string | null = null;
  // Track the last element that had 'selectedTextClick' so we can remove it
  // directly without a querySelectorAll on every expand click.
  private _lastSelectedTextClickEl: Element | null = null;
  // Cached reference to the submit button DOM element — avoids
  // document.getElementById on every checkbox click.
  private _submitButtonEl: HTMLElement | null = null;
  private _refreshFrameId: number | null = null;
  private _isDestroyed = false;

  private _rebuildToggleStatusCache(): void {
    this.enforceProductCategoryAudienceDependency();
    this._varCodeToEntryKeyCache.clear();
    this._toggleStatusCache.clear();
    for (const a of this.EPdataFor_Multiple || []) {
      const entryKey = ((a.variable_label ?? '') as string).replaceAll(' ', '');
      const codes = a.variable_code;
      if (Array.isArray(codes)) {
        for (const c of codes) {
          this._varCodeToEntryKeyCache.set(c, entryKey);
        }
      } else if (typeof codes === 'string') {
        this._varCodeToEntryKeyCache.set(codes, entryKey);
      }
    }
    this._varCodeToEntryKeyCache.set(
      this.productCategoryVariableCode,
      'EntryPoint2',
    );
    for (const entry of this.dataArray || []) {
      for (const entryKey of Object.keys(entry)) {
        const val = entry[entryKey];
        if (!val?.Level1 || !Array.isArray(val.Level2)) continue;
        for (const l2 of val.Level2) {
          if (!Array.isArray(l2.MetricOptions)) continue;
          for (const mo of l2.MetricOptions) {
            this._toggleStatusCache.set(
              `${entryKey}|${val.Level1}|${mo.Name}`,
              true,
            );
          }
        }
      }
    }
  }

  get isAudienceEntryPointSelected(): boolean {
    for (const entry of this.dataArray || []) {
      const entryPoint1 = entry['EntryPoint1'];
      if (!entryPoint1?.Level2?.length) {
        continue;
      }
      for (const level2 of entryPoint1.Level2) {
        if (level2.MetricOptions?.some((mo: any) => !!mo?.Name)) {
          return true;
        }
      }
    }
    return false;
  }

  get isProductCategoryEnabled(): boolean {
    return this.isAudienceEntryPointSelected;
  }

  private collapseProductCategoryPanel(): void {
    this.productCategory_items_expand = '';
    this.productCategorySidePanelblock = false;
    this.productCategory_nested_items_expand = '';
    this.productCategoryPanel_Lvl3 = [];
    this.isProductCategoryLoading = false;
  }

  private clearProductCategorySelection(): void {
    for (const entry of this.dataArray || []) {
      if (
        entry.hasOwnProperty('EntryPoint2') &&
        entry.EntryPoint2?.variableCode === this.productCategoryVariableCode
      ) {
        delete entry.EntryPoint2;
      }
    }
    this.selectedEP2 = '';
  }

  private resetProductCategorySelectionForAutoAudienceReset(): void {
    this.clearProductCategorySelection();
    this.collapseProductCategoryPanel();
    this.entry_nested_items_expand2 = '';
  }

  private enforceProductCategoryAudienceDependency(): void {
    if (!this.isProductCategorySection) {
      return;
    }
    if (!this.isProductCategoryEnabled) {
      this.clearProductCategorySelection();
      this.collapseProductCategoryPanel();
      this.productCategoryData = [];
    } else {
      this.pruneProductCategorySelections();
    }
  }

  getSelectedAudienceResponseLabels(): string[] {
    const labels = new Set<string>();
    for (const entry of this.dataArray || []) {
      const entryPoint1 = entry['EntryPoint1'];
      if (!entryPoint1?.Level2?.length) {
        continue;
      }
      for (const level2 of entryPoint1.Level2) {
        for (const mo of level2.MetricOptions || []) {
          if (mo?.Name) {
            labels.add(mo.Name);
          }
        }
      }
    }
    return this.expandFasTotalNames(Array.from(labels));
  }

  getSelectedProductLabelsFromUI(): string[] {
    const labels = new Set<string>();
    for (const entry of this.dataArray || []) {
      const entryPoint2 = entry['EntryPoint2'];
      if (
        !entryPoint2?.Level2?.length ||
        entryPoint2.variableCode !== this.productCategoryVariableCode
      ) {
        continue;
      }
      for (const level2 of entryPoint2.Level2) {
        for (const mo of level2.MetricOptions || []) {
          if (mo?.Name?.trim()) {
            labels.add(mo.Name.trim());
          }
        }
      }
    }
    return Array.from(labels);
  }

  getSelectedProductNameForSubmit(): string {
    return this.getSelectedProductLabelsFromUI().join(', ');
  }

  private getProductCategorySummaryParts(): { html: string; title: string } {
    const productLabels = this.getSelectedProductLabelsFromUI();
    const summaryLabel = this.productCategoryLabel;
    if (
      !this.isProductCategorySection ||
      !summaryLabel ||
      productLabels.length === 0
    ) {
      return { html: '', title: '' };
    }

    const value = productLabels.join(', ');
    return {
      html:
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">${summaryLabel}:</span> ${value}`,
      title: ` || ${summaryLabel}: ${value}`,
    };
  }

  getSelectedProductCategorySelections(): {
    Name: string;
    responseCode: string;
  }[] {
    return this.getSelectedProductLabelsFromUI().map((name) => ({
      Name: name,
      responseCode: '',
    }));
  }

  private findProductCategoryFomItem(selectedLabel: string): any | undefined {
    return this.productCategoryData.find(
      (item: any) => this.getProductResponseLabel(item) === selectedLabel,
    );
  }

  private getCurrentSectionName(): string {
    return (
      this.sectionselected ||
      this.selectedSection ||
      this._configService.selectedSection ||
      ''
    );
  }

  private buildSnapshotLoadPayload(sourceData: any[]): any[] {
    const payload = _.cloneDeep(sourceData || []);
    const section = this.getCurrentSectionName();
    const selectedProductLabels = this.getSelectedProductLabelsFromUI();

    if (payload.length === 0) {
      payload.push({
        clientName: this.clientDetails.clientDetails.client_code.toString(),
        studyName: this.selected_study,
        mandatory_variable_mapping: [],
        dimension: [],
        isMandatoryLoadClicked:
          this.selectedcompareacrossOption == 'Multiple Markets' ||
          this.selectedcompareacrossOption == 'Multiple Categories',
        snapshotType: this.selectedcompareacrossOption,
      });
    }

    for (const entry of payload) {
      entry.section = section;
      if (selectedProductLabels.length > 0) {
        entry.selectedProductLabels = selectedProductLabels;
        entry.productSelections = selectedProductLabels.map((name) => ({
          name,
        }));
      }

      if (
        entry?.EntryPoint2?.variableCode === this.productCategoryVariableCode
      ) {
        delete entry.EntryPoint2;
      }
    }

    return this.expandFasTotalInEntryPointData(payload);
  }

  private isFilterFlagEnabled(value: any): boolean {
    return value === 1 || value === '1';
  }

  private isExcludedLevel0ForSnapshotFilter(level0: any): boolean {
    const normalizedLevel0 = `${level0 ?? ''}`.replace(/\s+/g, '').toLowerCase();
    return (
      normalizedLevel0 === 'brands' ||
      normalizedLevel0 === 'timeperiod' ||
      normalizedLevel0 === 'alfabeta'
    );
  }

  private isBrandTrackerStudy(): boolean {
    const selectedStudy = (
      this.selected_study || this.clientDetails?.clientDetails?.selectedStudy || ''
    )
      .toString()
      .trim()
      .toLowerCase();

    return selectedStudy === 'brand tracker';
  }

  private isPlanParticipantsSnapshot(): boolean {
    return (this.snapshotName || '')
      .toString()
      .toUpperCase()
      .includes('PLAN PARTICIPANT');
  }

  private isPlanParticipantsAudienceLabel(label: string): boolean {
    const normalized = (label || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
    return (
      normalized === 'plan participants' ||
      normalized === 'plan participant' ||
      normalized.includes('plan participant')
    );
  }

  /**
   * Plan Participants snapshot: Audience EP shows only "Plan Participants"
   * so the existing single-option auto-select/load/reset path can run.
   */
  private restrictAudienceOptionsForPlanParticipantsSnapshot(
    options: typeof this.entryPanel_Lvl3,
  ): typeof this.entryPanel_Lvl3 {
    if (!this.isPlanParticipantsSnapshot() || !Array.isArray(options)) {
      return options;
    }

    const isAudienceLevel = (level1: string) =>
      (level1 || '').trim().toLowerCase() === 'audience';

    if (!options.some((o) => isAudienceLevel(o.Level1))) {
      return options;
    }

    return options.filter(
      (o) =>
        !isAudienceLevel(o.Level1) ||
        this.isPlanParticipantsAudienceLabel(o.MetricOptions),
    );
  }

  private isProductTrackerStudy(): boolean {
    const selectedStudy = (
      this.selected_study || this.clientDetails?.clientDetails?.selectedStudy || ''
    )
      .toString()
      .trim()
      .toLowerCase();

    return selectedStudy.startsWith('product');
  }

  private applySnapshotSpecificLeftPanelFilter(rows: any[]): any[] {
    const sourceRows = Array.isArray(rows) ? rows : [];

    const isBrandTracker = this.isBrandTrackerStudy();
    const isProductTracker = this.isProductTrackerStudy();

    if (!isBrandTracker && !isProductTracker) {
      return sourceRows;
    }

    const isMultipleBrandsSnapshot =
      isBrandTracker &&
      (this.selectedcompareacrossOption || '').toLowerCase() ===
        'multiple brands';
    const snapshotNameUpper = (this.snapshotName || '').toString().toUpperCase();
    const isFasSnapshot = isBrandTracker && snapshotNameUpper.startsWith('FAS');
    const isPersonalWealthSnapshot =
      isBrandTracker && snapshotNameUpper.includes('PERSONAL WEALTH');
    const isWorkplaceSnapshot =
      isBrandTracker && snapshotNameUpper.includes('WORKPLACE');
    const isPlanParticipantsSnapshot =
      isBrandTracker && this.isPlanParticipantsSnapshot();

    const getPlanParticipantColumnKey = (item: any): string | undefined => {
      if (!item || typeof item !== 'object') {
        return undefined;
      }

      return Object.keys(item).find((key: string) => {
        const normalizedKey = key.replace(/[^a-z0-9]/gi, '').toLowerCase();
        return (
          normalizedKey === 'planparticipant' ||
          normalizedKey === 'planpartcipant'
        );
      });
    };

    const hasMultipleBrandsColumn =
      isMultipleBrandsSnapshot &&
      sourceRows.some((item: any) =>
        Object.prototype.hasOwnProperty.call(item, 'Multiple_Brands'),
      );
    const hasFasColumn =
      isFasSnapshot &&
      sourceRows.some((item: any) =>
        Object.prototype.hasOwnProperty.call(item, 'FAS'),
      );
    const hasPersonalWealthColumn =
      isPersonalWealthSnapshot &&
      sourceRows.some((item: any) =>
        Object.prototype.hasOwnProperty.call(item, 'PersonalWealth'),
      );
    const hasWorkplaceColumn =
      isWorkplaceSnapshot &&
      sourceRows.some((item: any) =>
        Object.prototype.hasOwnProperty.call(item, 'Workplace'),
      );
    const hasPlanParticipantsColumn =
      isPlanParticipantsSnapshot &&
      sourceRows.some((item: any) => !!getPlanParticipantColumnKey(item));
    const hasMultipleProductColumn =
      isProductTracker &&
      sourceRows.some((item: any) =>
        Object.prototype.hasOwnProperty.call(item, 'Multiple_Product'),
      );

    if (
      !hasMultipleBrandsColumn &&
      !hasFasColumn &&
      !hasPersonalWealthColumn &&
      !hasWorkplaceColumn &&
      !hasPlanParticipantsColumn &&
      !hasMultipleProductColumn
    ) {
      return sourceRows;
    }

    return sourceRows.filter((item: any) => {
      if (this.isExcludedLevel0ForSnapshotFilter(item?.Level0)) {
        return true;
      }

      if (
        hasMultipleBrandsColumn &&
        Object.prototype.hasOwnProperty.call(item, 'Multiple_Brands') &&
        !this.isFilterFlagEnabled(item?.Multiple_Brands)
      ) {
        return false;
      }

      if (
        hasFasColumn &&
        Object.prototype.hasOwnProperty.call(item, 'FAS') &&
        !this.isFilterFlagEnabled(item?.FAS)
      ) {
        return false;
      }

      if (
        hasPersonalWealthColumn &&
        Object.prototype.hasOwnProperty.call(item, 'PersonalWealth') &&
        !this.isFilterFlagEnabled(item?.PersonalWealth)
      ) {
        return false;
      }

      if (
        hasWorkplaceColumn &&
        Object.prototype.hasOwnProperty.call(item, 'Workplace') &&
        !this.isFilterFlagEnabled(item?.Workplace)
      ) {
        return false;
      }

      if (hasPlanParticipantsColumn) {
        const planParticipantKey = getPlanParticipantColumnKey(item);
        if (
          planParticipantKey &&
          !this.isFilterFlagEnabled(item?.[planParticipantKey])
        ) {
          return false;
        }
      }

      if (
        hasMultipleProductColumn &&
        Object.prototype.hasOwnProperty.call(item, 'Multiple_Product') &&
        !this.isFilterFlagEnabled(item?.Multiple_Product)
      ) {
        return false;
      }

      return true;
    });
  }

  private pruneProductCategorySelections(): void {
    const validOptions = new Set(
      this.productCategoryPanel_Lvl3.map((item) => item.MetricOptions),
    );
    if (validOptions.size === 0) {
      return;
    }

    for (const entry of this.dataArray || []) {
      if (
        !entry.hasOwnProperty('EntryPoint2') ||
        entry.EntryPoint2?.variableCode !== this.productCategoryVariableCode
      ) {
        continue;
      }

      for (const level2 of entry.EntryPoint2.Level2 || []) {
        level2.MetricOptions = (level2.MetricOptions || []).filter((mo: any) =>
          validOptions.has(mo.Name),
        );
      }

      entry.EntryPoint2.Level2 = (entry.EntryPoint2.Level2 || []).filter(
        (l2: any) => l2.MetricOptions?.length > 0,
      );

      if (entry.EntryPoint2.Level2.length === 0) {
        delete entry.EntryPoint2;
      }
    }
  }

  private maybeRefreshProductCategoryForAudience(): void {
    if (
      this.productCategory_items_expand === this.productCategoryLabel &&
      this.isProductCategoryEnabled &&
      !this.isProductCategoryLoading
    ) {
      this.isProductCategoryLoading = true;
      this.productCategorySidePanelblock = false;
      this.loadProductCategoryData(() => {
        this.isProductCategoryLoading = false;
        this.refreshProductCategoryLvl3IfExpanded();
        this.cdr.detectChanges();
      });
    }
  }
  get productCategoryLabel(): string {
    switch (this.selectedSection) {
      case 'PRODUCT CATEGORY HEALTH':
      case 'PRIORITY PRODUCT PERCEPTIONS':
        return 'Product Category';

      case 'PERSONAL WEALTH: ACCOUNTS':
        return 'Account Types';

      case 'ASSET CLASS AND INVESTMENT STRATEGY':
        return 'Broad Market Categories';

      default:
        return ''; // intentionally no fallback assumption
    }
  }

  /** Level0 values already chosen before Load — hide them from Filters after load. */
  private getPreLoadFilterLevel0Exclusions(): string[] {
    if (!this.isProductCategorySection) {
      return [];
    }

    const section = (
      this.sectionselected ||
      this.selectedSection ||
      this._configService.selectedSection ||
      ''
    ).toUpperCase();

    switch (section) {
      case 'PRODUCT CATEGORY HEALTH':
      case 'PRIORITY PRODUCT PERCEPTIONS':
        return ['Products'];
      case 'PERSONAL WEALTH: ACCOUNTS':
        return ['Account Types'];
      case 'ASSET CLASS AND INVESTMENT STRATEGY':
        return ['Broad Market Categories'];
      default:
        return [];
    }
  }

  private shouldExcludePreLoadFilterFromFilters(level0: string): boolean {
    const normalizedLevel0 = level0?.trim().toLowerCase();
    if (!normalizedLevel0) {
      return false;
    }

    return this.getPreLoadFilterLevel0Exclusions().some(
      (excluded) => excluded.toLowerCase() === normalizedLevel0,
    );
  }

  private removePreLoadFiltersFromLevel0Filters(): void {
    if (!this.isProductCategorySection || this.level0Filters.length === 0) {
      return;
    }

    this.level0Filters = this.level0Filters.filter(
      (level0) => !this.shouldExcludePreLoadFilterFromFilters(level0),
    );
  }

  // --------------------------------------------------------------------------
  entryPanel: {
    Level1: string;
  }[] = [];

  @Input() dataArray: any[] = [];
  entryPanel_Lvl2: {
    Level1: string;
    Level2: string;
  }[] = [];

  entryPanel_Lvl3: {
    Level: number;
    Level1: string;
    Level2: string;
    MetricOptions: string;
    responseCode: string;
    isActive: boolean;
    variableCode: string;
    e1_variable_code: string;
    e2_variable_code: string;
    e3_variable_code: string;
    mandatory_variable_mapping: any[];
    dimension: any[];
  }[] = [];

  productCategoryData: any[] = [];
  productCategoryPanel: {
    Level1: string;
  }[] = [];
  productCategoryPanel_Lvl2: {
    Level1: string;
    Level2: string;
  }[] = [];
  productCategoryPanel_Lvl3: {
    Level: number;
    Level1: string;
    Level2: string;
    MetricOptions: string;
    responseCode: string;
    isActive: boolean;
    variableCode: string;
    e1_variable_code: string;
    e2_variable_code: string;
    e3_variable_code: string;
    mandatory_variable_mapping: any[];
    dimension: any[];
  }[] = [];
  productCategory_items_expand = '';
  productCategory_nested_items_expand = '';
  productCategorySidePanelblock = false;
  isProductCategoryLoading = false;
  searchProductCategoryLevel2 = '';
  searchProductCategoryMetricOption = '';
  readonly productCategoryVariableCode = 'PRODUCT_CATEGORY';
  private readonly productCategorySections = [
    'PRODUCT CATEGORY HEALTH',
    'PRIORITY PRODUCT PERCEPTIONS',
    'PERSONAL WEALTH: ACCOUNTS',
    'ASSET CLASS AND INVESTMENT STRATEGY'
  ];

  entryList: {
    Level1: string;
    variableCode: string;

    mandatory_variable_mapping: any[];
    dimension: any[];
    NestedEntryArray: {
      Level2: any[];
      MetricOptions: {
        Name: string;
        responseCode: string;
        isActive: boolean;
        e1_variable_code: string;
        e2_variable_code: string;
        e3_variable_code: string;
      }[];
    }[];
    entryDetails: string;
  }[] = [];

  private selectedItem: HTMLElement | null = null;

  searchText: string = '';
  filteredStudies: string[] = [];
  filteredEntryStudies: {
    study_name: string;
    entry_name: string;
    values: any[];
  }[] = [];
  entryArray: string[] = [];
  filterdEntryList: any[] = [];

  NestedEntryPoints = false;
  searchTextLevel2: string = '';
  searchMetricOption: string = '';
  selectedMarketItems: string[] = [];
  searchVariable: string = '';
  searchVariable2: string = '';
  searchVariable3: string = '';
  searchVariable4: string = '';
  searchVariable5: string = '';
  searchVariable6: string = '';
  searchVariable7: string = '';
  searchVariable8: string = '';
  searchVariable9: string = '';
  searchVariable10: string = '';
  isBrowserRefresh: boolean = false;

  searchVariableFil: string = '';
  searchVariable2Fil: string = '';
  searchVariable3Fil: string = '';
  searchVariable4Fil: string = '';
  searchVariable5Fil: string = '';
  searchVariable6Fil: string = '';
  searchVariable7Fil: string = '';
  searchVariable8Fil: string = '';
  searchVariable9Fil: string = '';
  searchVariable10Fil: string = '';

  showCancelBtn: boolean = false;
  // variableTabData: string[] = [];
  variableTabData: any = [];

  e1_forMultiple: string = '';
  e2_forMultiple: string = '';
  e3_forMultiple: string = '';
  mandatory_variable_mapping_Multiple: any[] = [];
  dimension_Multiple: any[] = [];
  dataArray_Multiple: any[] = [];
  EPdataFor_Multiple: any;
  isMultiMarketOrCateg: boolean = false;
  isAudienceSnapshot: boolean = false;
  variableListMultiMarketAndCateg: {
    Level0: string;
    isEntryPoint: boolean;
    hasNextLevel: boolean;
    is_selected: boolean;
    Level1: {
      Level1_value: string;
      is_derived: string;
      is_brand_analysis: number;
      calc_type: string;
      tooltip: string;
      hasNextLevel: boolean;
      data_variable_code: string;
      response_code: string;
      derived_metric_calculation: string;
      sort_id: string;
      is_multi_punch: string;
      date: string;
      year_code: string;
      is_dimension: string;
      isCustomGrpPresent: string;
      kibanaFilterScript: string;
      customGroupId: string;
      dataYearCode: string;
      is_time_Period_Present: string;
      is_selected: boolean;
      Level2: any;
    }[];
  }[] = [];

  EntryPointHeader = 'ENTRY POINT';
  defaultBrandList: any;
  defaultProductListMapping: any;
  variableList: {
    Level0: string;
    isEntryPoint: boolean;
    hasNextLevel: boolean;
    is_selected: boolean;
    Level1: {
      Level1_value: string;
      is_derived: string;
      is_brand_analysis: number;
      calc_type: string;
      tooltip: string;
      hasNextLevel: boolean;
      data_variable_code: string;
      response_code: string;
      derived_metric_calculation: string;
      sort_id: string;
      is_multi_punch: string;
      date: string;
      year_code: string;
      is_dimension: string;
      isCustomGrpPresent: string;
      kibanaFilterScript: string;
      customGroupId: string;
      dataYearCode: string;
      is_time_Period_Present: string;
      is_selected: boolean;
      Level2: any;
    }[];
  }[] = [];

  totalSampleObj = {
    Level1_value: 'Total Sample',
    is_derived: '',
    is_brand_analysis: 0,
    calc_type: '',
    tooltip: 'Total Sample',
    hasNextLevel: false,
    data_variable_code: 'total_sample',
    response_code: '',
    derived_metric_calculation: '',
    sort_id: '0',
    is_multi_punch: '',
    date: '',
    year_code: '',
    is_dimension: '',
    isCustomGrpPresent: '',
    kibanaFilterScript: '',
    customGroupId: '',
    dataYearCode: '',
    is_time_Period_Present: '',
    is_selected: false,
    Level2: [],
  };

  variableListFilter: {
    LevelMinus: string;
    isEntryPoint: boolean;
    hasNextLevel: boolean;
    is_selected: boolean;
    Level1: {
      Level0: string;
      isEntryPoint: boolean;
      is_selected: boolean;
      hasNextLevel: boolean;
      Level1: {
        Level1_value: string;
        is_derived: string;
        is_brand_analysis: number;
        calc_type: string;
        tooltip: string;
        hasNextLevel: boolean;
        data_variable_code: string;
        response_code: string;
        derived_metric_calculation: string;
        sort_id: string;
        is_multi_punch: string;
        date: string;
        year_code: string;
        is_dimension: string;
        isCustomGrpPresent: string;
        kibanaFilterScript: string;
        customGroupId: string;
        dataYearCode: string;
        is_time_Period_Present: string;
        Weekno_forSigcalculation: string;
        is_selected: boolean;
        Level2: any;
      }[];
    }[];
  }[] = [];

  @Input() landingData!: any[];
  @Input() isAcrossdropDown: boolean = false;
  clientcode: string = '';
  SelectionObject: {
    Row: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    Row_Nest: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    Column: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    ColumnNest: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
  }[] = [];
  @Output() isClearEverything = new EventEmitter<boolean>();

  snapshotType_details: any[] = [];
  isSingleaudienceCohortType: boolean = false;
  audienceLimit: boolean = false;
  isAudienceTotalSample: boolean = false;
  totalSample: boolean = false;

  constructor(
    private router: Router,
    private crossTabService: CrosstabService,
    private _alertService: AlertMessageService,
    public _configService: SnapshotService,
    private clientDetails: SnapshotSharedVariablesService,
    private _loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private elRef: ElementRef,
    private _usermanagementService: UserProjectManagementService,
    private _configCustomService: CustomsnapshotService,
    private entrypointColorService: EntrypointcolorService,
  ) {
    this.landingdata = this.router.getCurrentNavigation()?.extras.state;
  }

  iscompareacrossDropdownOpen = false;
  selectedcompareacrossOption: string = '';
  clientSnapshotNames: any;
  clientSnapshotNameObject: any;
  snapshotName: any;
  datarrayformultiplemarkorcategories: any = [];
  ngOnInit() {
    let localUserdefined: any = localStorage.getItem('leftPanelFilters');
    if (
      localUserdefined != undefined &&
      localUserdefined != null &&
      localUserdefined != ''
    ) {
      localStorage.removeItem('leftPanelFilters');
    }
    const [navEntry] = performance.getEntriesByType(
      'navigation',
    ) as PerformanceNavigationTiming[];

    // this.isBrowserRefresh = navEntry?.type === 'reload';
    this.isBrowserRefresh =
      navEntry?.type === 'reload' || navEntry?.type === 'navigate';
    this._loaderService.showLoader();
    this.dimensionList = [];
    this.entryPanel = [];
    this.productCategoryPanel = [];
    this.productCategoryPanel_Lvl2 = [];
    this.productCategoryPanel_Lvl3 = [];
    this.productCategoryData = [];
    this.variableList = [];
    this.compareacross = [];
    this.variableListMultiMarketAndCateg = [];
    // this.getEntryData();
    this.crossTabService.selectedStudyName.next(this.selected_study);

    if (this.dataArray.length > 0) {
      this.datarrayformultiplemarkorcategories = this.dataArray;
    }

    let data = {
      client_code: this.clientDetails.clientDetails.client_code,
      snapshot_name: this.clientDetails.clientDetails.study,
    };

    this._configService
      .getClientStudyData(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe((c) => {
        let data = JSON.parse(c.body.Data);

        this._configService.outputSnapshotData = data;
        this.snapshotName = data.snapshot_name;
        this.snapNameNavHeader.emit(data.snapshot_name);
        this.additionalList.emit(data.additional_list);
        // if (
        //   this._configService.outputSnapshotData?.snapshotType_details?.[1]?.snapshot_type === 'Audience Snapshot'
        // ) {
        //   this.snapshotcohortType = this._configService.outputSnapshotData?.audienceCohortType;
        // }
        this.isMultiSelectEP = data.additional_list.some(
          (item: any) =>
            item.key ===
            CheckboxSelectionModel.additionalCheckBoxSelection[5].name,
        );
        this.snapshotType_details = data.snapshotType_details;
        let studyName = data.study_list[0].study_name;
        this.selected_study = studyName;
        this.selected_client = data.client_name;
        this._configService.staticText =
          data.static_text != null ? data.static_text : '';
        let compareacross: any = [];
        if (data?.saveselection) {
          this._configService.globalDefaultSelectionFlag =
            data.saveselection.find(
              (item: { key: string; value: boolean }) =>
                item.key === 'Global Default Selection',
            )?.value ?? false;
        }

        // Call the service to get the color palette
        this.entrypointColorService
          .getOrFetchEntrypointColorPalette(this.selected_client)
          .subscribe({
            next: (response: any) => {
              // this.entryPointColors = response;
              // this.crossTabService.setEntrypointColorPalette(response);
            },
            error: (err: any) => {
              console.error('Error fetching entrypoint color palette:', err); // Handle errors
            },
          });

        this._configService
          .getConfigurationByClientName(
            this.clientDetails.clientDetails.client_code,
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe((EPData) => {
            let data = JSON.parse(EPData.Data);

            let selectedStudyData = data.filter(
              (item: any) => item.configData.study == this.selected_study,
            );
            this.EPdataFor_Multiple =
              selectedStudyData[0].configData.entry_point;
            this._rebuildToggleStatusCache();
          });

        this.issavelaodcheck =
          this._configService.outputSnapshotData?.saveselection != null
            ? (this._configService.outputSnapshotData?.saveselection?.find(
                (m: any) => m.key === 'Save/Load',
              )?.value ?? false)
            : false;
        // this.snapshotType_details.forEach((type: any) => {
        //   compareacross.push({
        //     name: type.snapshot_type,
        //     value: type.snapshot_type,
        //     selected: false,
        //   });
        // });

        // this.compareacross = compareacross;

        this._configService.widgetVariable$
          .pipe(takeUntil(this.destroy$))
          .subscribe((value) => {
            compareacross = [];
            if (value != null && value.length != 0) {
              if (this._configService.snapshotProductType == 'custom') {
                value.snapshotType.forEach((type: any) => {
                  compareacross.push({
                    name: type.snapshotType_name,
                    value: type.snapshotType_name,
                    selected: false,
                    section: type.section.map((section: any) => ({
                      name: section.section_name,
                      selected: false,
                      subsection: section.subsection
                        .filter((a: any) => a.subsection_name != 'NA')
                        .map((subsection: any) => ({
                          name: subsection.subsection_name,
                          selected: false,
                        })),
                    })),
                  });
                });
              } else if (
                this._configService.snapshotProductType == 'standard'
              ) {
                value.forEach((type: any) => {
                  compareacross.push({
                    name: type.snapshotType,
                    value: type.snapshotType,
                    selected: false,
                    section: [
                      {
                        name: type.sections,
                        selected: false,
                        subsection:
                          type.subsection == 'NA'
                            ? []
                            : [
                                {
                                  name: type.subsection,
                                  selected: false,
                                },
                              ],
                      },
                    ],
                  });
                });
              }

              compareacross.forEach((c: any) => {
                c.section.sort((a: any, b: any) =>
                  a.name.localeCompare(b.name),
                );
                c.section.forEach((s: any) => {
                  s.subsection.sort((a: any, b: any) =>
                    a.name.localeCompare(b.name),
                  );
                });
              });

              compareacross.forEach((item: any) => {
                const sectionsOnly = item.section.filter(
                  (section: any) => section.subsection.length === 0,
                );
                const sectionsWithSubsections = item.section.filter(
                  (section: any) => section.subsection.length > 0,
                );

                // Sort sections alphabetically
                sectionsOnly.sort((a: any, b: any) =>
                  a.name.localeCompare(b.name),
                );
                sectionsWithSubsections.sort((a: any, b: any) =>
                  a.name.localeCompare(b.name),
                );

                // Sort subsections alphabetically
                sectionsWithSubsections.forEach((section: any) => {
                  section.subsection.sort((a: any, b: any) =>
                    a.name.localeCompare(b.name),
                  );
                });

                // Reassign sorted sections back
                item.section = [...sectionsOnly, ...sectionsWithSubsections];
              });

              this.compareacross = compareacross;
            }

            const noDataScreen = document.querySelector('.no-data-screen');
            if (compareacross.length == 0) {
              if (noDataScreen) {
                noDataScreen.classList.remove('DN');
                this.collapsePanel();
              }
            } else {
              if (noDataScreen) {
                noDataScreen.classList.add('DN');
                this.expandPanel();
              }
            }
          });

        let parameter = {
          snapshot_name: this.clientDetails.clientDetails.study,
          client_name: this.clientDetails.clientDetails.client_code,
          client_code: this.clientDetails.clientDetails.client_code,
        };

        let parameter1 = {
          study: studyName,
          client_name: this.clientDetails.clientDetails.client_code,
          client_code: this.clientDetails.clientDetails.client_code,
          isBrandAnalysis: true,
        };

        forkJoin({
          generalConfig: this._configService.getGeneralConfigData(parameter1),
          entryPointData:
            this._configService.getSnapshotEntryPointData(parameter),
        })
          .pipe(takeUntil(this.destroy$))
          .subscribe(({ generalConfig, entryPointData: data }) => {
            // --- process generalConfig ---
            if (generalConfig.Data != '') {
              let lsORisData = JSON.parse(generalConfig.Data);
              this.mandatoryVariableMapping =
                lsORisData?.configData?.mandatory_variable_mapping;
              this.ImageURL = lsORisData.logoFile.url;
              this.BindImageURL.emit({
                Image: this.ImageURL,
              });
              this._configService.LBthreshold = Number(
                lsORisData.configData.low_base_identifier.find(
                  (item: any) => item.key === 'Low Base',
                )?.data_value,
              );
              this._configService.ISthreshold = Number(
                lsORisData.configData.low_base_identifier.find(
                  (item: any) => item.key === 'Insufficient Base',
                )?.data_value,
              );
              this._configService.weights = lsORisData.configData.weight.filter(
                (m: any) => m.is_selected == true,
              );
              if (
                lsORisData.configData.threshold_identifier[0].data_value !=
                  undefined ||
                lsORisData.configData.threshold_identifier[0].data_value != null
              ) {
                this._configService.thresholdIndex = Number(
                  lsORisData.configData.threshold_identifier[0].data_value,
                );
              }
            }
            // --- process entryPointData (was getSnapshotEntryPointData subscribe) ---
            {
              this.entryPointsData = JSON.parse(data.Data);

              // if (this.entryPointsData.length > 0) {
              //   this.ImageURL = this.entryPointsData[0].url_logo;
              //   this.BindImageURL.emit({
              //     Image: this.ImageURL,
              //   });
              // }

              this.snapshotData = this.entryPointsData.filter(
                (x: any) => x.study === studyName,
              )[0];
              this.snapshotDataConfig = this.snapshotData.snap_config;
              //this.selectedWeight=this.snapshotData.
              this.aggregatedVariables = this.snapshotData.aggregatedvariables;
              var x = [];
              for (let i = 0; i < this.snapshotData.dataformat.length; i++) {
                if (this.snapshotData.dataformat[i].value == true) {
                  x.push(this.snapshotData.dataformat[i].key);
                }
              }

              for (let j = 0; j < x.length; j++) {
                if (x[j] == 'Respondent Level') this.isRespondentLevel = true;
                else if (x[j] == 'Semi-Aggregated')
                  this.isSemiAggregatedData = true;
                else if (x[j] == 'Aggregated') this.isAggregatedData = true;
              }

              // ;

              this.BindEntryData(
                this.entryPointsData,
                this.selected_study,
                this.clientDetails.clientDetails.client_code,
                true,
              );

              this.buildProductCategoryPanel();

              // to remove custom variables if semi aggregated or aggregated
              if (this.isAggregatedData || this.isSemiAggregatedData) {
                this.additionalFeaturesList =
                  this.additionalFeaturesList.filter(
                    (item: any) => item.name !== 'Custom Variable',
                  );
              }

              //check if default selections are made in load selection
              if (
                !this.isAcrossdropDown ||
                (this._configService.tiggerSelectionSnapshotType &&
                  !this._configService.isGlobalDefaultSelectionEnabled)
              ) {
                this.LoadSelection(true);
              }
              this.selectedSnapshotType = 'Single Brand';
              let option = {
                name: 'Single Brand',
                value: 'Single Brand',
                selected: true,
                section: [
                  { name: '05pie chart', selected: true, subsection: [] },
                  { name: '13 Jan ', selected: false, subsection: [] },
                  { name: 'bips-comparision', selected: false, subsection: [] },
                  { name: 'D', selected: false, subsection: [] },
                  { name: 'fill chart', selected: false, subsection: [] },
                  { name: 'HART1', selected: false, subsection: [] },
                  { name: 'lollipop_ssr', selected: false, subsection: [] },
                  { name: 'Rader_Chart', selected: false, subsection: [] },
                  { name: 'task_74068', selected: false, subsection: [] },
                  {
                    name: 'Lollipop Chart Check',
                    selected: false,
                    subsection: [{ name: 'Bug 1', selected: false }],
                  },
                ],
              };
              if (
                this._configService.snapshotSelectedName === '' ||
                (this._configService.snapshotSelectedName === undefined &&
                  this._configService.selectedSection === '') ||
                (this._configService.selectedSection === undefined &&
                  this._configService.selectedSubSection === '') ||
                this._configService.selectedSubSection === undefined
              ) {
                this._configService.snapshotSelectedName =
                  localStorage.getItem('snapshotselected_landing') || '';
                this._configService.selectedSection =
                  localStorage.getItem('sectionselected_landing') || '';
                this._configService.selectedSubSection =
                  localStorage.getItem('subsectionselected_landing') || '';
              }

              option = this.compareacross.find(
                (option: any) =>
                  option.name == this._configService.snapshotSelectedName,
              );
              this.selectcompareacrossOption(
                this._configService.snapshotSelectedName,
                option,
                this._configService.selectedSection,
                this._configService.selectedSubSection,
              );
              if (
                !this._configService.isGlobalDefaultSelectionEnabled &&
                !this.isSavedScenarioSelected &&
                !this.isSingleEntryPointAutoLoaded
              ) {
                this._loaderService.hideLoader();
              }
            } // end entryPointData block
          });

        this._configService.loadSelec$
          .pipe(
            takeUntil(this.destroy$),
            // Use switchMap to avoid nested subscription leak — each new
            // loadSelec$ emission disposes the previous hasLoadSelec$ subscription.
          )
          .subscribe((a: any) => {});
        // Flat subscription: listen once, filter by truthy value.
        this._configService.hasLoadSelec$
          .pipe(takeUntil(this.destroy$))
          .subscribe((result: any) => {
            if (result) {
              this.collapsePanel();
            }
          });
      });
  }

  @Input() moduleLists: any;
  sectionSelected: string = '';
  ngOnChanges(changes: SimpleChanges): void {
    //To get section data
    if (changes['sectionselected']?.currentValue) {
      this.selectedSection = changes['sectionselected'].currentValue;
      if (this.isProductCategorySection) {
        if (this.productCategoryData.length > 0) {
          this.buildProductCategoryPanel();
        }
      } else {
        this.resetProductCategoryPanel();
      }
    }
    if (changes['moduleLists']) {
      let moduleList = changes['moduleLists'].currentValue;
      for (let i = 0; i < moduleList.length; i++) {
        if (moduleList[i].isSelected == true) {
          this.sectionSelected = moduleList[i].name;
        }
      }
    }
    if (
      changes['isGlobalDefaultSelectionEnabled']?.currentValue &&
      this._configService.isGlobalDefaultSelectionEnabled &&
      this._configService.globalDefaultSelectionFlag &&
      !this.isPanelLoaded &&
      !this.isSavedScenarioSelected &&
      this._configService.tiggerSelectionSnapshotType
    ) {
      this.isPanelLoaded = true;
      let option = {
        name: 'Single Brand',
        value: 'Single Brand',
        selected: true,
        section: [
          { name: '05pie chart', selected: true, subsection: [] },
          { name: '13 Jan ', selected: false, subsection: [] },
          { name: 'bips-comparision', selected: false, subsection: [] },
          { name: 'D', selected: false, subsection: [] },
          { name: 'fill chart', selected: false, subsection: [] },
          { name: 'HART1', selected: false, subsection: [] },
          { name: 'lollipop_ssr', selected: false, subsection: [] },
          { name: 'Rader_Chart', selected: false, subsection: [] },
          { name: 'task_74068', selected: false, subsection: [] },
          {
            name: 'Lollipop Chart Check',
            selected: false,
            subsection: [{ name: 'Bug 1', selected: false }],
          },
        ],
      };
      if (
        this._configService.snapshotSelectedName === '' ||
        (this._configService.snapshotSelectedName === undefined &&
          this._configService.selectedSection === '') ||
        (this._configService.selectedSection === undefined &&
          this._configService.selectedSubSection === '') ||
        this._configService.selectedSubSection === undefined
      ) {
        this._configService.snapshotSelectedName =
          localStorage.getItem('snapshotselected_landing') || '';
        this._configService.selectedSection =
          localStorage.getItem('sectionselected_landing') || '';
        this._configService.selectedSubSection =
          localStorage.getItem('subsectionselected_landing') || '';
      }
      let entryPointsData = this.entryPointsData.filter(
        (a: any) =>
          a.study === this.selected_study &&
          a.MetricOption !== '' &&
          a.Level1 != null &&
          !a.Level1.toLowerCase().includes('market'),
      );
      if (
        this._configService.snapshotSelectedName !== 'Multiple Markets' ||
        (entryPointsData && entryPointsData.length > 0)
      ) {
        option = this.compareacross.find(
          (option: any) =>
            option.name == this._configService.snapshotSelectedName,
        );
        this.selectcompareacrossOption(
          this._configService.snapshotSelectedName,
          option,
          this._configService.selectedSection,
          this._configService.selectedSubSection,
        );
      }
    }
    //whenever load is clicked for particular saved scenario to bind leftpanel data this is called
    // This method will be called whenever there is a change in the @Input properties
    this.showCancelBtn = false;
    if (changes['dataArray']) {
      // Rebuild the O(1) toggle-status cache whenever the dataArray input changes.
      this._rebuildToggleStatusCache();
    }
    if (
      changes['dataArray'] &&
      this.isSavedScenarioSelected &&
      (!this.isPanelLoaded || this.hasSelectionNameChanged(changes))
    ) {
      this.isPanelLoaded = true;
      this.updateLeftPanel();
    } else if (changes['isbackButton'] && this.isbackButton) {
      //this.getVariableData();
    } else if (changes['isChangeEntryPoint'] && this.isChangeEntryPoint) {
      this.isVariableTab = false;
      this.is_load_btn = true;
      this.isEntry_Tab = true;
      this.showCancelBtn = true;
    }
    // else if (changes['isCustomGroupClick'] && this.isCustomGroupClick && this.variableList.length > 0) {
    //   let customObject = this.variableList;
    //   //let listToUpdate = this.customGroupSelectionsObj;

    //   let listToUpdate = customObject.filter(
    //     (a) => a.isEntryPoint != true && a.Level0 != 'Time Period' && a.Level0 != 'Custom Group'
    //   );
    //   this.variableList = listToUpdate;
    // }
    else if (
      changes['isCreateCustomGroup'] &&
      this.isCreateCustomGroup &&
      this.variableList.length > 0
    ) {
      let customObject = this.variableList;
      //let listToUpdate = this.customGroupSelectionsObj;

      let listToUpdate = customObject.filter(
        (a) =>
          a.isEntryPoint != true &&
          a.Level0 != 'Time Period' &&
          a.Level0 != 'Custom Group',
      );
      this.variableList = listToUpdate;
    }

    // else if (changes['isCustomGroupClick'] && this.isCustomGroupClick && this.variableTabData.length > 0) {
    //   this.BindVariableDataLeftPanel(this.variableTabData);
    //   this.crossTabService.setVariableTabData(this.variableTabData);
    // }
  }

  hasSelectionNameChanged = (changes: any): boolean => {
    const previousValue = changes['selectedScenarioData']?.previousValue;
    const currentValue = changes['selectedScenarioData']?.currentValue;

    if (!previousValue || !currentValue) return false;

    const prevNames = previousValue
      .map((item: any) => item.selection_name)
      .filter(Boolean);

    const currNames = currentValue
      .map((item: any) => item.selection_name)
      .filter(Boolean);

    return (
      !prevNames.every((name: string) => currNames.includes(name)) ||
      !currNames.every((name: string) => prevNames.includes(name))
    );
  };

  togglecompareacrossDropdown() {
    this.iscompareacrossDropdownOpen = !this.iscompareacrossDropdownOpen;

    this.sidePanelblock = false;
    this.entry_items_expand = '';
    this.variable_expand = '';
    this.variable_expandLev1 = '';
    this.variable_expandLev2 = '';
    this.variable_expandLev3 = '';
    this.variable_expandLev4 = '';
    this.variable_expandLev5 = '';
    this.variable_expandLev6 = '';
    this.variable_expandLev7 = '';
    this.variable_expandLev8 = '';
    this.variable_expandLev9 = '';
  }

  closecompareacrossDropdown() {
    this.iscompareacrossDropdownOpen = false;
  }

  @Output() selectedType = new EventEmitter();
  @Output() increaseLeftpanelHeight = new EventEmitter();
  selectedSnapshotType = '';
  selectedSection = '';
  selectedSubSection = 'NA';
  isSubSectionDropdownOpen = false;
  isSectionDropdownOpen = false;
  ShowSection(SnapshotType: string) {
    let sectionDiv = document.querySelector('.section-options');
    sectionDiv?.classList.remove('DN');
    event?.stopPropagation();

    this.selectedSnapshotType = SnapshotType;
    this._configService.selectedSnapshotType = this.selectedSnapshotType;
    this.isSubSectionDropdownOpen = false;
    this.isSectionDropdownOpen = true;
  }

  ShowSubSection(section: string) {
    let subSectionDiv = document.querySelector('.sub-section-options');
    subSectionDiv?.classList.remove('DN');
    event?.stopPropagation();

    this.selectedSection = section;
    this.isSubSectionDropdownOpen = true;
  }

  dimensionVariableList: any[] = [];
  selectcompareacrossOption(
    option: string,
    object: any,
    section: string = 'NA',
    subSection: string = 'NA',
  ) {
    this._configService.setDropdownValue('compareAcross', option);
    object.selected = true;
    this.compareacross.forEach((c: any) => {
      if (c.name !== option) {
        c.selected = false;
      } else c.selected = true;

      c.section.forEach((s: any) => {
        if (c.name == option && s.name == section) {
          s.selected = true;
          this.selectedSection = s.name;
          this._configService.selectedSection = s.name;
          if (s.subsection.length == 0) {
            this.selectedSubSection = 'NA';
          }
        } else {
          s.selected = false;
        }
        s.subsection.forEach((ss: any) => {
          if (c.name == option && s.name == section && ss.name == subSection) {
            ss.selected = true;
            this.selectedSubSection = ss.name;
          } else {
            ss.selected = false;
          }
        });
      });
    });
    this.selectedcompareacrossOption = option;
    this._configService.selectedcompareacrossOption = option;
    this.iscompareacrossDropdownOpen = false;
    this.isSubSectionDropdownOpen = false;
    this.isSectionDropdownOpen = false;
    this.selectedType.emit(option); /////

    if (
      this.selectedSnapshotType != this.prevCompareAcrossValue ||
      (this._configService.isGlobalDefaultSelectionEnabled &&
        this._configService.globalDefaultSelectionFlag)
    ) {
      this.isSingleEntryPointAutoLoaded = false;
      this.isEntryPointHiddenBySingleOption = false;
      this.isAudienceEntryPointHiddenBySingleOption = false;
      this.autoLoadedEntryPointSnapshot = null;
      this.prevCompareAcrossValue = option;
      this.prevSectionValue = section;

      this.entry_nested_items_expand = '';

      this.entry_nested_items_expand1 = '';
      this.entry_nested_items_expandParent1 = '';
      this.entry_nested_items_expand2 = '';
      this.entry_nested_items_expandParent2 = '';
      this.entry_nested_items_expand3 = '';
      this.entry_nested_items_expandParent3 = '';

      this.variableListMultiMarketAndCateg = [];
      this.variableList = [];
      this.variableListFilter = [];

      this.GetMandatorySelectionsList();

      if (this.snapshotDataConfig.snapshotType_details.length > 0) {
        let snapshotTypeEPandD =
          this.snapshotDataConfig.snapshotType_details.find(
            (x: any) => x.snapshot_type === option,
          );

        const entryTabDiv = document.querySelector('.EntryTab');
        const loadDiv = document.querySelector('.btn-load');
        const variableTab = document.querySelector('.variableTab');

        entryTabDiv?.classList.add('DN');
        loadDiv?.classList.add('DN');
        variableTab?.classList.add('DN');

        const submitreset = document.querySelector('.submit-reset-btn');
        if (!submitreset?.classList.contains('disabled'))
          submitreset?.classList.add('disabled');

        this.dataArray = [];
        let selectedEPs = snapshotTypeEPandD.entry_point.filter(
          (x: any) => x.is_selected === true,
        );

        let selectedEPsVariableCodes = selectedEPs.map(
          (x: any) => x.variable_code,
        );

        this.level0EP = [];
        this.entryPanel = [];
        this.entryPanel_Lvl2 = [];
        this.entryPanel_Lvl3 = [];
        this.resetProductCategoryPanel();
        //if(option != this.selectedSnapshotType)
        if (selectedEPs.length > 0) {
          let entryPointsData = this.entryPointsData.filter((a: any) =>
            selectedEPsVariableCodes.includes(a.VariableCode),
          );

          const Leve1 = _.uniq(
            _.map(
              _.filter(
                entryPointsData,
                (item) =>
                  item.Level1 !== null &&
                  item.Level2 !== '' &&
                  item.study == this.selected_study,
              ),
              'Level1',
            ),
          );
          let index = 0;
          let uniqueVariableCode: string[] = [];

          let isEntryPoints = false;
          for (const element of Leve1) {
            this.entryPanel.push({
              Level1: element,
            });

            this.level0EP.push(element);
            if (
              this._configService.isGlobalDefaultSelectionEnabled &&
              this._configService.globalDefaultSelectionFlag &&
              !this.isSavedScenarioSelected &&
              this._configService.tiggerSelectionSnapshotType
            ) {
              let entryPointsDataForSelection = this.entryPointsData.find(
                (a: any) =>
                  a.Level1 == element &&
                  a.study == this.selected_study &&
                  a.MetricOption != '',
              );
              const match = this.EPdataFor_Multiple?.find(
                (a: any) =>
                  a.variable_code === entryPointsDataForSelection.VariableCode,
              );
              if (
                match &&
                this.selectedcompareacrossOption !== 'Multiple Markets'
              ) {
                uniqueVariableCode.push(
                  entryPointsDataForSelection.VariableCode,
                );
                match.variable_label = `Entry Point ${index + 1}`;
              }
              if (this.isMultiSelectEP) {
                if (entryPointsDataForSelection) {
                  isEntryPoints = true;
                  this.checkBoxClick(
                    0,
                    index,
                    entryPointsDataForSelection.Header,
                    entryPointsDataForSelection.Level1,
                    entryPointsDataForSelection.Level2,
                    entryPointsDataForSelection.MetricOption,
                    entryPointsDataForSelection.VariableCode,
                    entryPointsDataForSelection.ResponseCode,
                    entryPointsDataForSelection.mandatory_variable_mapping,
                    entryPointsDataForSelection.is_SelectAll_Metrics,
                    entryPointsDataForSelection.e1_variable_code,
                    entryPointsDataForSelection.e2_variable_code,
                    entryPointsDataForSelection.e3_variable_code,
                    entryPointsDataForSelection.dimension,
                  );
                }
              } else {
                if (entryPointsDataForSelection) {
                  isEntryPoints = true;
                  this.EPRadioClick(
                    0,
                    index,
                    entryPointsDataForSelection.Header,
                    entryPointsDataForSelection.Level1,
                    entryPointsDataForSelection.Level2,
                    entryPointsDataForSelection.MetricOption,
                    entryPointsDataForSelection.VariableCode,
                    entryPointsDataForSelection.ResponseCode,
                    entryPointsDataForSelection.mandatory_variable_mapping,
                    entryPointsDataForSelection.is_SelectAll_Metrics,
                    entryPointsDataForSelection.e1_variable_code,
                    entryPointsDataForSelection.e2_variable_code,
                    entryPointsDataForSelection.e3_variable_code,
                    entryPointsDataForSelection.dimension,
                  );
                }
              }
              index++;
            }
          }
          if (uniqueVariableCode && uniqueVariableCode.length > 0) {
            this.EPdataFor_Multiple = this.EPdataFor_Multiple.filter(
              (item: any) =>
                item.variable_code === '' ||
                uniqueVariableCode.includes(item.variable_code),
            );
          }

          const autoLoaded = this.tryAutoSelectAndLoadSingleEntryPointOptions();
          if (!autoLoaded) {
            if (entryTabDiv) {
              entryTabDiv.classList.remove('DN');
            }
            if (loadDiv) loadDiv.classList.remove('DN');
            if (
              isEntryPoints &&
              this._configService.isGlobalDefaultSelectionEnabled &&
              this._configService.globalDefaultSelectionFlag &&
              !this.isSavedScenarioSelected
            ) {
              this.loadBtnClick(true);
            }
          }
        } else {
          this.dataArray = [];
          const clientStudyInfo = {
            clientName: this.clientDetails.clientDetails.client_code,
            studyName: this.selected_study,
            snapshotType: this.selectedcompareacrossOption,
            isMandatoryLoadClicked:
              this.selectedcompareacrossOption == 'Multiple Markets' ||
              this.selectedcompareacrossOption == 'Multiple Categories'
                ? true
                : false,
          };
          //this.dataArray.push(clientStudyInfo);
          this.dataArray.push(clientStudyInfo);
          this._rebuildToggleStatusCache();
          //this.dataArray_Multiple.push(clientStudyInfo);
          this.loadBtnClick(false);

          // const variableTab = document.querySelector('.variableTab');
          // if (variableTab)
          //   variableTab.classList.remove('DN');
        }

        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];
      }
    }

    event?.stopPropagation();
  }

  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  togglePanel(Name: string, SelectedValue: string) {
    if (Name == 'study') {
      this.isStudyPanel = !this.isStudyPanel;
      this.isEntry_Point = false;
      this.entry_items_expand = '';
      this.sidePanelblock = false;
    }
  }
  selectedStudy(Name: string) {
    this.studyname = Name;
    this.selected_study = Name;
    this.isStudyPanel = true;
    this.configChanges(this.Reciveddata, Name);
    this.BindEntryData(this.Reciveddata, Name, this.selected_client, true);
    this.crossTabService.selectedStudyName.next(this.selected_study);
  }
  collapsePanel() {
    this.left_panel_collapse = true; //////
    this.iscompareacrossDropdownOpen = false;
    // const leftCollapseBlock = document.querySelector('.left-collapse-block');
    // if (leftCollapseBlock instanceof HTMLElement) {
    //   leftCollapseBlock.classList.remove('DN');
    // }
    // const leftPanelMainExpandBlock = document.querySelector(
    //   '.leftpanel-main-expand-block'
    // );
    // if (leftPanelMainExpandBlock instanceof HTMLElement) {
    //   leftPanelMainExpandBlock.classList.add('DN');
    // }

    this.valueChange.emit(this.left_panel_collapse);
  }
  expandPanel() {
    this.left_panel_collapse = false; /////
    // const leftCollapseBlock = document.querySelector('.left-collapse-block');
    // if (leftCollapseBlock instanceof HTMLElement) {
    //   leftCollapseBlock.classList.add('DN');
    // }
    // const leftPanelMainExpandBlock = document.querySelector(
    //   '.leftpanel-main-expand-block'
    // );
    // if (leftPanelMainExpandBlock instanceof HTMLElement) {
    //   leftPanelMainExpandBlock.classList.remove('DN');
    // }
    this.valueChange.emit(this.left_panel_collapse);
  }
  entrypointcollapse: boolean = false;
  toggleEntryPoint() {
    this.entrypointcollapse = !this.entrypointcollapse;
  }
  selectioncollapse: boolean = false;
  toggleSelection() {
    this.selectioncollapse = !this.selectioncollapse;
  }

  checkMaxLimit(lev: string) {
    // Count unique brands by Level2 to avoid double-counting mirrored Default/Brands entries
    const summaryArr = this.variablesSummaryObj;
    const uniqueBrandsCount = new Set(
      (summaryArr || [])
        .filter((item: any) => item.Level0 === 'Brands')
        .map((item: any) => item.Level2),
    ).size;
    const target = event?.target as HTMLElement;
    if (
      target?.className !== 'checkbox' &&
      target?.className !== 'sub-items-names-parent' &&
      uniqueBrandsCount >= 6
    ) {
      this.mandatoryMaxLimitReached = true;
    } else {
      this.mandatoryMaxLimitReached = false;
    }
  }
  variableExpand(
    variableName: string,
    level: number,
    nextLevelData?: any,
    typeData?: string,
    event?: Event,
  ) {
    if (variableName === 'Custom Percentage Variable - User Defined') {
      this.BindLocalStorageVariableDataPanel();
    }
    event?.stopPropagation();
    this.sidePanelblock = false;
    this.mandatoryMaxLimitReached = false;
    this.entry_items_expand = '';
    this.entry_nested_items_expand = '';
    this.iscompareacrossDropdownOpen = false;

    // --- Handle toggle for the clicked level ---
    const expandVars = [
      'variable_expand',
      'variable_expandLev1',
      'variable_expandLev2',
      'variable_expandLev3',
      'variable_expandLev4',
      'variable_expandLev5',
      'variable_expandLev6',
      'variable_expandLev7',
      'variable_expandLev8',
      'variable_expandLev9',
    ] as const;
    const searchVars = [
      'searchVariable',
      'searchVariable2',
      'searchVariable3',
      'searchVariable4',
      'searchVariable5',
      'searchVariable6',
      'searchVariable7',
      'searchVariable8',
      'searchVariable9',
      'searchVariable10',
    ] as const;
    const searchFilVars = [
      'searchVariableFil',
      'searchVariable2Fil',
      'searchVariable3Fil',
      'searchVariable4Fil',
      'searchVariable5Fil',
      'searchVariable6Fil',
      'searchVariable7Fil',
      'searchVariable8Fil',
      'searchVariable9Fil',
      'searchVariable10Fil',
    ] as const;

    // Toggle the current level
    const currentVar = expandVars[level];
    if (this.is_variable_expand && (this as any)[currentVar] === variableName) {
      this.is_variable_expand = false;
      (this as any)[currentVar] = '';
      if (level === 0) {
        this.increaseLeftpanelHeight.emit({ isReset: true });
      }
    } else {
      (this as any)[currentVar] = variableName;
      this.is_variable_expand = true;
    }

    // Clear all child-level expand/search states in one pass
    for (let i = level + 1; i < expandVars.length; i++) {
      (this as any)[expandVars[i]] = '';
    }
    // Clear search for the next level and all below
    for (let i = level + 1; i < searchVars.length; i++) {
      (this as any)[searchVars[i]] = '';
    }
    // Clear filter-search from the appropriate start index
    const filStart = level === 0 ? 0 : level + 1;
    for (let i = filStart; i < searchFilVars.length; i++) {
      (this as any)[searchFilVars[i]] = '';
    }
    if (level === 0) {
      this.searchVariable = '';
    }

    // --- Level-specific side-effects ---
    if (level === 0) {
      // Compute header position once (it never moves)
      if (!this._topLev1Cache) {
        const divElement1 = document.querySelector(
          '.variableHeader',
        ) as HTMLElement;
        if (divElement1) {
          const height = this.GetHeightAboveElement(divElement1);
          this._topLev1Cache =
            (height / document.body.offsetHeight) * 100 + '%';
        }
      }
      if (this._topLev1Cache) {
        this.topLev1 = this._topLev1Cache;
      }
    } else if (level === 1) {
      // Compute sub-items panel position once (it never moves)
      if (!this._topCache) {
        const divElement = document.querySelector(
          '.variables-sub-itemsLev1',
        ) as HTMLElement;
        if (divElement) {
          const height = this.GetHeightAboveElement(divElement);
          this._topCache = (height / document.body.offsetHeight) * 100 + '%';
        }
      }
      if (this._topCache) {
        this.top = this._topCache;
      }
    } else if (level >= 3) {
      const currentExpanded = (this as any)[expandVars[level]];
      const isIncrease = currentExpanded !== '';
      if (level <= 4) {
        this.increaseLeftpanelHeight.emit({
          isIncrease,
          isDecrease: !isIncrease,
          level,
        });
        this.increaseLeftbgpanelWidth({
          isIncrease,
          isDecrease: !isIncrease,
          level,
        });
      } else if (level === 5) {
        this.increaseLeftpanelHeight.emit({
          isIncrease,
          isDecrease: !isIncrease,
          level,
        });
      }
      if (level >= 5) {
        // Use requestAnimationFrame instead of setTimeout for smoother scroll
        requestAnimationFrame(() => this.scrollToRightEnd());
      }
    }

    // --- Update max-limit entirely from data (no DOM queries) ---
    this.updateMaxLimit(variableName);

    // --- Highlight the clicked element ---
    const clickedElement = event?.target as HTMLElement;
    if (clickedElement) {
      if (this._lastSelectedTextClickEl) {
        this._lastSelectedTextClickEl.classList.remove('selectedTextClick');
        this._lastSelectedTextClickEl = null;
      }

      const nearestDiv =
        clickedElement.parentElement?.parentElement?.classList.contains(
          'sub-items-block',
        )
          ? (clickedElement.parentElement!.parentElement as HTMLElement)
          : clickedElement.parentElement?.classList.contains('sub-items-block')
            ? (clickedElement.parentElement as HTMLElement)
            : null;

      if (nearestDiv) {
        nearestDiv.classList.add('selectedTextClick');
        this._lastSelectedTextClickEl = nearestDiv;
      }
    }

    this.checkAndExpand(
      variableName,
      level,
      this.variable_expand === 'Audience',
      nextLevelData,
      typeData,
    );
  }
  private updateMaxLimit(variableName: string) {
    // Count from data arrays — zero DOM queries
    const summaryArr = this.variablesSummaryObj;

    // Audience count with early exit
    let audienceCount = 0;
    if (summaryArr) {
      for (let i = 0, len = summaryArr.length; i < len; i++) {
        if (summaryArr[i].Level0 === 'Audience' && ++audienceCount >= 3) break;
      }
    }

    // Count unique brands by Level2 across both 'Brands' and 'Default' Level1 groups
    // (mirroring adds each brand twice, so deduplication by Level2 gives the real count)
    const uniqueBrandsCount = new Set(
      (summaryArr || [])
        .filter((item: any) => item.Level0 === 'Brands')
        .map((item: any) => item.Level2),
    ).size;

    this.audienceLimit = audienceCount >= 3;
    const isMultiCohortAudienceSnapshot =
      this.selectedcompareacrossOption === 'Audience Snapshot' &&
      !this.isSingleaudienceCohortType;
    this.mandatoryMaxLimitReached =
      variableName === 'Audience' || isMultiCohortAudienceSnapshot
        ? audienceCount >= 3
        : uniqueBrandsCount >= 6;
  }
  checkAndExpand(
    variableName: string,
    level: number,
    variableExpandIsAudience: boolean = false,
    nextLevelData: any = null,
    typeData: string = '',
  ) {
    let subValue = typeData !== 'filter' ? level + 1 : level;

    const nextLevel = nextLevelData?.[`Level${subValue}`];

    if (nextLevelData?.hasNextLevel && nextLevel?.length === 1) {
      const nextData = nextLevel[0];

      if (nextData?.hasNextLevel) {
        Promise.resolve().then(() => {
          this.variableExpand(
            nextData[`Level${subValue}_value`],
            level + 1,
            nextData,
            typeData,
          );
        });
      }
    }
  }
  // findItemInList(
  //   list: any[],
  //   variableName: string,
  //   targetLevel: number,
  //   currentLevel: number = 0,
  //   isFromFilter = false,
  // ): any | null {
  //   if (!list || list.length === 0) return null;

  //   if (list.some(item => `Level${targetLevel}` in item)) {
  //     for (const item of list) {
  //       let levelNumber = isFromFilter ? 0 : targetLevel;
  //       if (item[`Level${levelNumber}`] === variableName) {
  //         return item;
  //       }
  //       const nextLevel = currentLevel + 1;
  //       const childList = item[`Level${nextLevel}`];
  //       if (Array.isArray(childList) && childList.length != 0) {
  //         const found = this.findItemInList(childList, variableName, targetLevel, nextLevel, isFromFilter);
  //         if (found) return found;
  //       }
  //     }
  //   }
  //   return null;
  // }

  // getListForVariable(
  //   variableName: string,
  //   level: number
  // ): { item: any | null; fromFilter: boolean } {

  //   if (this.variableListMultiMarketAndCateg.length > 0) {
  //     const fromMulti = this.findItemInList(this.variableListMultiMarketAndCateg, variableName, level);
  //     if (fromMulti) return { item: fromMulti, fromFilter: false };
  //   }

  //   if (this.variableList.length > 0) {
  //     const fromList = this.findItemInList(this.variableList, variableName, level);
  //     if (fromList) return { item: fromList, fromFilter: false };
  //   }

  //   if (this.variableListFilter.length > 0) {
  //     const fromFilter = this.findItemInList(this.variableListFilter, variableName, level, 0, true);
  //     if (fromFilter) return { item: fromFilter, fromFilter: true };
  //   }

  //   return { item: null, fromFilter: false };
  // }
  //   checkAndExpand(variableName: string, level: number, variableExpandIsAudience: boolean = false, nextLevelData: any = null,typeData:string='') {
  //     let  subValue=level;
  //       if(typeData !='filter')
  //       {
  //         subValue =level+1;
  //       }

  //       if (
  //         nextLevelData.hasNextLevel &&
  //         nextLevelData[`Level${subValue}`]?.length === 1
  //       ) {
  //         const nextData = nextLevelData[`Level${subValue}`][0];
  //         if (nextData.hasNextLevel) {
  //            setTimeout(() => {
  //             this.variableExpand(
  //             nextData[`Level${subValue}_value`],
  //             level + 1,
  //             nextData,
  //             typeData
  //           );
  //            },0)
  //         }
  //       }
  // }
  // checkAndExpand(variableName: string, level: number, variableExpandIsAudience:boolean = false) {
  // let { item: currentItem, fromFilter } = this.getListForVariable(variableName, level);
  // if (!currentItem) return;
  // if(variableExpandIsAudience){
  //   fromFilter = false;
  //  }
  // const nextLevel = fromFilter ? 1 : level + 1;
  // const nextList = currentItem[`Level${nextLevel}`];

  // if (nextList?.length === 1 && currentItem.hasNextLevel) {
  //   const nextData = nextList[0];
  //   this.variableExpand(nextData[`Level${nextLevel}_value`], level + 1);
  // }
  // }
  onItemClicked(event: MouseEvent) {
    if (this.selectedItem) {
      this.selectedItem.classList.remove('clicked');
    }
    this.selectedItem = event.currentTarget as HTMLElement;

    const hasNextLevelValue = this.selectedItem
      .getAttribute('data-hasNextLevel')
      ?.toString();
    const has_nextLevel = hasNextLevelValue === 'true'; // Consider 'true' as true, anything else as false

    const dimension = this.selectedItem
      .getAttribute('data-is_dimension')
      ?.toString();
    const is_dimension = dimension === 'true'; // Consider 'true' as true, anything else as false

    const iscustomGrpPresent = this.selectedItem
      .getAttribute('data-is_CustomGroup')
      ?.toString();
    const is_custmGrpPresent = iscustomGrpPresent === 'true';

    const isTimePeriodPresent = this.selectedItem
      .getAttribute('data-is_time_Period_Present')
      ?.toString();
    const is_Time_Period_Present = isTimePeriodPresent === 'true';
    this.selectedVariableLevel1.emit({
      tooltip: this.selectedItem.title,
      title: this.selectedItem.getAttribute('data-variable-name')?.toString(),
      Parent: this.selectedItem.getAttribute('data-attr')?.toString(),
      is_derived: this.selectedItem.getAttribute('data-is_derived')?.toString(),
      is_brand_analysis: this.selectedItem.getAttribute(
        'data-is_brand_analysis',
      ),
      is_calc_type: this.selectedItem
        .getAttribute('data-calc_type')
        ?.toString(),
      has_nextLevel,
      data_variable_code: this.selectedItem
        .getAttribute('data_variable_code')
        ?.toString(),
      data_response_code: this.selectedItem
        .getAttribute('data_response_code')
        ?.toString(),
      derived_metric_calculation: this.selectedItem
        .getAttribute('data_derived_metric_calculation')
        ?.toString(),
      data_sort_id: this.selectedItem.getAttribute('data_sort_id')?.toString(),
      data_is_multi_punch: this.selectedItem
        .getAttribute('data_is_multi_punch')
        ?.toString(),
      data_date: this.selectedItem.getAttribute('data_date')?.toString(),
      data_year_code: this.selectedItem
        .getAttribute('data_year_code')
        ?.toString(),
      is_dimension,
      is_custmGrpPresent,
      data_kibanaFilterScript: this.selectedItem
        .getAttribute('data-kibanaFilterScript')
        ?.toString(),
      data_customGroupId: this.selectedItem
        .getAttribute('data-customGroupId')
        ?.toString(),

      dataYearCode: this.selectedItem
        .getAttribute('data-dataYearCode')
        ?.toString(),
      is_Time_Period_Present,
      data_Weekno_forSigcalculation: this.selectedItem
        .getAttribute('data-Weekno_forSigcalculation')
        ?.toString(),
    });

    //this.selectedItem.classList.add('clicked');
  }

  MultipleloadBtnClick(
    isZeroEntryPoint: boolean,
    isNotSaved: boolean = true,
    clickFromButton: boolean = false,
  ) {
    if (
      this.dataArray.length > 0 &&
      this.datarrayformultiplemarkorcategories.length == 0
    ) {
      this.datarrayformultiplemarkorcategories = _.cloneDeep(this.dataArray);
    } else if (
      this.dataArray.length > 0 &&
      this.datarrayformultiplemarkorcategories.length > 0 &&
      this.dataArray != this.datarrayformultiplemarkorcategories
    ) {
      this.dataArray = _.cloneDeep(this.datarrayformultiplemarkorcategories);
    }
    if (this.dataArray_Multiple.length == 0) {
      this.getValidation('2ndLoadClick');
    } else {
      let newDataArray = _.cloneDeep(this.dataArray);

      newDataArray.forEach((item) => {
        if (item.isMandatoryLoadClicked) item.isMandatoryLoadClicked = false;
      });

      this.dataArray_Multiple.forEach((item) => {
        newDataArray.push(item);
      });

      this.isVariableTab = true;
      const shouldHideEntryPoint = this.shouldHideEntryPointPanelAfterLoad();
      this.is_load_btn = !shouldHideEntryPoint;
      this.isEntry_Tab = !shouldHideEntryPoint;
      this.sidePanelblock = false;
      this.isEntry_Point = false;
      this.entry_items_expand = '';
      this.collapseProductCategoryPanel();
      this.variable_expand = '';
      this.variable_expandLev1 = '';
      this.variable_expandLev2 = '';
      this.variable_expandLev3 = '';
      this.variable_expandLev4 = '';
      this.variable_expandLev5 = '';
      this.variable_expandLev6 = '';
      this.variable_expandLev7 = '';
      this.variable_expandLev8 = '';
      this.variable_expandLev9 = '';
      if (shouldHideEntryPoint) {
        this.isEntryPointHiddenBySingleOption = true;
        this.hideEntryPointPanel();
      }

      this.btnVisible.emit({
        save: true,
        load: true,
        custom_groups: this.isconfigCustomGrpPresent ? true : false,
        custom_calc: false,
        create_table: true,
        weighted_btns: true,
      });

      this._loaderService.showLoader();
      if (
        this.$unSubscribeSubmitData2 &&
        !this.$unSubscribeSubmitData2.closed
      ) {
        this.$unSubscribeSubmitData2.unsubscribe();
      }
      this.$unSubscribeSubmitData2 = this._configService
        .getSnapshotLeftPanelData(this.buildSnapshotLoadPayload(newDataArray))
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          if (data.Data !== '') {
            this.isAdditionalFeatures = true;
            let jsonLeftPanelData = JSON.parse(data.Data);
            jsonLeftPanelData = jsonLeftPanelData.filter(
              (item: any) => item.calculation_type?.toUpperCase() !== 'MEAN',
            );
            jsonLeftPanelData = this.applySnapshotSpecificLeftPanelFilter(
              jsonLeftPanelData,
            );
            this._configService.leftPanelData = jsonLeftPanelData;
            if (this.selectedcompareacrossOption == 'Multiple Markets') {
              this._configService.brandData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 === 'Markets',
              );
              jsonLeftPanelData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 != 'Markets',
              );
            } else if (
              this.selectedcompareacrossOption == 'Audience Snapshot'
            ) {
              this._configService.brandData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 === 'Audience',
              );
              jsonLeftPanelData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 != 'Audience',
              );
            } else {
              this._configService.brandData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 === 'Brands',
              );
            }

            //debugger;
            // Duplicate Brands items as "Default" with Level1 and Level2 set to 'Default'
            if (this.defaultBrandList?.length > 0) {
              const defaultBrandsItems = jsonLeftPanelData
                .filter((item: any) => item.Level0 === 'Brands')
                .map((item: any) => ({
                  ...item,
                  Level1: 'Default',
                  Level2: 'Default',
                }));
              jsonLeftPanelData = [...defaultBrandsItems, ...jsonLeftPanelData];
            }

            jsonLeftPanelData = jsonLeftPanelData.filter(
              (item: any) => item.is_snapshot === 1,
            );
          
            this._configCustomService.uniqueMetricOptions = [
                  ...new Set(
                      jsonLeftPanelData.filter((a: any) => a.Level1 !== 'Brands' && a.Level1 !== 'Time Period').flatMap((item: any) => [  
                          item.Level2,
                          item.Level3,
                          item.Level4,
                          item.Level5,
                          item.Level6,
                          item.Level7
                      ]).filter(Boolean)
                  )
            ]; 

            this.BindVariableDataPanel(jsonLeftPanelData);
            if (this.isSavedScenarioSelected && isNotSaved) {
              //isZeroEntryPoint &&
              this.LoadSelectionVariableData();
            } else if (
              this._configService.isGlobalDefaultSelectionEnabled &&
              this._configService.globalDefaultSelectionFlag &&
              isNotSaved
            ) {
              this.GlobalDefaultSelection();
            }

            this.autoSelectDefaultBrands();

            this._configService.leftPanelSelectionsData = this.variableList;
            this.GetUniqueSelectionsList();
            let weightOptions = this._configService.leftPanelData.filter(
              (lp: any) => lp.Level1 == 'Weight Metrics',
            );
            this._configService.weights?.forEach((wp: any) => {
              //if (wp.variable_code == "") {
              wp.key = wp.variable_label;
              //}
              let wop = weightOptions.find(
                (w1: any) => w1.data_variable_code == wp.variable_code,
              );
              if (wop) {
                wp.key = wop.Level2;
              }
            });
            const variableTab = document.querySelector('.variableTab');
            if (variableTab) variableTab.classList.remove('DN');
            this.captureAutoLoadedEntryPointSnapshot();
          }
          if (
            clickFromButton ||
            (!this._configService.isGlobalDefaultSelectionEnabled &&
              !this.isSavedScenarioSelected)
          ) {
            this._loaderService.hideLoader();
          }
          //this._loaderService.hideLoader();
        });

      //disable Study Dropdown click Event
      this.isLoadSubmitted = true;
      this.showCancelBtn = false;

      if (
        !(
          this.selectedcompareacrossOption == 'Multiple Markets' ||
          this.selectedcompareacrossOption == 'Multiple Categories'
        )
      ) {
        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];
      }
    }
  }

  loadBtnClick(
    isZeroEntryPoint: boolean,
    isNotSaved: boolean = true,
    clickFromButton: boolean = false,
  ) {
    // this.isLoader = true;
    this._loaderService.showLoader();
    if (
      isZeroEntryPoint &&
      (this.dataArray.length == 0 ||
        this.getSelectedEntryPointCount() < this.getRequiredEntryPointCount())
    ) {
      // this.isLoader = false;
      this._loaderService.hideLoader();
      this.getValidation('EntryPoint');
    } else {
      const shouldHideEntryPoint = this.shouldHideEntryPointPanelAfterLoad();
      this.isVariableTab = true;
      this.is_load_btn = !shouldHideEntryPoint;
      this.isEntry_Tab = !shouldHideEntryPoint;
      this.sidePanelblock = false;
      this.isEntry_Point = false;
      this.entry_items_expand = '';
      this.collapseProductCategoryPanel();
      this.variable_expand = '';
      this.variable_expandLev1 = '';
      this.variable_expandLev2 = '';
      this.variable_expandLev3 = '';
      this.variable_expandLev4 = '';
      this.variable_expandLev5 = '';
      this.variable_expandLev6 = '';
      this.variable_expandLev7 = '';
      this.variable_expandLev8 = '';
      this.variable_expandLev9 = '';
      if (shouldHideEntryPoint) {
        this.isEntryPointHiddenBySingleOption = true;
        this.hideEntryPointPanel();
      }
      this.IsEntrypointSelected.emit(true);

      this.btnVisible.emit({
        save: true,
        load: true,
        custom_groups: this.isconfigCustomGrpPresent ? true : false,
        custom_calc: false,
        create_table: true,
        weighted_btns: true,
      });

      this.entryListChange.emit(this.entryPanel);

      if (
        this.isMultiMarketOrCateg &&
        this.selectedcompareacrossOption == 'Multiple Markets'
      ) {
        this.dataListChange.emit(this.dataArray_Multiple);
      } else {
        this.dataListChange.emit(this.dataArray);
      }
      this.dimensionListChange.emit(this.dimensionList);

      this._configService
        .getTopicsConfigurationBySnapshot({
          clientName: this.clientDetails.clientDetails.client_code,
          studyName: this.selected_study,
          snapshot_type: this._configService.snapshotSelectedName,
          section_name: this._configService.selectedSection,
          snapshot_name: this.snapshotName,
          subsection_name: this.subsectionselected
            ? this.subsectionselected
            : '',
        })
        .pipe(
          takeUntil(this.destroy$),
          catchError(() => of(null)),
        )
        .subscribe((topicsConfig: any) => {
          if (topicsConfig?.Data) {
            this._configService.topicsConfigurationBySnapshot = JSON.parse(
              topicsConfig.Data,
            );
            const allRows: any[] =
              this._configService.topicsConfigurationBySnapshot?.rows || [];

            // Keep FAS Total as-is for Topics matching (do not expand to 3 FAS segments —
            // expanding unions BrandLists from other FAS rows and adds extra default brands).
            const ep1Names: string[] =
              this.dataArray
                .find((e: any) => e.EntryPoint1)
                ?.EntryPoint1?.Level2?.flatMap(
                  (l2: any) =>
                    l2.MetricOptions?.map((mo: any) => mo.Name).filter(
                      Boolean,
                    ) || [],
                ) || [];
            const ep2Names: string[] =
              this.dataArray
                .find((e: any) => e.EntryPoint2)
                ?.EntryPoint2?.Level2?.flatMap(
                  (l2: any) =>
                    l2.MetricOptions?.map((mo: any) => mo.Name).filter(
                      Boolean,
                    ) || [],
                ) || [];
            const ep3Names: string[] =
              this.dataArray
                .find((e: any) => e.EntryPoint3)
                ?.EntryPoint3?.Level2?.flatMap(
                  (l2: any) =>
                    l2.MetricOptions?.map((mo: any) => mo.Name).filter(
                      Boolean,
                    ) || [],
                ) || [];

            const filteredRows = this.filterTopicsRowsForDefaultBrands(
              allRows,
              ep1Names,
              ep2Names,
              ep3Names,
            );
            //debugger;

            this.defaultProductListMapping = [
              ...new Set(
                filteredRows.flatMap((row: any) => row.productList || []),
              ),
            ];

            //Based on selected products default brands will be filtered and set to defaultBrandList
            if (this.defaultProductListMapping.length > 0) {
              //Default  Brandlist wil be prepared here for product trackers
              this.filterDefaultBrandsBasedOnProducts(filteredRows);
            } else {
              this.defaultBrandList = [
                ...new Set(
                  filteredRows.flatMap((row: any) => row.brandList || []),
                ),
              ];
            }

            if (this.variableList && this.variableList.length > 0) {
              this.applyDefaultBrandListToBrandsPanel();
              this.autoSelectDefaultBrands();
            }
          } else {
            this._configService.topicsConfigurationBySnapshot = null;
            this.defaultBrandList = [];
            this.defaultProductListMapping = [];
          }
        });

      this._loaderService.showLoader();
      if (
        this.$unSubscribeSubmitData1 &&
        !this.$unSubscribeSubmitData1.closed
      ) {
        this.$unSubscribeSubmitData1.unsubscribe();
      }
      this.$unSubscribeSubmitData1 = this._configService
        .getSnapshotLeftPanelData(this.buildSnapshotLoadPayload(this.dataArray))
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          if (data.Data !== '') {
            if (this.selectedcompareacrossOption != 'Multiple Markets') {
              this.isAdditionalFeatures = true;
            }
            let jsonLeftPanelData = JSON.parse(data.Data);
            jsonLeftPanelData = jsonLeftPanelData.filter(
              (item: any) => item.calculation_type?.toUpperCase() !== 'MEAN',
            );
            jsonLeftPanelData = this.applySnapshotSpecificLeftPanelFilter(
              jsonLeftPanelData,
            );
            this._configService.leftPanelData = jsonLeftPanelData;
            this._configService.brandData = jsonLeftPanelData.filter(
              (item: any) => item.Level0 === 'Brands',
            );

            // Duplicate Brands items as "Default" with Level1 and Level2 set to 'Default'
            if (this.defaultBrandList?.length > 0) {
              const defaultBrandsItems = jsonLeftPanelData
                .filter((item: any) => item.Level0 === 'Brands')
                .map((item: any) => ({
                  ...item,
                  Level1: 'Default',
                  Level2: 'Default',
                }));
              jsonLeftPanelData = [...defaultBrandsItems, ...jsonLeftPanelData];
            }
            jsonLeftPanelData = jsonLeftPanelData.filter(
              (item: any) => item.is_snapshot === 1,
            );
          
            this._configCustomService.uniqueMetricOptions = [
                    ...new Set(
                      jsonLeftPanelData.filter((a: any) => a.Level1 !== 'Brands' && a.Level1 !== 'Time Period').flatMap((item: any) => [
                          item.Level2,
                          item.Level3,
                          item.Level4,
                          item.Level5,
                          item.Level6,
                          item.Level7
                      ]).filter(Boolean)
                  )
                ]; 

            if (
              this.selectedcompareacrossOption == 'Multiple Markets' ||
              this.selectedcompareacrossOption == 'Multiple Categories'
            ) {
              if (this.variableListMultiMarketAndCateg.length == 0) {
                this.BindVariableDataPanelMultiple(jsonLeftPanelData);
              }
            } else {
              this.BindVariableDataPanel(jsonLeftPanelData);
            }

            if (this.isSavedScenarioSelected && isNotSaved) {
              //isZeroEntryPoint
              this.LoadSelectionVariableData();
            } else if (
              this._configService.isGlobalDefaultSelectionEnabled &&
              this._configService.globalDefaultSelectionFlag &&
              isNotSaved
            ) {
              this.GlobalDefaultSelection();
            }

            this.autoSelectDefaultBrands();

            this._configService.leftPanelSelectionsData = this.variableList;
            this.GetUniqueSelectionsList();
            let weightOptions = this._configService.leftPanelData.filter(
              (lp: any) => lp.Level1 == 'Weight Metrics',
            );
            this._configService.weights?.forEach((wp: any) => {
              //if (wp.variable_code == "") {
              wp.key = wp.variable_label;
              // }
              let wop = weightOptions.find(
                (w1: any) => w1.data_variable_code == wp.variable_code,
              );
              if (wop) {
                wp.key = wop.Level2;
              }
            });
            const variableTab = document.querySelector('.variableTab');
            if (variableTab) variableTab.classList.remove('DN');
            this.captureAutoLoadedEntryPointSnapshot();
          }

          if (
            this.selectedcompareacrossOption == 'Multiple Markets' ||
            this.selectedcompareacrossOption == 'Multiple Categories'
          )
            this.isMultiMarketOrCateg = true;
          else this.isMultiMarketOrCateg = false;

          if (this.selectedcompareacrossOption == 'Audience Snapshot')
            this.isAudienceSnapshot = true;
          else this.isAudienceSnapshot = false;

          if (
            clickFromButton ||
            (!this._configService.saveSelectionLoad &&
              !this._configService.isGlobalDefaultSelectionEnabled)
          ) {
            this._loaderService.hideLoader();
          } //-- removing this
          this._configService.saveSelectionLoad = false;
          // this.isLoader = false;
          this._loaderService.hideLoader();
        });

      //disable Study Dropdown click Event
      this.isLoadSubmitted = true;
      this.showCancelBtn = false;
      if (
        !(
          this.selectedcompareacrossOption == 'Multiple Markets' ||
          this.selectedcompareacrossOption == 'Multiple Categories'
        )
      ) {
        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];
      }
    }
  }

  GetUniqueSelectionsList() {
    this.uniqueSelections = [
      ...new Set(
        this.variableList
          .filter(
            (a: any) =>
              a.isEntryPoint !== true &&
              a.Level0 !== '' &&
              a.Level0 !== 'Custom Group',
          )
          .map((a: any) => a.Level0),
      ),
    ];

    this.GetMandatorySelectionsList();
  }

  GetMandatorySelectionsList() {
    switch (this.selectedcompareacrossOption) {
      case 'Single Brand':
        this.singleorMultiSelectMandatory1 = 'Brands 1';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = '';
        break;
      case 'Multiple Brands':
        this.singleorMultiSelectMandatory1 = 'Brands 2';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = '';
        break;
      case 'Multiple Categories':
        this.singleorMultiSelectMandatory1 = 'Category 2';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = 'Brands 1';
        break;
      case 'Multiple Markets':
        this.singleorMultiSelectMandatory1 = 'Markets 2';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = 'Brands 1';
        break;
      case 'Audience Snapshot':
        this.singleorMultiSelectMandatory1 = 'Audience Snapshot';
        this.timeperiodMandatory2 = 'Time Period';
        break;
      default:
        // Code for default case
        break;
    }
  }

  GetHeightAboveElement(element: HTMLElement): number {
    let height = 0;
    while (element) {
      height += element.offsetTop;
      element = element.offsetParent as HTMLElement;
    }
    return height;
  }

  OnCancelBtnClick() {
    this.showCancelBtn = false;
    this.cancelEntryPointChange.emit(true);
  }

  toggleMetricOptions(
    Level1: any,
    nestedEntry: any,
    event: MouseEvent,
    entryDetails: string,
  ) {
    this.sidePanelblock = true;
    this.variable_expand = '';
    this.entry_nested_items_expand = nestedEntry;
    this.selectedItem = event.currentTarget as HTMLElement;

    this.metricOption = [];
    this.dataArray.forEach((entry) => {
      const metricOptionsList = entry['EntryPoint1']?.MetricOptions || [];

      metricOptionsList.forEach((data: MetricOptions) => {
        this.metricOption.push(data.Name);
      });
    });

    const uniqueMetricOptionsArray =
      entryDetails == 'entry1' ? [] : this.metricOption;

    if (this.entryList.length > 0) {
      const EntryData = _.filter(
        this.entryList,
        (item) =>
          item.Level1 !== null && item.Level1 !== '' && item.Level1 === Level1,
      );
      if (uniqueMetricOptionsArray.length > 0) {
        if (EntryData.length > 0) {
          this.filterdEntryList = _.filter(
            EntryData[0].NestedEntryArray,
            (item) => item.Level2 !== null && item.Level2 === nestedEntry,
          );

          this.filterdEntryList =
            EntryData[0].NestedEntryArray[0].MetricOptions.filter(
              (option: any) => {
                const optionCodes = option.e2_variable_code
                  .split(',')
                  .map((code: any) => code.trim());
                return optionCodes.some((code: any) =>
                  uniqueMetricOptionsArray.includes(code),
                );
              },
            );
        }
      } else {
        if (EntryData.length > 0) {
          this.filterdEntryList = _.filter(
            EntryData[0].NestedEntryArray,
            (item) => item.Level2 !== null && item.Level2 === nestedEntry,
          );
        }
      }
    }
  }
  onSearchLevel(Name: string) {
    this.sidePanelblock = false;
    this.entry_nested_items_expand = '';
  }
  shouldHideItem(item: string): boolean {
    return item.toString().includes(this.searchMetricOption);
  }

  onSearchLevelHiding(Name: string) {
    const variablesSubItemsLev1 = document.querySelector(
      '.variables-sub-itemsLev' + Name,
    );
    const selectedTextClick =
      variablesSubItemsLev1?.querySelector('.selectedTextClick');
    selectedTextClick?.classList.remove('selectedTextClick');

    switch (Name) {
      case '1':
        this.variable_expandLev1 = '';
        this.variable_expandLev2 = '';
        this.variable_expandLev3 = '';
        this.variable_expandLev4 = '';
        break;
      case '2':
        this.variable_expandLev2 = '';
        this.variable_expandLev3 = '';
        this.variable_expandLev4 = '';
        break;
      case '3':
        this.variable_expandLev3 = '';
        this.variable_expandLev4 = '';
        break;
      case '4':
        this.variable_expandLev4 = '';
        break;
    }
  }

  checkBoxClick(
    index: number,
    Level: number,
    Header: string,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
    responseCode: string,
    mandatory_variable_mapping: any[],
    isSelectAll: boolean,
    e1_variable_code: string,
    e2_variable_code: string,
    e3_variable_code: string,
    dimension: any[],
  ): void {
    // this.ResetClicked();
    if (this.selectedcompareacrossOption == 'Multiple Markets') {
      Level += 1;
    }
    const entryPointKey =
      Level === 0 ? 'EntryPoint1' : Level === 1 ? 'EntryPoint2' : 'EntryPoint3';

    if (Level === 0) {
      const entryPoint2Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint2'),
      );
      if (entryPoint2Index !== -1) {
        const entryPoint2 = this.dataArray[entryPoint2Index];

        const level2Index = entryPoint2['EntryPoint2'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions,
            ),
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint2['EntryPoint2'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions,
          );
          if (metricOptionIndex !== -1) {
            entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1,
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint2['EntryPoint2'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint2['EntryPoint2'].Level2.length === 0) {
                this.dataArray.splice(entryPoint2Index, 1);

                const entryPoint3Index = this.dataArray.findIndex((entry) =>
                  entry.hasOwnProperty('EntryPoint3'),
                );

                if (entryPoint3Index !== -1) {
                  this.dataArray.splice(entryPoint3Index, 1);
                }
              }
            }
          }
        }
      }

      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3'),
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions,
            ),
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions,
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1,
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    } else if (Level === 1) {
      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3'),
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e2 === e2_variable_code,
            ),
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e2 === e2_variable_code,
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1,
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    }
    const existingEntryIndex = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1,
    );

    if (existingEntryIndex !== -1) {
      // Entry with the same entryPointKey and Level1 exists
      const existingEntry = this.dataArray[existingEntryIndex];

      // Check if Level2 is different
      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === Level2,
      );

      if (existingLevel2Index !== -1) {
        // Level2 with the same Parent exists
        const existingMetricOptionIndex = existingEntry[entryPointKey].Level2[
          existingLevel2Index
        ].MetricOptions.findIndex((mo: any) => mo.Name === MetricOptions);

        if (existingMetricOptionIndex !== -1) {
          // MetricOptions is the same, remove it
          if (isSelectAll == false) {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.splice(existingMetricOptionIndex, 1);
          }
        } else {
          // MetricOptions is different, push it to the existing MetricOptions array

          const existingMetricOptionIndex = existingEntry[
            entryPointKey
          ].Level2.findIndex((mo: any) => {
            const existingMetricOptions = mo.MetricOptions;
            return existingMetricOptions.some(
              (existingMo: any) => existingMo.Name === MetricOptions,
            );
          });

          if (existingMetricOptionIndex !== -1) {
            if (isSelectAll == false) {
            }
          } else {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.push({
              Name: MetricOptions,
              responseCode: responseCode,
              isActive: true,
              Dependency_e1: e1_variable_code,
              Dependency_e2: e2_variable_code,
            });
          }
        }
      } else {
        const existingMetricOptionIndex = existingEntry[
          entryPointKey
        ].Level2.findIndex((mo: any) => {
          const existingMetricOptions = mo.MetricOptions;
          return (
            existingMetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions,
            ) !== -1
          );
        });

        if (existingMetricOptionIndex !== -1) {
          if (isSelectAll == false) {
            const metricOptionIndex = existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions,
            );
            existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.splice(metricOptionIndex, 1);
          }
        } else {
          // Level2 is different, push new Level2 and MetricOptions
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode,
                isActive: true,
                Dependency_e1: e1_variable_code,
                Dependency_e2: e2_variable_code,
              },
            ],
          });
        }
      }
    } else {
      // Create a new entry
      const tempEntry = {
        [entryPointKey]: {
          Level1: Level1,
          Level2: [
            {
              Parent: Level2,
              MetricOptions: [
                {
                  Name: MetricOptions,
                  responseCode: responseCode,
                  isActive: true,
                  Dependency_e1: e1_variable_code,
                  Dependency_e2: e2_variable_code,
                },
              ],
            },
          ],
          variableCode: variableCode,
        },
        clientName: this.clientDetails.clientDetails.client_code.toString(),
        studyName: this.selected_study,
        mandatory_variable_mapping: mandatory_variable_mapping,
        dimension: dimension,
        isMandatoryLoadClicked:
          this.selectedcompareacrossOption == 'Multiple Markets' ||
          this.selectedcompareacrossOption == 'Multiple Categories'
            ? true
            : false,
        snapshotType: this.selectedcompareacrossOption,
      };
      this.dataArray.push(tempEntry);
    }
    const existingEntryIndex1 = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1,
    );

    const existingEntry = this.dataArray[existingEntryIndex1];

    const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
      (l2: any) => l2.Parent === Level2,
    );
    if (
      this.entryPanel_Lvl3.filter(
        (a) => a.Level1 === Level1 && a.Level2 === Level2,
      ).length ===
        (existingLevel2Index !== -1
          ? existingEntry[entryPointKey].Level2[existingLevel2Index]
              .MetricOptions.length
          : 0) &&
      isSelectAll == false
    ) {
      this.isSelectAll = true;
    } else {
      if (isSelectAll == false) {
        this.isSelectAll = false;
      }
    }
    this.updateSavedSelectionsFromData(this.selectedObjects);
    this._rebuildToggleStatusCache();
    if (entryPointKey === 'EntryPoint1' && this.isProductCategorySection) {
      this.maybeRefreshProductCategoryForAudience();
    }
    this.queuePanelRefresh();
    // this.ResetClicked();
    this.ClearAll();
  }

  checkBoxClickMultiple(
    event: any,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
    responseCode1: string,
    level1: string,
    level2: string,
    level3: string,
    level4: string,
    level5: string,
    level0: string = '',
    loadSel: boolean = false,
    SelectionFilterData: any = {},
    Level = 0,
    isSelectAll = false,
  ): void {
    let numberOfCheckedCheckboxes;
    if (!loadSel) {
      const nearestLevelDiv = (event.target as HTMLElement).closest(
        'div[class*="variables-sub-itemsLev"]',
      );
      const checkedCheckboxes = nearestLevelDiv?.querySelectorAll(
        'input[type="checkbox"]:checked',
      );
      numberOfCheckedCheckboxes = checkedCheckboxes?.length;
    }

    let entryPointKey = this.EPdataFor_Multiple.filter((a: any) =>
      a.variable_code.includes(variableCode),
    )
      .map((a: any) => a.variable_label)[0]
      ?.replaceAll(' ', '');

    //crosstab EP code start

    if (Level === 0) {
      const entryPoint2Index = this.dataArray_Multiple.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint2'),
      );
      if (entryPoint2Index !== -1) {
        const entryPoint2 = this.dataArray_Multiple[entryPoint2Index];

        const level2Index = entryPoint2['EntryPoint2'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions,
            ),
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint2['EntryPoint2'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions,
          );
          if (metricOptionIndex !== -1) {
            entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1,
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint2['EntryPoint2'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint2['EntryPoint2'].Level2.length === 0) {
                this.dataArray_Multiple.splice(entryPoint2Index, 1);

                const entryPoint3Index = this.dataArray_Multiple.findIndex(
                  (entry) => entry.hasOwnProperty('EntryPoint3'),
                );

                if (entryPoint3Index !== -1) {
                  this.dataArray_Multiple.splice(entryPoint3Index, 1);
                }
              }
            }
          }
        }
      }

      const entryPoint3Index = this.dataArray_Multiple.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3'),
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray_Multiple[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions,
            ),
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions,
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1,
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray_Multiple.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    }
    const existingEntryIndex = this.dataArray_Multiple.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1,
    );

    if (existingEntryIndex !== -1) {
      // Entry with the same entryPointKey and Level1 exists
      const existingEntry = this.dataArray_Multiple[existingEntryIndex];

      // Check if Level2 is different
      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === Level2,
      );

      if (existingLevel2Index !== -1) {
        // Level2 with the same Parent exists
        const existingMetricOptionIndex = existingEntry[entryPointKey].Level2[
          existingLevel2Index
        ].MetricOptions.findIndex((mo: any) => mo.Name === MetricOptions);

        if (existingMetricOptionIndex !== -1) {
          // MetricOptions is the same, remove it
          if (isSelectAll == false) {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.splice(existingMetricOptionIndex, 1);
          }
        } else {
          // MetricOptions is different, push it to the existing MetricOptions array

          const existingMetricOptionIndex = existingEntry[
            entryPointKey
          ].Level2.findIndex((mo: any) => {
            const existingMetricOptions = mo.MetricOptions;
            return existingMetricOptions.some(
              (existingMo: any) => existingMo.Name === MetricOptions,
            );
          });

          if (existingMetricOptionIndex !== -1) {
            if (isSelectAll == false) {
            }
          } else {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.push({
              Name: MetricOptions,
              responseCode: responseCode1,
              isActive: true,
              Dependency_e1: this.e1_forMultiple,
              Dependency_e2: this.e2_forMultiple,
            });
          }
        }
      } else {
        const existingMetricOptionIndex = existingEntry[
          entryPointKey
        ].Level2.findIndex((mo: any) => {
          const existingMetricOptions = mo.MetricOptions;
          return (
            existingMetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions,
            ) !== -1
          );
        });

        if (existingMetricOptionIndex !== -1) {
          if (isSelectAll == false) {
            const metricOptionIndex = existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions,
            );
            existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.splice(metricOptionIndex, 1);
          }
        } else {
          // Level2 is different, push new Level2 and MetricOptions
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode1,
                isActive: true,
                Dependency_e1: this.e1_forMultiple,
                Dependency_e2: this.e2_forMultiple,
              },
            ],
          });
        }
      }
    } else {
      // Create a new entry
      const tempEntry = {
        [entryPointKey]: {
          Level1: Level1,
          Level2: [
            {
              Parent: Level2,
              MetricOptions: [
                {
                  Name: MetricOptions,
                  responseCode: responseCode1,
                  isActive: true,
                  Dependency_e1: this.e1_forMultiple,
                  Dependency_e2: this.e2_forMultiple,
                },
              ],
            },
          ],
          variableCode: variableCode,
        },
        clientName: this.clientDetails.clientDetails.client_code.toString(),
        studyName: this.selected_study,
        mandatory_variable_mapping: this.mandatory_variable_mapping_Multiple,
        dimension: this.dimension_Multiple,
        isMandatoryLoadClicked: false,
        snapshotType: this.selectedcompareacrossOption,
      };
      this.dataArray_Multiple.push(tempEntry);
    }

    //crosstab EP code end

    let responseCode,
      variableLabel,
      year_code,
      is_brand_analysis,
      is_derived,
      calc_type,
      hasNextLevel,
      variable_code,
      sort_id,
      is_multi_punch,
      date,
      is_dimension,
      is_CustomGroup,
      kibanaFilterScript,
      customGroupId,
      dataYearCode,
      is_time_Period_Present,
      derived_metric_calculation,
      isSelected;

    if (!loadSel) {
      if (
        (event.target as HTMLElement).classList.contains(
          'sub-items-names-parent',
        )
      ) {
        let elementParent = (event.target as HTMLElement).parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation',
        );
        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis',
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript',
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present',
        );

        isSelected = elementParent?.getAttribute('data-is_selected');
      } else {
        let elementParent = (event.target as HTMLElement).parentElement
          ?.parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation',
        );

        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis',
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript',
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present',
        );

        isSelected = elementParent?.getAttribute('data-is_selected');
      }
    } else {
      responseCode = SelectionFilterData.response_code;
      derived_metric_calculation =
        SelectionFilterData.derived_metric_calculation;
      variableLabel = SelectionFilterData.variable_label;
      Level0: level0;
      level1 = SelectionFilterData.Level1;
      level2 = SelectionFilterData.Level2;
      level3 = SelectionFilterData.Level3;
      level4 = SelectionFilterData.Level4;
      level5 = SelectionFilterData.Level5;
      year_code = SelectionFilterData.year_code;
      is_brand_analysis = SelectionFilterData.is_brand_analysis;
      is_derived = SelectionFilterData.is_derived;
      calc_type = SelectionFilterData.calc_type;
      hasNextLevel = SelectionFilterData.hasNextLevel;
      variable_code = SelectionFilterData.variable_code;
      sort_id = SelectionFilterData.sort_id;
      is_multi_punch = SelectionFilterData.is_multi_punch;
      date = SelectionFilterData.date;
      is_dimension = SelectionFilterData.s_dimension;
      is_CustomGroup = SelectionFilterData.is_CustomGroup;
      kibanaFilterScript = SelectionFilterData.kibanaFilterScript;
      customGroupId = SelectionFilterData.customGroupId;
      dataYearCode = SelectionFilterData.dataYearCode;
      is_time_Period_Present = SelectionFilterData.is_time_Period_Present;
      isSelected = false;
    }

    const selectedData = {
      response_code: responseCode,
      derived_metric_calculation: derived_metric_calculation,
      variable_label: variableLabel,
      Level0: level0,
      Level1: level1,
      Level2: level2,
      Level3: level3,
      Level4: level4,
      Level5: level5,
      year_code: year_code,
      is_brand_analysis: is_brand_analysis,
      is_derived: is_derived,
      calc_type: calc_type,
      hasNextLevel: hasNextLevel,
      variable_code: variable_code,
      sort_id: sort_id,
      is_multi_punch: is_multi_punch,
      date: date,
      is_dimension: is_dimension,
      is_CustomGroup: is_CustomGroup,
      kibanaFilterScript: kibanaFilterScript,
      customGroupId: customGroupId,
      dataYearCode: dataYearCode,
      is_time_Period_Present: is_time_Period_Present,
    };

    if (event?.target != null) {
      if (
        (event?.target as HTMLElement).classList.contains(
          'sub-items-names-parent',
        )
      ) {
        let elementParent = (event.target as HTMLElement).parentElement;
        isSelected = elementParent?.getAttribute('data-is_selected');
      } else {
        let elementParent = (event.target as HTMLElement).parentElement
          ?.parentElement;
        isSelected = elementParent?.getAttribute('data-is_selected');
      }
    }

    if (isSelected !== 'true') {
      if (this.selectedObjects.some((obj) => obj[selectedData.Level0])) {
        const selectedObj = this.selectedObjects.find(
          (obj) => obj[selectedData.Level0],
        );
        // Check if data already exists before pushing
        const dataExists = selectedObj[selectedData.Level0].some(
          (item: any) => {
            return (
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              item.Level3 == selectedData.Level3 &&
              item.Level4 == selectedData.Level4 &&
              item.Level5 == selectedData.Level5
            );
          },
        );
        if (!dataExists) {
          selectedObj[selectedData.Level0].push(selectedData);
        }
      } else {
        this.selectedObjects.push({ [selectedData.Level0]: [selectedData] });
      }

      // Create a new entry for 2nd load
      // const tempEntry = {
      //   [entryPointKey]: {
      //     Level1: Level1,
      //     Level2: [
      //       {
      //         Parent: Level2,
      //         MetricOptions: [
      //           {
      //             Name: MetricOptions,
      //             responseCode: responseCode1,
      //             isActive: true,
      //             Dependency_e1: this.e1_forMultiple,
      //             Dependency_e2: this.e2_forMultiple,
      //           },
      //         ],
      //       },
      //     ],
      //     variableCode: variableCode,
      //   },
      //   clientName: this.clientDetails.clientDetails.client_code
      //     .toString()
      //     .toLowerCase(),
      //   studyName: this.selected_study,
      //   mandatory_variable_mapping: this.mandatory_variable_mapping_Multiple,
      //   dimension: this.dimension_Multiple,
      //   isMandatoryLoadClicked: false,
      //   snapshotType: this.selectedcompareacrossOption
      // };
      // this.dataArray_Multiple.push(tempEntry);

      this.SwitchMakeSelectedTrueMultiple(selectedData, 'NOTfilters');

      this.variablesSummaryObj.push(selectedData);

      const target = event?.target as HTMLElement;

      if (
        target?.classList.contains('checkbox') &&
        numberOfCheckedCheckboxes !== undefined &&
        numberOfCheckedCheckboxes >= 6
      ) {
        this.mandatoryMaxLimitReached = true;
      } else {
        this.mandatoryMaxLimitReached = false;
      }
      this.queuePanelRefresh();
    } else {
      const selectedObj = this.selectedObjects.find(
        (obj) => obj[selectedData.Level0],
      );
      if (selectedObj) {
        const index = selectedObj[selectedData.Level0].findIndex(
          (item: any) => {
            if (
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level0 == selectedData.Level0 &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              item.Level3 == selectedData.Level3 &&
              item.Level4 == selectedData.Level4 &&
              item.Level5 == selectedData.Level5
            )
              return item;
          },
        );
        if (index !== -1) {
          selectedObj[selectedData.Level0].splice(index, 1);
        }
      }

      //remove entry from the 2ne load object
      // const index = this.dataArray_Multiple.findIndex(
      //   (item: any) => {
      //     if (item[entryPointKey].variableCode == variableCode && item[entryPointKey].Level2.filter((a: any) => a.MetricOptions.filter((b: any) => b.responseCode == responseCode1)).length > 0)
      //       return item;
      //   }
      // );
      // if (index !== -1) {
      //   this.dataArray_Multiple.splice(index, 1);
      // }

      this.SwitchMakeSelectedFalseMultiple(selectedData, 'NOTfilters');

      this.variablesSummaryObj = this.variablesSummaryObj.filter(
        (item: any) => {
          if (
            !(
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              item.Level3 == selectedData.Level3 &&
              item.Level4 == selectedData.Level4 &&
              item.Level5 == selectedData.Level5
            )
          )
            return item;
        },
      );

      // this.mandatoryMaxLimitReached = false;
      const count = numberOfCheckedCheckboxes ?? 0;

      if (count >= 6) {
        this.mandatoryMaxLimitReached = true;
      } else {
        this.mandatoryMaxLimitReached = false;
      }
      this.queuePanelRefresh();
    }

    (event as MouseEvent).stopPropagation();
    this.CheckIfMandatorySelected();
  }

  EPRadioClick(
    index: number,
    Level: number,
    Header: string,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
    responseCode: string,
    mandatory_variable_mapping: any[],
    isSelectAll: boolean,
    e1_variable_code: string,
    e2_variable_code: string,
    e3_variable_code: string,
    dimension: any[],
  ): void {
    // const entryPointKey =
    //   Level === 0 ? 'EntryPoint1' : Level === 1 ? 'EntryPoint2' : 'EntryPoint3';

    let entryPointKey = this.EPdataFor_Multiple.filter((a: any) =>
      a.variable_code.includes(variableCode),
    )
      .map((a: any) => a.variable_label)[0]
      .replaceAll(' ', '');

    if (Level === 0) {
      if (this.dataArray.length > 0) {
        if (
          this.dataArray[0].EntryPoint1 != undefined &&
          Object.keys(this.dataArray[0].EntryPoint1).length !== 0 &&
          this.dataArray[0].EntryPoint1.Level2[0].MetricOptions[0].Name ==
            MetricOptions
        ) {
          return;
        } else if (
          (this.isSavedScenarioSelected ||
            this._configService.isGlobalDefaultSelectionEnabled) &&
          this.selectedcompareacrossOption == 'Multiple Markets'
        ) {
          if (
            this.dataArray[0].EntryPoint2 != undefined &&
            Object.keys(this.dataArray[0].EntryPoint2).length !== 0 &&
            this.dataArray[0].EntryPoint2.Level2[0].MetricOptions[0].Name ==
              MetricOptions
          ) {
            return;
          }
        }
        if (this.dataArray[0].EntryPoint1 != undefined) {
          this.dataArray[0].EntryPoint1 = {};
        }
      }

      const entryPoint2Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint2'),
      );
      if (entryPoint2Index !== -1) {
        const entryPoint2 = this.dataArray[entryPoint2Index];

        const level2Index = entryPoint2['EntryPoint2'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions,
            ),
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint2['EntryPoint2'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions,
          );
          if (metricOptionIndex !== -1) {
            entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1,
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint2['EntryPoint2'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint2['EntryPoint2'].Level2.length === 0) {
                this.dataArray.splice(entryPoint2Index, 1);

                const entryPoint3Index = this.dataArray.findIndex((entry) =>
                  entry.hasOwnProperty('EntryPoint3'),
                );

                if (entryPoint3Index !== -1) {
                  this.dataArray.splice(entryPoint3Index, 1);
                }
              }
            }
          }
        }
        //const recordIndexToRemove = entryPoint2['EntryPoint2'].Level2.findIndex(
        //  (l2: any) =>
        //    l2.MetricOptions.some(
        //      (mo: any) => mo.Dependency === MetricOptions
        //    )
        //);
        //if (recordIndexToRemove !== -1) {
        //  entryPoint2['EntryPoint2'].Level2.splice(recordIndexToRemove, 1);
        //}
        //if (entryPoint2['EntryPoint2'].Level2.length === 0) {
        //  this.dataArray.splice(entryPoint2Index, 1);
        //}
      }

      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3'),
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions,
            ),
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions,
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1,
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    } else if (Level === 1) {
      if (this.dataArray.length > 1) {
        if (
          this.dataArray[1].EntryPoint2.Level2[0].MetricOptions[0].Name ==
          MetricOptions
        ) {
          return;
        }
        this.dataArray[1].EntryPoint2 = {};
      }

      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3'),
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e2 === e2_variable_code,
            ),
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e2 === e2_variable_code,
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1,
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    } else if (Level === 2) {
      if (this.dataArray.length > 2) {
        if (
          this.dataArray[2].EntryPoint3.Level2[0].MetricOptions[0].Name ==
          MetricOptions
        ) {
          return;
        }
        this.dataArray[2].EntryPoint3 = {};
      }
    }

    if (Level == 0) {
      this.entry_nested_items_expand1 = Level2;
    } else if (Level == 1) {
      this.entry_nested_items_expand2 = Level2;
    } else if (Level == 2) {
      this.entry_nested_items_expand3 = Level2;
    }

    const existingEntryIndex = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1,
    );

    if (existingEntryIndex !== -1) {
      // Entry with the same entryPointKey and Level1 exists
      const existingEntry = this.dataArray[existingEntryIndex];

      // Check if Level2 is different
      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === Level2,
      );

      if (existingLevel2Index !== -1) {
        // Level2 with the same Parent exists
        const existingMetricOptionIndex = existingEntry[entryPointKey].Level2[
          existingLevel2Index
        ].MetricOptions.findIndex((mo: any) => mo.Name === MetricOptions);

        if (existingMetricOptionIndex !== -1) {
          // MetricOptions is the same, remove it
          if (isSelectAll == false) {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.splice(existingMetricOptionIndex, 1);
          }
        } else {
          // MetricOptions is different, push it to the existing MetricOptions array

          const existingMetricOptionIndex = existingEntry[
            entryPointKey
          ].Level2.findIndex((mo: any) => {
            const existingMetricOptions = mo.MetricOptions;
            return existingMetricOptions.some(
              (existingMo: any) => existingMo.Name === MetricOptions,
            );
          });

          if (existingMetricOptionIndex !== -1) {
            if (isSelectAll == false) {
            }
          } else {
            //since single select
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions = [];

            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.push({
              Name: MetricOptions,
              responseCode: responseCode,
              isActive: true,
              Dependency_e1: e1_variable_code,
              Dependency_e2: e2_variable_code,
            });

            if (entryPointKey == 'EntryPoint1')
              this.selectedEP1 = MetricOptions;
            else if (entryPointKey == 'EntryPoint2')
              this.selectedEP2 = MetricOptions;
            else if (entryPointKey == 'EntryPoint3')
              this.selectedEP3 = MetricOptions;
          }
        }
      } else {
        const existingMetricOptionIndex = existingEntry[
          entryPointKey
        ].Level2.findIndex((mo: any) => {
          const existingMetricOptions = mo.MetricOptions;
          return (
            existingMetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions,
            ) !== -1
          );
        });

        if (existingMetricOptionIndex !== -1) {
          if (isSelectAll == false) {
            const metricOptionIndex = existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions,
            );
            existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.splice(metricOptionIndex, 1);
          }
        } else {
          //since single select
          existingEntry[entryPointKey].Level2 = [];

          // Level2 is different, push new Level2 and MetricOptions
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode,
                isActive: true,
                Dependency_e1: e1_variable_code,
                Dependency_e2: e2_variable_code,
              },
            ],
          });

          if (entryPointKey == 'EntryPoint1') this.selectedEP1 = MetricOptions;
          else if (entryPointKey == 'EntryPoint2')
            this.selectedEP2 = MetricOptions;
          else if (entryPointKey == 'EntryPoint3')
            this.selectedEP3 = MetricOptions;
        }
      }
    } else {
      // Create a new entry
      if (this.dataArray.some((entry) => entry.hasOwnProperty(entryPointKey))) {
        const existingEntryIndex = this.dataArray.findIndex((entry) =>
          entry.hasOwnProperty(entryPointKey),
        );
        if (existingEntryIndex !== -1) {
          const existingEntry = this.dataArray[existingEntryIndex];
          existingEntry[entryPointKey] = Object.assign(
            {},
            existingEntry[entryPointKey],
          );
          existingEntry[entryPointKey].Level1 = Level1;
          existingEntry[entryPointKey].Level2 = [];
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode,
                isActive: true,
                Dependency_e1: e1_variable_code,
                Dependency_e2: e2_variable_code,
              },
            ],
          });
          existingEntry[entryPointKey].variableCode = variableCode;
        }
      } else {
        const tempEntry = {
          [entryPointKey]: {
            Level1: Level1,
            Level2: [
              {
                Parent: Level2,
                MetricOptions: [
                  {
                    Name: MetricOptions,
                    responseCode: responseCode,
                    isActive: true,
                    Dependency_e1: e1_variable_code,
                    Dependency_e2: e2_variable_code,
                  },
                ],
              },
            ],
            variableCode: variableCode,
          },
          clientName: this.clientDetails.clientDetails.client_code.toString(),
          studyName: this.selected_study,
          mandatory_variable_mapping: mandatory_variable_mapping,
          dimension: dimension,
          isMandatoryLoadClicked:
            this.selectedcompareacrossOption == 'Multiple Markets' ||
            this.selectedcompareacrossOption == 'Multiple Categories'
              ? true
              : false,
          snapshotType: this.selectedcompareacrossOption,
        };
        this.dataArray.push(tempEntry);
        this.e1_forMultiple = e1_variable_code;
        this.e2_forMultiple = e2_variable_code;
        this.mandatory_variable_mapping_Multiple = mandatory_variable_mapping;
        this.dimension_Multiple = dimension;

        if (entryPointKey == 'EntryPoint1') this.selectedEP1 = MetricOptions;
        else if (entryPointKey == 'EntryPoint2')
          this.selectedEP2 = MetricOptions;
        else if (entryPointKey == 'EntryPoint3')
          this.selectedEP3 = MetricOptions;
      }
    }
    const existingEntryIndex1 = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1,
    );

    const existingEntry = this.dataArray[existingEntryIndex1];

    const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
      (l2: any) => l2.Parent === Level2,
    );
    if (
      this.entryPanel_Lvl3.filter(
        (a) => a.Level1 === Level1 && a.Level2 === Level2,
      ).length ===
        (existingLevel2Index !== -1
          ? existingEntry[entryPointKey].Level2[existingLevel2Index]
              .MetricOptions.length
          : 0) &&
      isSelectAll == false
    ) {
      this.isSelectAll = true;
    } else {
      if (isSelectAll == false) {
        this.isSelectAll = false;
      }
    }

    const variableTab = document.querySelector('.variableTab');
    if (variableTab) variableTab.classList.add('DN');
    this._rebuildToggleStatusCache();
    if (Level === 0 && this.isProductCategorySection) {
      this.maybeRefreshProductCategoryForAudience();
    }
    this.queuePanelRefresh();
    this.ClearAll();
  }

  @Input() onItemClick: ((event: MouseEvent) => void) | undefined;

  checkBoxClickNotEP(
    filters: string,
    event: Event,
    level1: string,
    level2: string,
    level3: string,
    level4: string,
    level5: string,
    level6: string,
    level7: string,
    level8: string,
    level9: string,
    level0: string = '',
    loadSel: boolean = false,
    SelectionFilterData: any = {},
    isFromGlobalSlection = false,
  ) {
    let numberOfCheckedCheckboxes;
    if (!loadSel) {
      const nearestLevelDiv = (event.target as HTMLElement).closest(
        'div[class*="variables-sub-itemsLev"]',
      );
      const checkedCheckboxes =
        this.isAggregatedData && filters == 'filters'
          ? nearestLevelDiv?.querySelectorAll('input[type="radio"]:checked')
          : nearestLevelDiv?.querySelectorAll('input[type="checkbox"]:checked');
      numberOfCheckedCheckboxes = checkedCheckboxes?.length;
    }

    let responseCode,
      variableLabel,
      year_code,
      is_brand_analysis,
      is_derived,
      calc_type,
      hasNextLevel,
      variable_code,
      sort_id,
      is_multi_punch,
      date,
      is_dimension,
      is_CustomGroup,
      kibanaFilterScript,
      customGroupId,
      dataYearCode,
      is_time_Period_Present,
      derived_metric_calculation,
      isSelected,
      Weekno_forSigcalculation;

    if (!loadSel) {
      if (
        (event.target as HTMLElement).classList.contains(
          'sub-items-names-parent',
        )
      ) {
        let elementParent = (event.target as HTMLElement).parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation',
        );
        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis',
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript',
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present',
        );
        Weekno_forSigcalculation = elementParent?.getAttribute(
          'data-Weekno_forSigcalculation',
        );

        isSelected = elementParent?.getAttribute('data-is_selected');
      } else {
        let elementParent = (event.target as HTMLElement).parentElement
          ?.parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation',
        );

        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis',
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript',
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present',
        );
        Weekno_forSigcalculation = elementParent?.getAttribute(
          'data-Weekno_forSigcalculation',
        );

        isSelected = elementParent?.getAttribute('data-is_selected');
      }
    } else {
      responseCode = SelectionFilterData.response_code;
      derived_metric_calculation =
        SelectionFilterData.derived_metric_calculation;
      variableLabel = SelectionFilterData.variable_label;
      Level0: level0;
      level1 = SelectionFilterData.Level1;
      level2 = SelectionFilterData.Level2;
      level3 = SelectionFilterData.Level3;
      level4 = SelectionFilterData.Level4;
      level5 = SelectionFilterData.Level5;
      level6 = SelectionFilterData.Level6;
      level7 = SelectionFilterData.Level7;
      level8 = SelectionFilterData.Level8;
      level9 = SelectionFilterData.Level9;
      year_code = SelectionFilterData.year_code;
      is_brand_analysis = SelectionFilterData.is_brand_analysis;
      is_derived = SelectionFilterData.is_derived;
      calc_type = SelectionFilterData.calc_type;
      hasNextLevel = SelectionFilterData.hasNextLevel;
      variable_code = SelectionFilterData.variable_code;
      sort_id = SelectionFilterData.sort_id;
      is_multi_punch = SelectionFilterData.is_multi_punch;
      date = SelectionFilterData.date;
      is_dimension = SelectionFilterData.s_dimension;
      is_CustomGroup = SelectionFilterData.is_CustomGroup;
      kibanaFilterScript = SelectionFilterData.kibanaFilterScript;
      customGroupId = SelectionFilterData.customGroupId;
      dataYearCode = SelectionFilterData.dataYearCode;
      is_time_Period_Present = SelectionFilterData.is_time_Period_Present;
      isSelected = SelectionFilterData.is_selected ?? false;
      Weekno_forSigcalculation = SelectionFilterData.Weekno_forSigcalculation;
    }

    const selectedData = {
      response_code: responseCode,
      derived_metric_calculation: derived_metric_calculation,
      variable_label: variableLabel,
      Level0: level0,
      Level1: level1,
      Level2: level2,
      Level3: level3,
      Level4: level4,
      Level5: level5,
      Level6: level6,
      Level7: level7,
      Level8: level8,
      Level9: level9,
      year_code: year_code,
      is_brand_analysis: is_brand_analysis,
      is_derived: is_derived,
      calc_type: calc_type,
      hasNextLevel: hasNextLevel,
      variable_code: variable_code,
      sort_id: sort_id,
      is_multi_punch: is_multi_punch,
      date: date,
      is_dimension: is_dimension,
      is_CustomGroup: is_CustomGroup,
      kibanaFilterScript: kibanaFilterScript,
      customGroupId: customGroupId,
      dataYearCode: dataYearCode,
      is_time_Period_Present: is_time_Period_Present,
      Weekno_forSigcalculation: Weekno_forSigcalculation,
    };
    const objKey =
      selectedData.Level0 === 'Audience'
        ? selectedData.Level0
        : selectedData.Level0;
    if (isSelected !== 'true') {
      // Hard block: prevent more than 6 Default brands from being selected (interactive or loaded)
      // Allow mirror calls through (they keep the paired Level1 group in sync)
      if (
        !this._isMirroringBrandSelection &&
        level0 === 'Brands' &&
        this.defaultBrandList?.length > 0
      ) {
        const brandsVar = this.variableList?.find(
          (item: any) => item.Level0 === 'Brands',
        );
        const guardCount = brandsVar
          ? (brandsVar.Level1 || [])
              .filter((l1: any) => l1.Level1_value === level1)
              .flatMap((l1: any) =>
                (l1.Level2 || [])
                  .filter((l2: any) => l2.is_selected)
                  .map((l2: any) => l2.Level2_value),
              ).length
          : 0;
        if (guardCount >= 6) {
          return;
        }
      }
      if (this.selectedObjects.some((obj) => obj[objKey])) {
        const selectedObj = this.selectedObjects.find((obj) => obj[objKey]);
        if (
          this.isAggregatedData &&
          filters == 'filters' &&
          selectedData.Level1 != 'KPI' &&
          !isFromGlobalSlection
        ) {
          selectedObj[selectedData.Level1].forEach((element: any) => {
            this.SwitchMakeSelectedFalse(element, filters);
          });
          selectedObj[selectedData.Level1] = [];

          this.variablesSummaryObj = this.variablesSummaryObj.map(
            (item: any) => {
              if (item.Level1 === selectedData.Level1) {
                return selectedData;
              }
              return item;
            },
          );
        } else {
          this.variablesSummaryObj.push(selectedData);
        }
        if (!isFromGlobalSlection) {
          // Check if data already exists before pushing
          const dataExists = selectedObj[objKey].some((item: any) => {
            return (
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              (item.Level3 ?? '') == (selectedData.Level3 ?? '') &&
              (item.Level4 ?? '') == (selectedData.Level4 ?? '') &&
              (item.Level5 ?? '') == (selectedData.Level5 ?? '')
            );
          });
          if (!dataExists) {
            selectedObj[objKey].push(selectedData);
          }
        }
      } else {
        this.selectedObjects.push({ [objKey]: [selectedData] });
        this.variablesSummaryObj.push(selectedData);
      }
      this.SwitchMakeSelectedTrue(selectedData, filters);
      //this.variablesSummaryObj.push(selectedData);

      const target = event?.target as HTMLElement;
      // Count unique Default brand names from variableList (works regardless of isFromGlobalSlection flag)
      const brandsVar1 = this.variableList?.find(
        (item: any) => item.Level0 === 'Brands',
      );

      let brandselectedlengh = brandsVar1
        ? (brandsVar1.Level1 || [])
            .filter((l1: any) => l1.Level1_value === level1)
            .flatMap((l1: any) =>
              (l1.Level2 || [])
                .filter((l2: any) => l2.is_selected)
                .map((l2: any) => l2.Level2_value),
            ).length
        : 0;
      const customLength = this.selectedObjects.reduce(
        (sum: number, obj: any) => {
          const arr: any[] = obj[Object.keys(obj)[0]] ?? [];
          return arr.length > 0 && arr[0].Level0 === 'Audience'
            ? sum + arr.length
            : sum;
        },
        0,
      );

      this.audienceLimit = customLength >= 3 ? true : false;
      if (
        (brandselectedlengh !== undefined && brandselectedlengh >= 6) ||
        customLength >= 3
      ) {
        this.mandatoryMaxLimitReached = true;
      } else {
        this.mandatoryMaxLimitReached = false;
      }
      this.queuePanelRefresh();
    } else {
      const selectedObj = this.selectedObjects.find((obj) => obj[objKey]);
      if (selectedObj) {
        const index = selectedObj[objKey].findIndex((item: any) => {
          if (
            item.response_code == selectedData.response_code &&
            item.variable_label == selectedData.variable_label &&
            item.Level1 == selectedData.Level1 &&
            item.Level2 == selectedData.Level2 &&
            (item.Level3 ?? '') == (selectedData.Level3 ?? '') &&
            (item.Level4 ?? '') == (selectedData.Level4 ?? '') &&
            (item.Level5 ?? '') == (selectedData.Level5 ?? '') &&
            (item.Level6 ?? '') == (selectedData.Level6 ?? '') &&
            (item.Level7 ?? '') == (selectedData.Level7 ?? '') &&
            (item.Level8 ?? '') == (selectedData.Level8 ?? '') &&
            (item.Level9 ?? '') == (selectedData.Level9 ?? '')
          )
            return item;
        });
        if (index !== -1) {
          selectedObj[objKey].splice(index, 1);
        }
      }

      this.SwitchMakeSelectedFalse(selectedData, filters);

      this.variablesSummaryObj = this.variablesSummaryObj.filter(
        (item: any) => {
          if (
            !(
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              (item.Level3 ?? '') == (selectedData.Level3 ?? '') &&
              (item.Level4 ?? '') == (selectedData.Level4 ?? '') &&
              (item.Level5 ?? '') == (selectedData.Level5 ?? '') &&
              (item.Level6 ?? '') == (selectedData.Level6 ?? '') &&
              (item.Level7 ?? '') == (selectedData.Level7 ?? '') &&
              (item.Level8 ?? '') == (selectedData.Level8 ?? '') &&
              (item.Level9 ?? '') == (selectedData.Level9 ?? '')
            )
          )
            return item;
        },
      );

      // Count unique Default brands from variableList after deselection (SwitchMakeSelectedFalse already ran)
      const brandsVar2 = this.variableList?.find(
        (item: any) => item.Level0 === 'Brands',
      );
      const count = brandsVar2
        ? new Set(
            (brandsVar2.Level1 || []).flatMap((l1: any) =>
              (l1.Level2 || [])
                .filter(
                  (l2: any) =>
                    l2.is_selected &&
                    this.defaultBrandList?.includes(l2.Level2_value),
                )
                .map((l2: any) => l2.Level2_value),
            ),
          ).size
        : 0;
      const customLength = this.selectedObjects.reduce(
        (sum: number, obj: any) => {
          const arr: any[] = obj[Object.keys(obj)[0]] ?? [];
          return arr.length > 0 && arr[0].Level0 === 'Audience'
            ? sum + arr.length
            : sum;
        },
        0,
      );

      this.audienceLimit = customLength >= 3 ? true : false;
      if (count >= 6 || customLength >= 3) {
        this.mandatoryMaxLimitReached = true;
      } else {
        this.mandatoryMaxLimitReached = false;
      }
      this.queuePanelRefresh();
    }

    // STEP 1: Update saved selection list
    this.updateSavedSelectionsFromData(this.selectedObjects);

    // Mirror between "Default" ↔ "Brands"
    if (this.defaultBrandList.length > 0) {
      if (!this._isMirroringBrandSelection && level0 === 'Brands') {
        const brandsVariableItem = this.variableList.find(
          (item: any) => item.Level0 === 'Brands',
        );
        if (brandsVariableItem) {
          const targetLevel1 =
            level1 === 'Default'
              ? brandsVariableItem.Level1?.find(
                  (l1: any) => l1.Level1_value !== 'Default',
                )
              : brandsVariableItem.Level1?.find(
                  (l1: any) => l1.Level1_value === 'Default',
                );

          if (targetLevel1) {
            const matchingLevel2 = (targetLevel1.Level2 || []).find(
              (l2: any) => l2.Level2_value === level2,
            );
            if (matchingLevel2) {
              // Mirror the same action (select/deselect) from source to target
              const selection = this.buildSelectedObject(
                'Brands',
                targetLevel1,
                matchingLevel2,
                '',
              );
              // isSelected === 'true' means the source item was selected and user is deselecting it
              selection.is_selected = isSelected === 'true' ? 'true' : false;
              matchingLevel2.is_selected = isSelected !== 'true';

              this._isMirroringBrandSelection = true;
              try {
                this.checkBoxClickNotEP(
                  filters,
                  event,
                  selection.Level1,
                  selection.Level2,
                  selection.Level3,
                  selection.Level4,
                  selection.Level5,
                  selection.Level6 || '',
                  selection.Level7 || '',
                  selection.Level8 || '',
                  selection.Level9 || '',
                  'Brands',
                  true,
                  selection,
                );
              } finally {
                this._isMirroringBrandSelection = false;
              }
            }
          }
        }
      }
    }

    (event as MouseEvent).stopPropagation();
  }

  checkBoxClickNotEPRadio(
    filters: string,
    event: Event,
    level1: string,
    level2: string,
    level3: string,
    level4: string,
    level5: string,
    thisLevelDataChildren: any,
    level: string,
    thisLevelData: any,
    level0: string,
    loadSel: boolean,
  ) {
    let responseCode,
      variableLabel,
      year_code,
      is_brand_analysis,
      is_derived,
      calc_type,
      hasNextLevel,
      variable_code,
      sort_id,
      is_multi_punch,
      date,
      is_dimension,
      is_CustomGroup,
      kibanaFilterScript,
      customGroupId,
      dataYearCode,
      is_time_Period_Present,
      derived_metric_calculation,
      Weekno_forSigcalculation;
    if (!loadSel) {
      if (
        (event.target as HTMLElement).classList.contains(
          'sub-items-names-parent',
        )
      ) {
        let elementParent = (event.target as HTMLElement).parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation',
        );
        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis',
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript',
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present',
        );
        Weekno_forSigcalculation = elementParent?.getAttribute(
          'data-Weekno_forSigcalculation',
        );
      } else {
        let elementParent = (event.target as HTMLElement).parentElement
          ?.parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation',
        );

        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis',
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript',
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present',
        );
        Weekno_forSigcalculation = elementParent?.getAttribute(
          'data-Weekno_forSigcalculation',
        );
      }
    } else {
      let loadselectionData = thisLevelDataChildren?.find(
        (item: any) => item.Level2_value === level2,
      );

      if (
        this._configService.isGlobalDefaultSelectionEnabled &&
        !loadselectionData &&
        level3
      ) {
        loadselectionData = thisLevelDataChildren?.find(
          (item: any) => item.Level3_value === level3,
        );
      }
      responseCode = loadselectionData?.response_code;
      derived_metric_calculation =
        loadselectionData?.derived_metric_calculation;
      variableLabel =
        this._configService.isGlobalDefaultSelectionEnabled && level3
          ? loadselectionData?.Level3_value
          : loadselectionData?.Level2_value;
      level0 = level0;
      level1 = level1;
      level2 = level2;
      level3 = level3;
      level4 = level4;
      level5 = level5;
      year_code = loadselectionData?.year_code;
      is_brand_analysis = loadselectionData.is_brand_analysis;
      is_derived = loadselectionData.is_derived;
      calc_type = loadselectionData.calc_type;
      hasNextLevel = loadselectionData.hasNextLevel;
      variable_code = loadselectionData.data_variable_code;
      sort_id = loadselectionData.sort_id;
      is_multi_punch = loadselectionData.is_multi_punch;
      date = loadselectionData.date;
      is_dimension = loadselectionData.is_dimension;
      is_CustomGroup = loadselectionData.isCustomGrpPresent;
      kibanaFilterScript = loadselectionData.kibanaFilterScript;
      customGroupId = loadselectionData.customGroupId;
      dataYearCode = loadselectionData.dataYearCode;
      is_time_Period_Present = loadselectionData.is_time_Period_Present;
      Weekno_forSigcalculation = loadselectionData.Weekno_forSigcalculation;
    }

    let selectedData: {
      response_code: any;
      derived_metric_calculation: any;
      variable_label: any;
      Level0: string;
      Level1: string;
      Level2: string;
      Level3: string;
      Level4: string;
      Level5: string;
      year_code: any;
      is_brand_analysis: any;
      is_derived: any;
      calc_type: any;
      hasNextLevel: any;
      variable_code: any;
      sort_id: any;
      is_multi_punch: any;
      date: any;
      is_dimension: any;
      is_CustomGroup: any;
      kibanaFilterScript: any;
      customGroupId: any;
      dataYearCode: any;
      is_time_Period_Present: any;
      Weekno_forSigcalculation: any;
      isMostRecent?: boolean;
    } = {
      response_code: responseCode,
      derived_metric_calculation: derived_metric_calculation,
      variable_label: variableLabel,
      Level0: level0,
      Level1: level1,
      Level2: level2,
      Level3: level3,
      Level4: level4,
      Level5: level5,
      year_code: year_code,
      is_brand_analysis: is_brand_analysis,
      is_derived: is_derived,
      calc_type: calc_type,
      hasNextLevel: hasNextLevel,
      variable_code: variable_code,
      sort_id: sort_id,
      is_multi_punch: is_multi_punch,
      date: date,
      is_dimension: is_dimension,
      is_CustomGroup: is_CustomGroup,
      kibanaFilterScript: kibanaFilterScript,
      customGroupId: customGroupId,
      dataYearCode: dataYearCode,
      is_time_Period_Present: is_time_Period_Present,
      Weekno_forSigcalculation: Weekno_forSigcalculation,
    };

    if (
      selectedData.Level0 == 'Time Period' &&
      (isMostRecentTimePeriodLabel(selectedData.Level2) ||
        selectedData.isMostRecent)
    ) {
      selectedData.isMostRecent = true;
    }

    if (selectedData.Level0 == 'Time Period') {
      // Display stays "Most recent"; filter/API key must be the concrete latest period.
      this._configService.selectedTPforNonTrendView =
        getResolvedTimePeriodChildKey(selectedData, this.variableList);
    }

    if (
      !this.variablesSummaryObjRadio.some(
        (obj: any) => obj.Level1 === selectedData.Level1,
      ) &&
      !this.variablesSummaryObjRadio.some(
        (obj: any) => obj.Level0 === selectedData.Level0,
      )
    )
      this.variablesSummaryObjRadio.push(selectedData);
    else {
      const index = this.variablesSummaryObjRadio.findIndex(
        (item: any) => item.Level0 === selectedData.Level0,
      );
      this.variablesSummaryObjRadio.splice(index, 1);
      this.variablesSummaryObjRadio.push(selectedData);
    }

    //this.selectedObjects[selectedData.Level1] = [selectedData];

    switch (filters) {
      case 'NOTfilters':
        this.variableList.forEach((item) => {
          if (item.Level0 === selectedData.Level0) {
            item?.Level1?.forEach((level1Item) => {
              level1Item.is_selected = false;
              level1Item?.Level2?.forEach((level2Item: any) => {
                level2Item.is_selected = false;
                level2Item?.Level3?.forEach((level3Item: any) => {
                  level3Item.is_selected = false;
                  level3Item?.Level4?.forEach((level4Item: any) => {
                    level4Item.is_selected = false;
                    level4Item?.Level5?.forEach((level5Item: any) => {
                      level5Item.is_selected = false;
                    });
                  });
                });
              });
            });
          }
        });

        thisLevelDataChildren = Array.isArray(thisLevelDataChildren)
          ? thisLevelDataChildren
          : thisLevelDataChildren
            ? [thisLevelDataChildren]
            : [];

        thisLevelDataChildren.forEach((a: any) => {
          //
          if (
            a[(level + '_value') as keyof typeof a] ===
            selectedData[level as keyof typeof selectedData]
          ) {
            a.is_selected = true;
          }
        });
        thisLevelData.is_selected = true;

        let condition = false;
        this.selectedObjects.forEach((obj: any) => {
          if (obj[selectedData.Level0]?.length > 0) {
            condition = true;
          }
        });
        if (!condition) {
          this.selectedObjects.push({ [selectedData.Level0]: [selectedData] });
        } else
          this.selectedObjects.forEach((obj: any) => {
            if (obj.hasOwnProperty(selectedData.Level0))
              obj[selectedData.Level0] = [selectedData];
          });

        break;

      case 'filters':
        this.variableListFilter.forEach((item) => {
          if (item.LevelMinus === selectedData.Level0) {
            item.Level1.forEach((level1Item) => {
              if (level1Item.Level0 === selectedData.Level1) {
                level1Item.is_selected = false;
                level1Item.Level1.forEach((level2Item: any) => {
                  level2Item.is_selected = false;
                  level2Item.Level2.forEach((level3Item: any) => {
                    level3Item.is_selected = false;
                    level3Item.Level3.forEach((level4Item: any) => {
                      level4Item.is_selected = false;
                      level4Item.Level4.forEach((level5Item: any) => {
                        level5Item.is_selected = false;
                      });
                    });
                  });
                });
              }
            });
          }
        });

        thisLevelDataChildren.forEach((a: any) => {
          if (
            a[(level + '_value') as keyof typeof a] ===
            selectedData[level as keyof typeof selectedData]
          ) {
            a.is_selected = true;
          }
        });
        thisLevelData.is_selected = true;

        let condition1 = false;
        this.selectedObjects.forEach((obj: any) => {
          if (obj[selectedData.Level1].length > 0) {
            condition1 = true;
          }
        });
        if (!condition1) {
          this.selectedObjects.push({ [selectedData.Level1]: [selectedData] });
        } else
          this.selectedObjects.forEach((obj: any) => {
            if (obj.hasOwnProperty(selectedData.Level1))
              obj[selectedData.Level1] = [selectedData];
          });

        break;
    }

    this.CheckIfMandatorySelected();
    this.updateSavedSelectionsFromData(this.selectedObjects, 'radio');

    (event as MouseEvent).stopPropagation();
  }

  savedSelections: any[] = [];
  getEPGroupName(variableCode: string): string {
    return this._varCodeToEntryKeyCache.get(variableCode) ?? 'ep_group_default';
  }
  updateSavedSelectionsFromData(data: any, type: string = '') {
    this.savedSelections = [];

    if (Array.isArray(data)) {
      const merged: any = {};
      data.forEach((item: any) => {
        Object.keys(item).forEach((key) => {
          if (
            merged[key] &&
            Array.isArray(merged[key]) &&
            Array.isArray(item[key])
          ) {
            merged[key] = [...merged[key], ...item[key]];
          } else {
            merged[key] = item[key];
          }
        });
      });
      data = merged;
    }

    Object.keys(data).forEach((bucketKey) => {
      const arr = data[bucketKey];
      if (!Array.isArray(arr)) return;

      const audienceItems = arr.filter((x) => x.Level0 === 'Audience');
      if (!audienceItems.length) return;

      const grouped: any = {};

      audienceItems.forEach((item) => {
        const levels: string[] = [];
        for (let i = 1; i <= 10; i++) {
          if (item[`Level${i}`]) levels.push(item[`Level${i}`]);
        }

        if (levels.length < 1) return;

        const last3 = levels.slice(-3);

        const level2 = last3.length >= 2 ? last3[last3.length - 2] : last3[0];
        const level3 = last3[last3.length - 1];

        if (!grouped[level2])
          grouped[level2] = { last3Hierarchy: [], lastLevelValues: [] };

        grouped[level2].last3Hierarchy = last3.slice(0, -1);
        grouped[level2].lastLevelValues.push(level3);
      });

      Object.keys(grouped).forEach((level2) => {
        const grp = grouped[level2];

        this.savedSelections.push({
          hierarchy: grp.last3Hierarchy,
          lastLevelValues: [...new Set(grp.lastLevelValues)],
        });
      });
    });

    this.audienceTooltip = this.buildAudienceTooltip(this.savedSelections);
  }

  buildAudienceTooltip(data: any[]) {
    if (!data || data.length === 0) return 'No selections';

    return data
      .sort((a, b) => {
        const hA = a.hierarchy.join(' : ');
        const hB = b.hierarchy.join(' : ');

        // items with empty h appear FIRST
        if (hA === '' && hB !== '') return -1;
        if (hA !== '' && hB === '') return 1;
        return 0;
      })
      .map((item) => {
        const h = item.hierarchy.join(' : ');
        const boldValues = item.lastLevelValues
          .map((v: any) => `<b>${v}</b>`)
          .join(', ');

        return h !== '' ? `${h} : ${boldValues}` : `${boldValues}`;
      })
      .join('<br>');
  }

  SwitchMakeSelectedTrue(selectedData: any, filters: string) {
    switch (filters) {
      case 'NOTfilters':
        for (const levelMinus of this.variableList) {
          const level1 = levelMinus.Level1.find(
            (l: any) => l.Level1_value === selectedData.Level1,
          );
          if (!level1) continue;
          level1.is_selected = true;
          const level2 = level1.Level2?.find(
            (l: any) => l.Level2_value === selectedData.Level2,
          );
          if (!level2) continue;
          level2.is_selected = true;
          const level3 = level2.Level3?.find(
            (l: any) => l.Level3_value === selectedData.Level3,
          );
          if (!level3) continue;
          level3.is_selected = true;
          const level4 = level3.Level4?.find(
            (l: any) => l.Level4_value === selectedData.Level4,
          );
          if (!level4) continue;
          level4.is_selected = true;
          const level5 = level4.Level5?.find(
            (l: any) => l.Level5_value === selectedData.Level5,
          );
          if (!level5) continue;
          level5.is_selected = true;
          const level6 = level5.Level6?.find(
            (l: any) => l.Level6_value === selectedData.Level6,
          );
          if (!level6) continue;
          level6.is_selected = true;
          const level7 = level6.Level7?.find(
            (l: any) => l.Level7_value === selectedData.Level7,
          );
          if (!level7) continue;
          level7.is_selected = true;
          const level8 = level7.Level8?.find(
            (l: any) => l.Level8_value === selectedData.Level8,
          );
          if (!level8) continue;
          level8.is_selected = true;
          const level9 = level8.Level9?.find(
            (l: any) => l.Level9_value === selectedData.Level9,
          );
          if (level9) level9.is_selected = true;
        }
        break;
      case 'filters':
        for (const levelMinus of this.variableListFilter) {
          const level1 = levelMinus.Level1.find(
            (l: any) => l.Level0 === selectedData.Level1,
          );
          if (!level1) continue;
          level1.is_selected = true;
          const level2 = level1.Level1?.find(
            (l: any) => l.Level1_value === selectedData.Level2,
          );
          if (!level2) continue;
          level2.is_selected = true;
          const level3 = level2.Level2?.find(
            (l: any) => l.Level2_value === selectedData.Level3,
          );
          if (!level3) continue;
          level3.is_selected = true;
          const level4 = level3.Level3?.find(
            (l: any) => l.Level3_value === selectedData.Level4,
          );
          if (!level4) continue;
          level4.is_selected = true;
          const level5 = level4.Level4?.find(
            (l: any) => l.Level4_value === selectedData.Level5,
          );
          if (!level5) continue;
          level5.is_selected = true;
          const level6 = level5.Level5?.find(
            (l: any) => l.Level5_value === selectedData.Level6,
          );
          if (!level6) continue;
          level6.is_selected = true;
          const level7 = level6.Level6?.find(
            (l: any) => l.Level6_value === selectedData.Level7,
          );
          if (!level7) continue;
          level7.is_selected = true;
          const level8 = level7.Level7?.find(
            (l: any) => l.Level7_value === selectedData.Level8,
          );
          if (!level8) continue;
          level8.is_selected = true;
          const level9 = level8.Level8?.find(
            (l: any) => l.Level8_value === selectedData.Level9,
          );
          if (level9) level9.is_selected = true;
        }
        break;
      default:
        break;
    }
    this.CheckIfMandatorySelected();
  }

  SwitchMakeSelectedFalse(selectedData: any, filters: string) {
    let values = Object.values(this.selectedObjects);
    switch (filters) {
      case 'NOTfilters':
        for (let i = 0; i < Object.keys(this.selectedObjects).length; i++) {
          // Skip buckets that don't match the deselected item's group.
          if (Object.keys(values[i] as any)[0] !== selectedData.Level0)
            continue;
          let value1 = Object.values(values[i]);
          let value = value1[0] as any[];

          for (const levelMinus of this.variableList) {
            const level1 = levelMinus.Level1.find(
              (l: any) => l.Level1_value === selectedData.Level1,
            );
            if (!level1) continue;
            const level2 = level1.Level2?.find(
              (l: any) => l.Level2_value === selectedData.Level2,
            );
            if (level2) {
              const level3 = level2.Level3?.find(
                (l: any) => l.Level3_value === selectedData.Level3,
              );
              if (level3) {
                const level4 = level3.Level4?.find(
                  (l: any) => l.Level4_value === selectedData.Level4,
                );
                if (level4) {
                  const level5 = level4.Level5?.find(
                    (l: any) => l.Level5_value === selectedData.Level5,
                  );
                  if (level5) level5.is_selected = false;
                  if (
                    value.filter(
                      (a: any) =>
                        a.Level1 === selectedData.Level1 &&
                        a.Level2 === selectedData.Level2 &&
                        a.Level3 === selectedData.Level3 &&
                        a.Level4 === selectedData.Level4,
                    ).length === 0
                  )
                    level4.is_selected = false;
                }
                if (
                  value.filter(
                    (a: any) =>
                      a.Level1 === selectedData.Level1 &&
                      a.Level2 === selectedData.Level2 &&
                      a.Level3 === selectedData.Level3,
                  ).length === 0
                )
                  level3.is_selected = false;
              }
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2,
                ).length === 0
              )
                level2.is_selected = false;
            }
            if (
              value.filter((a: any) => a.Level1 === selectedData.Level1)
                .length === 0
            )
              level1.is_selected = false;
          }
        }
        break;
      case 'filters':
        for (let i = 0; i < Object.keys(this.selectedObjects).length; i++) {
          const bucketKey = Object.keys(values[i] as any)[0];
          if (bucketKey !== selectedData.Level1 && bucketKey !== '') continue;
          let value1 = Object.values(values[i]);
          let allValues = value1[0] as any[];
          // When items are stored under '' key (level0 empty), filter to the matching Level1 group
          let value =
            bucketKey === ''
              ? allValues.filter((a: any) => a.Level1 === selectedData.Level1)
              : allValues;

          const noChildren = (arr: any[]) =>
            !arr?.length || arr.every((a: any) => !a.is_selected);

          for (const levelMinus of this.variableListFilter) {
            const level1 = levelMinus.Level1.find(
              (l: any) => l.Level0 === selectedData.Level1,
            );
            if (!level1) continue;

            const level2 = level1.Level1?.find(
              (l: any) => l.Level1_value === selectedData.Level2,
            );
            if (!level2) {
              if (
                value.filter((a: any) => a.Level1 === selectedData.Level1)
                  .length === 0 &&
                noChildren(level1.Level1)
              )
                level1.is_selected = false;
              continue;
            }

            const level3 = selectedData.Level3
              ? level2.Level2?.find(
                  (l: any) => l.Level2_value === selectedData.Level3,
                )
              : undefined;
            if (!level3) {
              // Leaf at level2
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2,
                ).length === 0
              )
                level2.is_selected = false;
              if (
                value.filter((a: any) => a.Level1 === selectedData.Level1)
                  .length === 0 &&
                noChildren(level1.Level1)
              )
                level1.is_selected = false;
              continue;
            }

            const level4 = selectedData.Level4
              ? level3.Level3?.find(
                  (l: any) => l.Level3_value === selectedData.Level4,
                )
              : undefined;
            if (!level4) {
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3,
                ).length === 0
              )
                level3.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2,
                ).length === 0 &&
                noChildren(level2.Level2)
              )
                level2.is_selected = false;
              if (
                value.filter((a: any) => a.Level1 === selectedData.Level1)
                  .length === 0 &&
                noChildren(level1.Level1)
              )
                level1.is_selected = false;
              continue;
            }

            const level5 = selectedData.Level5
              ? level4.Level4?.find(
                  (l: any) => l.Level4_value === selectedData.Level5,
                )
              : undefined;
            if (!level5) {
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3 &&
                    a.Level4 === selectedData.Level4,
                ).length === 0
              )
                level4.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3,
                ).length === 0 &&
                noChildren(level3.Level3)
              )
                level3.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2,
                ).length === 0 &&
                noChildren(level2.Level2)
              )
                level2.is_selected = false;
              if (
                value.filter((a: any) => a.Level1 === selectedData.Level1)
                  .length === 0 &&
                noChildren(level1.Level1)
              )
                level1.is_selected = false;
              continue;
            }

            const level6 = selectedData.Level6
              ? level5.Level5?.find(
                  (l: any) => l.Level5_value === selectedData.Level6,
                )
              : undefined;
            if (!level6) {
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3 &&
                    a.Level4 === selectedData.Level4 &&
                    a.Level5 === selectedData.Level5,
                ).length === 0
              )
                level5.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3 &&
                    a.Level4 === selectedData.Level4,
                ).length === 0 &&
                noChildren(level4.Level4)
              )
                level4.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3,
                ).length === 0 &&
                noChildren(level3.Level3)
              )
                level3.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2,
                ).length === 0 &&
                noChildren(level2.Level2)
              )
                level2.is_selected = false;
              if (
                value.filter((a: any) => a.Level1 === selectedData.Level1)
                  .length === 0 &&
                noChildren(level1.Level1)
              )
                level1.is_selected = false;
              continue;
            }

            const level7 = selectedData.Level7
              ? level6.Level6?.find(
                  (l: any) => l.Level6_value === selectedData.Level7,
                )
              : undefined;
            if (!level7) {
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3 &&
                    a.Level4 === selectedData.Level4 &&
                    a.Level5 === selectedData.Level5 &&
                    a.Level6 === selectedData.Level6,
                ).length === 0
              )
                level6.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3 &&
                    a.Level4 === selectedData.Level4 &&
                    a.Level5 === selectedData.Level5,
                ).length === 0 &&
                noChildren(level5.Level5)
              )
                level5.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3 &&
                    a.Level4 === selectedData.Level4,
                ).length === 0 &&
                noChildren(level4.Level4)
              )
                level4.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3,
                ).length === 0 &&
                noChildren(level3.Level3)
              )
                level3.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2,
                ).length === 0 &&
                noChildren(level2.Level2)
              )
                level2.is_selected = false;
              if (
                value.filter((a: any) => a.Level1 === selectedData.Level1)
                  .length === 0 &&
                noChildren(level1.Level1)
              )
                level1.is_selected = false;
              continue;
            }

            const level8 = selectedData.Level8
              ? level7.Level7?.find(
                  (l: any) => l.Level7_value === selectedData.Level8,
                )
              : undefined;
            if (level8) {
              const level9 = level8.Level8?.find(
                (l: any) => l.Level8_value === selectedData.Level9,
              );
              if (level9) level9.is_selected = false;
              if (
                value.filter(
                  (a: any) =>
                    a.Level1 === selectedData.Level1 &&
                    a.Level2 === selectedData.Level2 &&
                    a.Level3 === selectedData.Level3 &&
                    a.Level4 === selectedData.Level4 &&
                    a.Level5 === selectedData.Level5 &&
                    a.Level6 === selectedData.Level6 &&
                    a.Level7 === selectedData.Level7 &&
                    a.Level8 === selectedData.Level8,
                ).length === 0 &&
                noChildren(level8.Level8)
              )
                level8.is_selected = false;
            } else {
              level7.is_selected = false;
            }
            if (
              value.filter(
                (a: any) =>
                  a.Level1 === selectedData.Level1 &&
                  a.Level2 === selectedData.Level2 &&
                  a.Level3 === selectedData.Level3 &&
                  a.Level4 === selectedData.Level4 &&
                  a.Level5 === selectedData.Level5 &&
                  a.Level6 === selectedData.Level6 &&
                  a.Level7 === selectedData.Level7,
              ).length === 0 &&
              noChildren(level7.Level7)
            )
              level7.is_selected = false;
            if (
              value.filter(
                (a: any) =>
                  a.Level1 === selectedData.Level1 &&
                  a.Level2 === selectedData.Level2 &&
                  a.Level3 === selectedData.Level3 &&
                  a.Level4 === selectedData.Level4 &&
                  a.Level5 === selectedData.Level5 &&
                  a.Level6 === selectedData.Level6,
              ).length === 0 &&
              noChildren(level6.Level6)
            )
              level6.is_selected = false;
            if (
              value.filter(
                (a: any) =>
                  a.Level1 === selectedData.Level1 &&
                  a.Level2 === selectedData.Level2 &&
                  a.Level3 === selectedData.Level3 &&
                  a.Level4 === selectedData.Level4 &&
                  a.Level5 === selectedData.Level5,
              ).length === 0 &&
              noChildren(level5.Level5)
            )
              level5.is_selected = false;
            if (
              value.filter(
                (a: any) =>
                  a.Level1 === selectedData.Level1 &&
                  a.Level2 === selectedData.Level2 &&
                  a.Level3 === selectedData.Level3 &&
                  a.Level4 === selectedData.Level4,
              ).length === 0 &&
              noChildren(level4.Level4)
            )
              level4.is_selected = false;
            if (
              value.filter(
                (a: any) =>
                  a.Level1 === selectedData.Level1 &&
                  a.Level2 === selectedData.Level2 &&
                  a.Level3 === selectedData.Level3,
              ).length === 0 &&
              noChildren(level3.Level3)
            )
              level3.is_selected = false;
            if (
              value.filter(
                (a: any) =>
                  a.Level1 === selectedData.Level1 &&
                  a.Level2 === selectedData.Level2,
              ).length === 0 &&
              noChildren(level2.Level2)
            )
              level2.is_selected = false;
            if (
              value.filter((a: any) => a.Level1 === selectedData.Level1)
                .length === 0 &&
              noChildren(level1.Level1)
            )
              level1.is_selected = false;
          }
        }
        break;
      default:
        break;
    }

    this.CheckIfMandatorySelected();
  }

  SwitchMakeSelectedTrueMultiple(selectedData: any, filters: string) {
    switch (filters) {
      case 'NOTfilters':
        this.variableListMultiMarketAndCateg.forEach((levelMinus) => {
          levelMinus.Level1.forEach((level1) => {
            if (level1.Level1_value === selectedData.Level1) {
              level1.is_selected = true;
              level1.Level2.forEach((level2: any) => {
                if (level2.Level2_value === selectedData.Level2) {
                  level2.is_selected = true;
                  level2.Level3.forEach((level3: any) => {
                    if (level3.Level3_value === selectedData.Level3) {
                      level3.is_selected = true;
                      level3.Level4.forEach((level4: any) => {
                        if (level4.Level4_value === selectedData.Level4) {
                          level4.is_selected = true;
                          level4.Level5.forEach((level5: any) => {
                            if (level5.Level5_value === selectedData.Level5) {
                              level5.is_selected = true;
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        });
        break;

      default:
        break;
    }
    this.CheckIfMandatorySelected();
  }

  SwitchMakeSelectedFalseMultiple(selectedData: any, filters: string) {
    let values = Object.values(this.selectedObjects);
    switch (filters) {
      case 'NOTfilters':
        for (let i = 0; i < Object.keys(this.selectedObjects).length; i++) {
          if (Object.keys(values[i] as any)[0] !== selectedData.Level0)
            continue;
          let value1 = Object.values(values[i]);
          let value = value1[0] as any[];

          this.variableListMultiMarketAndCateg.forEach((levelMinus) => {
            levelMinus.Level1.forEach((level1) => {
              if (level1.Level1_value === selectedData.Level1) {
                level1.Level2.forEach((level2: any) => {
                  if (level2.Level2_value === selectedData.Level2) {
                    level2.Level3.forEach((level3: any) => {
                      if (level3.Level3_value === selectedData.Level3) {
                        level3.Level4.forEach((level4: any) => {
                          if (level4.Level4_value === selectedData.Level4) {
                            level4.Level5.forEach((level5: any) => {
                              if (level5.Level5_value === selectedData.Level5) {
                                level5.is_selected = false;
                              }
                            });

                            if (
                              value.filter(
                                (a: any) =>
                                  a.Level1 === selectedData.Level1 &&
                                  a.Level2 === selectedData.Level2 &&
                                  a.Level3 === selectedData.Level3 &&
                                  a.Level4 === selectedData.Level4,
                              ).length == 0
                            )
                              level4.is_selected = false;
                          }
                        });

                        if (
                          value.filter(
                            (a: any) =>
                              a.Level1 === selectedData.Level1 &&
                              a.Level2 === selectedData.Level2 &&
                              a.Level3 === selectedData.Level3,
                          ).length == 0
                        )
                          level3.is_selected = false;
                      }
                    });

                    if (
                      value.filter(
                        (a: any) =>
                          a.Level1 === selectedData.Level1 &&
                          a.Level2 === selectedData.Level2,
                      ).length == 0
                    )
                      level2.is_selected = false;
                  }
                });

                if (
                  value.filter((a: any) => a.Level1 === selectedData.Level1)
                    .length == 0
                )
                  level1.is_selected = false;
              }
            });
          });
        }

        break;

      default:
        break;
    }

    this.CheckIfMandatorySelected();
  }

  CheckIfMandatorySelected() {
    //debugger;
    //event?.stopPropagation();
    const selectedObjects: { [key: string]: any } = this.selectedObjects;
    // let allLevel1Selected = this.variableListFilter.every((levelMinus) =>
    //   levelMinus.Level1.every((level1) => level1.is_selected)
    // );
    let allLevel1Selected = this.variableListFilter.every((levelMinus: any) =>
      levelMinus.Level1.every(
        (level1: any) => level1.Level0 === 'KPI' || level1.is_selected,
      ),
    );
    const timePeriodData = selectedObjects['find'](
      (obj: any) => obj['Time Period'],
    )?.['Time Period'];

    let mandatory1Data: any = [];

    switch (this.singleorMultiSelectMandatory1) {
      case 'Brands 1':
        mandatory1Data = selectedObjects['find']((obj: any) => obj['Brands'])?.[
          'Brands'
        ];
        if (mandatory1Data == undefined || mandatory1Data.length == 0) {
          mandatory1Data = selectedObjects['find'](
            (obj: any) => obj['Brand'],
          )?.['Brand'];
        }
        break;
      case 'Brands 2':
        mandatory1Data = selectedObjects['find']((obj: any) => obj['Brands'])?.[
          'Brands'
        ];
        if (mandatory1Data == undefined || mandatory1Data.length == 0) {
          mandatory1Data = selectedObjects['find'](
            (obj: any) => obj['Brand'],
          )?.['Brand'];
        }
        break;
      case 'Category 2':
        mandatory1Data = selectedObjects['find'](
          (obj: any) => obj['Category'],
        )?.['Category'];
        break;
      case 'Markets 2':
        mandatory1Data = selectedObjects['find'](
          (obj: any) => obj['Markets'],
        )?.['Markets'];
        break;
      case 'Audience Snapshot':
        mandatory1Data = selectedObjects['flatMap']((obj: any) =>
          Object.values(obj),
        )
          .flat()
          .find((x: any) => x.Level0 === 'Audience');
        break;
      default:
        break;
    }

    let mandatory3Data: any = [];
    if (this.brandMandatory3 != '') {
      mandatory3Data = selectedObjects['find']((obj: any) => obj['Brands'])?.[
        'Brands'
      ];
    }

    // Determine if submit should be enabled — pure data check, single DOM access
    const hasTimePeriod =
      this._configService.isStaticTimeFrame || timePeriodData?.length > 0;
      //mandatory1Data is coming null in case of Entrypoints hidden. hence added isEntryPointHiddenBySingleOption to enable submit button in that case.
      //mandatory1Data also stays empty when audience type is EntryPoint (not one of the hardcoded
      //compareAcross cases above) and it has more than one selectable option, so isEntryPointHiddenBySingleOption
      //never gets set either. Falling back to real EntryPoint selections in dataArray covers that case.
    const hasMandatory1 =
      mandatory1Data?.length > 0 ||
      mandatory1Data?.Level0 === 'Audience' ||
      this.isEntryPointHiddenBySingleOption ||
      this.hasEntryPointSelectionInDataArray();
    const hasMandatory3 =
      this.brandMandatory3 === '' ||
      (this.brandMandatory3 !== '' && mandatory3Data?.length > 0);
    const shouldEnable =
      hasTimePeriod &&
      hasMandatory1 &&
      hasMandatory3 &&
      (!this.isAggregatedData || allLevel1Selected);

    // Cache the submitButton reference to avoid repeated getElementById calls
    if (!this._submitButtonEl) {
      this._submitButtonEl = document.getElementById('submitButton');
    }
    const submitButton = this._submitButtonEl;

    if (shouldEnable) {
      if (submitButton?.classList.contains('disabled')) {
        submitButton.classList.remove('disabled');
      }
      this.issubmitReset.emit(true);
    } else {
      if (submitButton && !submitButton.classList.contains('disabled')) {
        submitButton.classList.add('disabled');
      }
      this.issubmitReset.emit(false);
    }
  }

  // O(1) — uses a pre-built cache; cache is rebuilt when dataArray or
  // EPdataFor_Multiple changes via _rebuildToggleStatusCache().
  toggleStatus(
    Level: number,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
  ): boolean {
    const entryKey = this._varCodeToEntryKeyCache.get(variableCode) ?? '';
    return (
      this._toggleStatusCache.get(`${entryKey}|${Level1}|${MetricOptions}`) ===
      true
    );
  }

  toggleStatusRadio(
    Level: number,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
  ): boolean {
    const entryKey = this._varCodeToEntryKeyCache.get(variableCode) ?? '';
    return (
      this._toggleStatusCache.get(`${entryKey}|${Level1}|${MetricOptions}`) ===
      true
    );
  }

  private queuePanelRefresh(): void {
    if (this._refreshFrameId !== null || this._isDestroyed) {
      return;
    }

    this._refreshFrameId = requestAnimationFrame(() => {
      this._refreshFrameId = null;

      if (!this._isDestroyed) {
        this.cdr.detectChanges();
      }
    });
  }

  getValidation(Name: string) {
    if (Name == 'Duplicate') {
      this.errorPopup('Already Exist');
    } else if (Name == 'EntryPoint') {
      this.errorPopup(
        'At least one option has to be selected from each Entry Point.',
      );
    } else if (Name == '2ndLoadClick')
      this.errorPopup('Please select at least one option from above.');
    this._loaderService.hideLoader();
    //return false;
  }

  configChanges(data: any, study: any) {
    let comparisionpoint;
    let confidenceLevel;
    let weights;
    data = data.filter((a: any) => a.study == study);
    if (data.length > 0) {
      if (data[0].comparison_point.length > 0) {
        // Check if "None" key is already present
        const isNoneKeyPresent = data[0].comparison_point.some(
          (itemConst: any) => itemConst.key === 'None',
        );
        // If the key is not present, add it
        if (!isNoneKeyPresent) {
          data[0].comparison_point.unshift({ key: 'None', value: true });
        }
        comparisionpoint = data[0].comparison_point.filter(
          (a: Config) => a.value == true,
        );
        // Push other objects where value is true to comparison_point array
      }

      if (data[0].confidence_level.length > 0) {
        confidenceLevel = data[0].confidence_level.filter(
          (a: Config) => a.value == true,
        );
      }

      if (data[0].weight.length > 0) {
        weights = data[0].weight.filter((a: any) => a.is_selected == true);
      }

      this.selectedConfig.emit({
        RowNestSelection: data[0].nesting[0].is_selected,
        ColNestSelection: data[0].nesting[1].is_selected,
        is_brand_analysis: data[0].is_brand_analysis,
        is_chart_visualization: data[0].is_chart_visualization,
        is_sticky_selection: data[0].is_sticky_selection,
        is_reset_selection: data[0].is_reset_selection,
        is_Transpose: data[0].output_page[0].value,
        is_indexing: data[0].output_page[1].value,
        is_sigtesting: data[0].output_page[2].value,
        is_ranking: data[0].output_page[3].value,
        isFilterToggle: data[0].filter_function[0].value,
        isAnswerToggle: data[0].filter_function[1].value,
        comparisionpoint: comparisionpoint,
        confidenceLevel: confidenceLevel,
        excelExport: data[0].export_download[0].value,
        pptExport: data[0].export_download[1].value,
        repository: data[0].export_download[2].value,
        lowBaseIdentifier: data[0].export_download[3].value,
        is_AI_Integration: data[0].is_AI_Integration,
        is_StoryBoard: data[0].is_StoryBoard,
        is_Column_Row_Percentage: data[0].is_Column_Row_Percentage,
        insufficentBase: data[0].low_base_identifier[0].data_value,
        lowBase: data[0].low_base_identifier[1].data_value,
        threshold: data[0].threshold_identifier[0].data_value,
        configweights: weights,
        iscustomgrp: data[0].custom_content[0].value,
        iscustomCalc: data[0].custom_content[1].value,
        iscustomreport: data[0].custom_content[2].value,
        changeEntryPoint: data[0].save_selection[1].value,
      });
      this.sendHelpGuide.emit(data[0].help_guide);
      this.custom_calculation = data[0].custom_calculation;
      this.custom_group = data[0].custom_group;
      this.custom_report = data[0].custom_report;
      this.export_download = data[0].export_download;
      this.isconfigCustomGrpPresent =
        data[0].custom_content[0].value == true ? true : false;
    }
  }

  onOtherOptionSelected() {
    this.totalSample = false;
  }

  get isProductCategorySection(): boolean {
    const section =
      this.sectionselected ||
      this.selectedSection ||
      this._configService.selectedSection ||
      '';
    return this.productCategorySections.includes(section.toUpperCase());
  }

  resetProductCategoryPanel(clearData = true): void {
    this.productCategoryPanel = [];
    this.productCategoryPanel_Lvl2 = [];
    this.productCategoryPanel_Lvl3 = [];
    if (clearData) {
      this.productCategoryData = [];
    }
    this.productCategory_items_expand = '';
    this.productCategory_nested_items_expand = '';
    this.productCategorySidePanelblock = false;
    this.isProductCategoryLoading = false;
    this.isAudienceEntryPointHiddenBySingleOption = false;
  }

  private resetProductCategoryUI(): void {
    this.resetProductCategoryPanel(false);
  }

  buildProductCategoryPanel(): void {
    if (!this.isProductCategorySection) {
      this.resetProductCategoryUI();
      return;
    }

    const lvl1 = this.productCategoryLabel;

    const lvl2 =
      this.selectedSection === 'PERSONAL WEALTH: ACCOUNTS'
        ? 'Account Types'
        : this.selectedSection === 'ASSET CLASS AND INVESTMENT STRATEGY'
          ? 'Broad Market Categories'
          : 'Products';

    this.productCategoryPanel = [
      { Level1: lvl1 }
    ];

    this.productCategoryPanel_Lvl2 = [
      {
        Level1: lvl1,
        Level2: lvl2,
      },
    ];
    this.refreshProductCategoryLvl3IfExpanded();
  }

  private parseProductCategoryApiResponse(response: any): any[] {
    if (!response?.Data) {
      return [];
    }
    try {
      const parsed =
        typeof response.Data === 'string'
          ? JSON.parse(response.Data)
          : response.Data;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private buildProductCategoryLvl3Options(
    entryDetails: number,
    lvl1: string,
    lvl2: string,
  ): typeof this.productCategoryPanel_Lvl3 {
    return _.sortBy(this.productCategoryData, 'sort_id')
      .map((item: any) => ({
        Level: entryDetails,
        Level1: lvl1,
        Level2: lvl2,
        MetricOptions: this.getProductResponseLabel(item),
        productSubgroupLevel1Label:
          item?.metric_subgroup_level1_label ??
          item?.metric_subgroup_level1Label ??
          '',
        responseCode: item.response_code || item.responseCode || '',
        isActive: item.is_active ?? item.isActive ?? true,
        variableCode: this.productCategoryVariableCode,
        e1_variable_code: '',
        e2_variable_code: '',
        e3_variable_code: '',
        mandatory_variable_mapping: [],
        dimension: [],
      }))
      .filter((item) => !!item.MetricOptions);
  }

  private getProductResponseLabel(item: any): string {
    return (
      item?.response_label ?? item?.Response_label ?? item?.responseLabel ?? ''
    );
  }

  private refreshProductCategoryLvl3IfExpanded(): void {
    const lvl1 =
      this.selectedSection === 'PRODUCT CATEGORY HEALTH' ||
        this.selectedSection === 'PRIORITY PRODUCT PERCEPTIONS'
        ? 'Product Category'
        : this.selectedSection === 'PERSONAL WEALTH: ACCOUNTS'
          ? 'Account Types'
          : this.selectedSection === 'ASSET CLASS AND INVESTMENT STRATEGY'
            ? 'Broad Market Categories'
            : '';

    if (this.productCategory_items_expand === lvl1) {
      const lvl2Default =
        this.productCategory_nested_items_expand ||
        (this.selectedSection === 'PERSONAL WEALTH: ACCOUNTS'
          ? 'Account Types'
          : this.selectedSection === 'ASSET CLASS AND INVESTMENT STRATEGY'
            ? 'Broad Market Categories'
            : 'Products');

      this.bindProductCategorySidePanel(1, lvl1, lvl2Default);
    }
  }

  loadProductCategoryData(onLoaded?: () => void): void {
    if (!this.isProductCategorySection) {
      this.resetProductCategoryPanel();
      onLoaded?.();
      return;
    }

    const audienceResponseLabels = this.getSelectedAudienceResponseLabels();
    if (audienceResponseLabels.length === 0) {
      this.productCategoryData = [];
      this.productCategoryPanel_Lvl3 = [];
      this.buildProductCategoryPanel();
      onLoaded?.();
      return;
    }

    const parameter = {
      snapshot_name: this.clientDetails.clientDetails.study,
      client_name: this.clientDetails.clientDetails.client_code,
      client_code: this.clientDetails.clientDetails.client_code,
      study: this.selected_study,
      audience_response_labels: audienceResponseLabels,
    };

    this._configService
      .getSnapshotProductCategoryData(parameter)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.productCategoryData = this.parseProductCategoryApiResponse(data);
          this.buildProductCategoryPanel();
          this.pruneProductCategorySelections();
          this.cdr.detectChanges();
          onLoaded?.();
        },
        error: () => {
          this.productCategoryData = [];
          this.buildProductCategoryPanel();
          onLoaded?.();
        },
      });
  }

  onProductCategoryLevel2Click(lvl2: string): void {
    if (!this.isProductCategoryEnabled || this.isProductCategoryLoading) {
      return;
    }

    const lvl1 =
      this.selectedSection === 'PRODUCT CATEGORY HEALTH' ||
        this.selectedSection === 'PRIORITY PRODUCT PERCEPTIONS'
        ? 'Product Category'
        : this.selectedSection === 'PERSONAL WEALTH: ACCOUNTS'
          ? 'Account Types'
          : this.selectedSection === 'ASSET CLASS AND INVESTMENT STRATEGY'
            ? 'Broad Market Categories'
            : '';

    this.productCategorySidePanelblock = false;
    this.isProductCategoryLoading = true;

    this.loadProductCategoryData(() => {
      this.isProductCategoryLoading = false;

      this.bindProductCategorySidePanel(1, lvl1, lvl2);

      this.cdr.detectChanges();
    });
  }

  productCategoryExpand(lvl1: string): void {
    if (!this.isProductCategoryEnabled || this.isProductCategoryLoading) {
      return;
    }

    const resolvedLvl1 =
      this.selectedSection === 'PRODUCT CATEGORY HEALTH' ||
        this.selectedSection === 'PRIORITY PRODUCT PERCEPTIONS'
        ? 'Product Category'
        : this.selectedSection === 'PERSONAL WEALTH: ACCOUNTS'
          ? 'Account Types'
          : this.selectedSection === 'ASSET CLASS AND INVESTMENT STRATEGY'
            ? 'Broad Market Categories'
            : '';

    const defaultLvl2 =
      this.selectedSection === 'PERSONAL WEALTH: ACCOUNTS'
        ? 'Account Types'
        : this.selectedSection === 'ASSET CLASS AND INVESTMENT STRATEGY'
          ? 'Broad Market Categories'
          : 'Products';

    this.searchProductCategoryLevel2 = '';
    this.searchProductCategoryMetricOption = '';
    this.entry_items_expand = '';
    this.sidePanelblock = false;
    this.entry_nested_items_expand = '';

    if (this.productCategory_items_expand === lvl1) {
      this.productCategory_items_expand = '';
      this.productCategorySidePanelblock = false;
      this.productCategory_nested_items_expand = '';
      this.productCategoryPanel_Lvl3 = [];

      this.LeftPanelClick.emit({
        entry_items_expand: '',
        entryFlag: false,
      });

      return;
    }

    this.productCategoryPanel_Lvl2 = [
      {
        Level1: resolvedLvl1,
        Level2: defaultLvl2,
      },
    ];

    this.isProductCategoryLoading = true;

    this.loadProductCategoryData(() => {
      this.isProductCategoryLoading = false;

      this.productCategory_items_expand = resolvedLvl1;

      this.LeftPanelClick.emit({
        entry_items_expand: resolvedLvl1,
        entryFlag: true,
      });

      this.bindProductCategorySidePanel(1, resolvedLvl1, defaultLvl2);

      this.cdr.detectChanges();
    });
  }
  
  bindProductCategorySidePanel(
    entryDetails: number,
    lvl1: string,
    lvl2: string,
  ): void {
    if (!this.isProductCategoryEnabled) {
      return;
    }

    this.searchProductCategoryLevel2 = '';
    this.searchProductCategoryMetricOption = '';
    this.productCategorySidePanelblock = true;
    this.sidePanelblock = true;
    this.productCategory_nested_items_expand = lvl2;
    this.entry_nested_items_expand = lvl2;

    this.productCategoryPanel_Lvl3 = this.buildProductCategoryLvl3Options(
      entryDetails,
      lvl1,
      lvl2,
    );

    const existingEntry = this.dataArray.find((entry) =>
      entry.hasOwnProperty('EntryPoint2'),
    );
    if (
      existingEntry?.EntryPoint2?.Level1 === lvl1 &&
      existingEntry?.EntryPoint2?.Level2?.[0]?.Parent === lvl2 &&
      this.productCategoryPanel_Lvl3.length === 1
    ) {
      const item = this.productCategoryPanel_Lvl3[0];
      this.productCategoryEPRadioClick(
        0,
        entryDetails,
        this.EntryPointHeader,
        item.Level1,
        item.Level2,
        item.MetricOptions,
        item.responseCode,
      );
    }

    this.cdr.detectChanges();
  }

  productCategoryToggleStatusRadio(
    Level1: string,
    MetricOptions: string,
  ): boolean {
    return (
      this._toggleStatusCache.get(`EntryPoint2|${Level1}|${MetricOptions}`) ===
      true
    );
  }

  productCategoryCheckBoxClick(
    index: number,
    Level: number,
    Header: string,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    responseCode: string = '',
  ): void {
    this.productCategoryEPRadioClick(
      index,
      Level,
      Header,
      Level1,
      Level2,
      MetricOptions,
      responseCode,
    );
  }

  productCategoryEPRadioClick(
    index: number,
    Level: number,
    Header: string,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    responseCode: string = '',
  ): void {
    if (!this.isProductCategoryEnabled) {
      return;
    }

    const entryPointKey = 'EntryPoint2';

    const existingProductEntry = this.dataArray.find(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey]?.Level2?.length > 0,
    );
    if (
      existingProductEntry?.[entryPointKey]?.Level2?.[0]?.MetricOptions?.[0]
        ?.Name === MetricOptions
    ) {
      return;
    }

    this.productCategory_nested_items_expand = Level2;
    this.entry_nested_items_expand2 = Level2;

    const metricOptionPayload = {
      Name: MetricOptions,
      responseCode: responseCode || '',
      isActive: true,
      Dependency_e1: '',
      Dependency_e2: '',
    };

    const entryPointPayload = {
      Level1,
      Level2: [
        {
          Parent: Level2,
          MetricOptions: [metricOptionPayload],
        },
      ],
      variableCode: this.productCategoryVariableCode,
    };

    const existingEntryIndex = this.dataArray.findIndex((entry) =>
      entry.hasOwnProperty(entryPointKey),
    );

    if (existingEntryIndex !== -1) {
      this.dataArray[existingEntryIndex][entryPointKey] = entryPointPayload;
    } else if (this.dataArray.length > 0) {
      this.dataArray[0][entryPointKey] = entryPointPayload;
    } else {
      this.dataArray.push({
        [entryPointKey]: entryPointPayload,
        clientName: this.clientDetails.clientDetails.client_code.toString(),
        studyName: this.selected_study,
        mandatory_variable_mapping: [],
        dimension: [],
        isMandatoryLoadClicked:
          this.selectedcompareacrossOption == 'Multiple Markets' ||
          this.selectedcompareacrossOption == 'Multiple Categories',
        snapshotType: this.selectedcompareacrossOption,
      });
    }

    this.selectedEP2 = MetricOptions;
    this._rebuildToggleStatusCache();
    this.CheckIfMandatorySelected();
    this.queuePanelRefresh();
  }

  private getRequiredEntryPointCount(): number {
    return this.entryPanel.length + (this.isProductCategorySection ? 1 : 0);
  }

  private getSelectedEntryPointCount(): number {
    let count = 0;
    for (const entry of this.dataArray || []) {
      for (const key of ['EntryPoint1', 'EntryPoint2', 'EntryPoint3']) {
        if (
          entry[key]?.Level2?.length > 0 &&
          entry[key].Level2.some(
            (l2: any) => l2.MetricOptions && l2.MetricOptions.length > 0,
          )
        ) {
          count++;
        }
      }
    }
    return count;
  }

  BindEntryData(
    data: any,
    selectedStudy: string,
    ClientCode: string,
    ZeroEntryPoint: boolean,
  ) {
    this.studyname = selectedStudy;
    this.entryPanel = [];
    this.variableList = [];
    this.filteredStudies = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            item.study !== null &&
            item.study !== '' &&
            item.client_name == ClientCode,
        ),
        'study',
      ),
    );
    const Leve1 = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            item.Level1 !== null &&
            item.Level2 !== '' &&
            item.study == selectedStudy,
        ),
        'Level1',
      ),
    );

    // if (ZeroEntryPoint && this.entryPanel.length == 0) {
    //   this.dataArray = [];
    //   const clientStudyInfo = {
    //     clientName: this.clientDetails.clientDetails.client_code.toString(),
    //     studyName: this.selected_study,
    //   };
    //   this.dataArray.push(clientStudyInfo);
    //   this.loadBtnClick(false);
    // }
    // else {
    //   for (const element of Leve1) {
    //     this.entryPanel.push({
    //       Level1: element,
    //     });

    //     this.level0EP.push(element);
    //   }
    // }

    // if (!(ZeroEntryPoint && this.entryPanel.length == 0)) {
    //   for (const element of Leve1) {
    //     this.entryPanel.push({
    //       Level1: element,
    //     });

    //     this.level0EP.push(element);
    //   }
    // }
  }
  entryExpand(lvl1: string) {
    this.searchTextLevel2 = '';
    this.searchMetricOption = '';
    this.variable_expand = '';
    this.iscompareacrossDropdownOpen = false;
    this.entry_nested_items_expand = '';
    this.productCategory_items_expand = '';
    this.productCategorySidePanelblock = false;
    this.productCategory_nested_items_expand = '';
    if (this.entry_items_expand == '') {
      this.entry_items_expand = lvl1;
      this.entryFlag = true;
    } else if (this.entry_items_expand == lvl1) {
      this.entry_items_expand = '';
      this.entryFlag = false;
    } else {
      this.entry_items_expand = lvl1;
      this.entryFlag = true;
    }

    this.LeftPanelClick.emit({
      entry_items_expand: this.entry_items_expand,
      entryFlag: this.entryFlag,
    });

    this.entryPanel_Lvl2 = [];
    this.sidePanelblock = false;
    let lvl2Update = this.entryPointsData.filter(
      (a: any) => a.Level1 === lvl1 && a.study == this.selected_study,
    );
    lvl2Update = _.sortBy(lvl2Update, 'sortid');
    const Leve2 = _.uniq(
      _.map(
        _.filter(
          lvl2Update,
          (item) =>
            item.Level2 !== null && item.Level2 !== '' && item.Level1 == lvl1,
        ),
        'Level2',
      ),
    );
    for (const lvl2 of Leve2) {
      this.entryPanel_Lvl2.push({
        Level1: lvl1,
        Level2: lvl2,
      });
    }

    // Add "Default" as a replica of "Brands" in Level2
    const brandsEntry = this.entryPanel_Lvl2.find(
      (item) => item.Level2.toLowerCase() === 'brands' && item.Level1 === lvl1,
    );
    if (brandsEntry) {
      this.entryPanel_Lvl2.unshift({
        Level1: lvl1,
        Level2: 'Default',
      });
    }
    //  ;

    const divElement = document.querySelector('.EntryHeader') as HTMLElement;
    if (divElement) {
      let height = this.GetHeightAboveElement(divElement);
      const bodyHeight = document.body.offsetHeight;
      const containerHeight = height;
      const heightPercentage = (containerHeight / bodyHeight) * 100;
      this.topEP = heightPercentage + '%';
    }

    // Auto-open Level2 and Level3 if selections exist for this Level1
    if (this.dataArray.length > 0) {
      const selectedEntry = this.dataArray.find((entry) => {
        return Object.keys(entry).some(
          (key) => key.startsWith('EntryPoint') && entry[key].Level1 === lvl1,
        );
      });

      if (selectedEntry) {
        let selectedLevel2 = '';
        let entryPointIndex = 0;

        for (let i = 1; i <= 3; i++) {
          const epKey = `EntryPoint${i}`;
          if (
            selectedEntry.hasOwnProperty(epKey) &&
            selectedEntry[epKey].Level1 === lvl1
          ) {
            selectedLevel2 = selectedEntry[epKey].Level2[0]?.Parent;
            entryPointIndex = i - 1;
            break;
          }
        }

        if (selectedLevel2) {
          this.BindSidePanel(entryPointIndex, lvl1, selectedLevel2);
        }
      }
    }

    // Auto-open side panel if there is only one Level2 option and no prior selection handled it
    if (this.entry_items_expand === lvl1) {
      const realLevel2Items = this.entryPanel_Lvl2.filter(
        (item) => item.Level2 !== 'Default',
      );
      if (realLevel2Items.length === 1) {
        const alreadyHandled = this.dataArray.some((entry) =>
          Object.keys(entry).some(
            (key) => key.startsWith('EntryPoint') && entry[key].Level1 === lvl1,
          ),
        );
        if (!alreadyHandled) {
          const entryPointIndex = this.entryPanel.findIndex(
            (ep) => ep.Level1 === lvl1,
          );
          this.BindSidePanel(
            entryPointIndex !== -1 ? entryPointIndex : 0,
            lvl1,
            realLevel2Items[0].Level2,
          );
        }
      }
    }
  }

  BindSidePanel(EntryDetails: number, lvl1: string, lvl2: string) {
    // ;
    this.searchTextLevel2 = '';
    this.searchMetricOption = '';
    this.entryPanel_Lvl3 = [];
    this.sidePanelblock = true;
    this.selectAllCheck = 0;
    if (
      this.selectedcompareacrossOption == 'Multiple Markets' &&
      EntryDetails != 0
    ) {
      EntryDetails += 1;
    }

    // Map "Default" to "Brands" so it uses the same variable list
    const lvl2ForData = lvl2 === 'Default' ? 'Brands' : lvl2;
    let lvl2Update = this.entryPointsData.filter(
      (a: any) =>
        a.Level1 === lvl1 &&
        a.Level2 === lvl2ForData &&
        a.study == this.selected_study,
    );
    lvl2Update = _.sortBy(lvl2Update, 'sortid');

    // if (EntryDetails == 0) {
    //   this.entry_nested_items_expand1 = lvl2Update[0].Level2;
    //   this.entry_nested_items_expandParent1 = lvl2Update[0].Level1;
    // }
    // else if (EntryDetails == 1) {
    //   this.entry_nested_items_expand2 = lvl2Update[0].Level2;
    //   this.entry_nested_items_expandParent2 = lvl2Update[0].Level1;
    // }
    // else if (EntryDetails == 2) {
    //   this.entry_nested_items_expand3 = lvl2Update[0].Level2;
    //   this.entry_nested_items_expandParent3 = lvl2Update[0].Level1;
    // }

    this.entry_nested_items_expand = lvl2;
    this.metricOption = [];
    let uniqueMarket: any = [];
    let uniqueCate: any = [];
    this.dataArray.forEach((entry) => {
      const metricOptionsList1 = entry['EntryPoint1']?.Level2 || [];

      metricOptionsList1.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
          uniqueMarket.push(metricOption.responseCode);
        });
        //this.metricOption.push(data.responseCode);
      });

      const metricOptionsList2 = entry['EntryPoint2']?.Level2 || [];

      metricOptionsList2.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
          uniqueCate.push(metricOption.responseCode);
        });
      });

      const metricOptionsList3 = entry['EntryPoint3']?.Level2 || [];

      metricOptionsList3.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
        });
      });
    });

    const uniqueMetricOptionsArray = this.metricOption;
    this.entryPanel_Lvl3 = this.buildEntryPanelLvl3Options(
      EntryDetails,
      lvl1,
      lvl2,
    );

    const entryPointKey =
      EntryDetails === 0
        ? 'EntryPoint1'
        : EntryDetails === 1
          ? 'EntryPoint2'
          : 'EntryPoint3';
    const existingEntryIndex1 = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === lvl1,
    );

    if (existingEntryIndex1 == -1) {
      this.isSelectAll = false;
    } else {
      const existingEntry = this.dataArray[existingEntryIndex1];

      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === lvl2,
      );
      if (
        this.entryPanel_Lvl3.filter(
          (a) => a.Level1 === lvl1 && a.Level2 === lvl2,
        ).length ===
        (existingLevel2Index !== -1
          ? existingEntry[entryPointKey].Level2[existingLevel2Index]
              .MetricOptions.length
          : 0)
      ) {
        this.isSelectAll = true;
      } else {
        const entryPanelOptions = this.entryPanel_Lvl3.map(
          (entry) => entry.MetricOptions,
        );
        const isAllOptionsIncluded = entryPanelOptions.every((option) =>
          uniqueMetricOptionsArray.includes(option),
        );
        if (isAllOptionsIncluded) {
          this.isSelectAll = true;
        } else {
          this.isSelectAll = false;
        }
      }
    }

    this.autoSelectSingleEntryPointOption(EntryDetails, lvl1, lvl2);
  }

  private autoSelectSingleEntryPointOption(
    entryDetails: number,
    lvl1: string,
    lvl2: string,
  ): void {
    if (this.isMultiSelectEP || this.entryPanel_Lvl3.length !== 1) {
      return;
    }

    const item = this.entryPanel_Lvl3[0];
    const entryPointKey =
      entryDetails === 0
        ? 'EntryPoint1'
        : entryDetails === 1
          ? 'EntryPoint2'
          : 'EntryPoint3';

    const existingEntry = this.dataArray.find(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey]?.Level1 === lvl1,
    );

    const alreadySelected = existingEntry?.[entryPointKey]?.Level2?.some(
      (l2: any) =>
        l2.Parent === lvl2 &&
        l2.MetricOptions?.some((mo: any) => mo.Name === item.MetricOptions),
    );

    if (alreadySelected) {
      return;
    }

    this.EPRadioClick(
      0,
      entryDetails,
      this.EntryPointHeader,
      item.Level1,
      item.Level2,
      item.MetricOptions,
      item.variableCode,
      item.responseCode,
      item.mandatory_variable_mapping,
      false,
      item.e1_variable_code,
      item.e2_variable_code,
      item.e3_variable_code,
      item.dimension,
    );
  }

  private buildEntryPanelLvl3Options(
    entryDetails: number,
    lvl1: string,
    lvl2: string,
  ): typeof this.entryPanel_Lvl3 {
    const lvl2ForData = lvl2 === 'Default' ? 'Brands' : lvl2;
    let lvl2Update = this.entryPointsData.filter(
      (a: any) =>
        a.Level1 === lvl1 &&
        a.Level2 === lvl2ForData &&
        a.study == this.selected_study,
    );
    lvl2Update = _.sortBy(lvl2Update, 'sortid');

    const metricOption: string[] = [];
    const uniqueMarket: string[] = [];
    const uniqueCate: string[] = [];
    this.dataArray.forEach((entry) => {
      const metricOptionsList1 = entry['EntryPoint1']?.Level2 || [];
      metricOptionsList1.forEach((data: any) => {
        data.MetricOptions.forEach((mo: any) => {
          metricOption.push(mo.responseCode);
          uniqueMarket.push(mo.responseCode);
        });
      });

      const metricOptionsList2 = entry['EntryPoint2']?.Level2 || [];
      metricOptionsList2.forEach((data: any) => {
        data.MetricOptions.forEach((mo: any) => {
          metricOption.push(mo.responseCode);
          uniqueCate.push(mo.responseCode);
        });
      });

      const metricOptionsList3 = entry['EntryPoint3']?.Level2 || [];
      metricOptionsList3.forEach((data: any) => {
        data.MetricOptions.forEach((mo: any) => {
          metricOption.push(mo.responseCode);
        });
      });
    });

    const uniqueMetricOptionsArray = metricOption;
    const Leve2 = _.uniq(
      _.map(
        _.filter(
          lvl2Update,
          (item) =>
            item.Level1 === lvl1 &&
            item.Level2 === lvl2ForData &&
            item.MetricOption != '',
        ),
        'MetricOption',
      ),
    );

    const options: typeof this.entryPanel_Lvl3 = [];
    for (const lvl of Leve2) {
      let MetricOptions = this.entryPointsData.filter(
        (a: any) =>
          a.Level1 === lvl1 &&
          a.Level2 === lvl2ForData &&
          a.MetricOption == lvl &&
          a.study == this.selected_study,
      );

      if (entryDetails == 1) {
        MetricOptions = MetricOptions.filter((a: any) => {
          const optionCodes = a.e1_variable_code
            .split(',')
            .map((code: any) => code.trim());
          return optionCodes.some((code: any) =>
            uniqueMetricOptionsArray.includes(code),
          );
        });
        MetricOptions = MetricOptions.filter((x: any) => {
          return uniqueMarket.indexOf(x.e1_variable_code) > -1;
        });
      } else if (entryDetails == 2) {
        MetricOptions = MetricOptions.filter((a: any) => {
          const optionCodes = a.e1_variable_code
            .split(',')
            .map((code: any) => code.trim());
          const optionCodes2 = a.e2_variable_code
            .split(',')
            .map((code: any) => code.trim());

          return (
            optionCodes.some((code: any) =>
              uniqueMetricOptionsArray.includes(code),
            ) ||
            optionCodes2.some((code: any) =>
              uniqueMetricOptionsArray.includes(code),
            )
          );
        });

        if (this.selectedcompareacrossOption == 'Multiple Markets') {
          MetricOptions = MetricOptions.filter((x: any) => {
            return uniqueCate.indexOf(x.e2_variable_code) > -1;
          });
        } else {
          MetricOptions = MetricOptions.filter((x: any) => {
            return (
              uniqueMarket.indexOf(x.e1_variable_code) > -1 &&
              uniqueCate.indexOf(x.e2_variable_code) > -1
            );
          });
        }
      }
      if (MetricOptions.length > 1) {
        MetricOptions = [MetricOptions[0]];
      }

      let epFilteredBrandList = this.defaultBrandList;
      if (
        lvl2 === 'Default' &&
        this._configService.topicsConfigurationBySnapshot?.rows?.length > 0
      ) {
        const epKey =
          entryDetails === 0
            ? 'EntryPoint1'
            : entryDetails === 1
              ? 'EntryPoint2'
              : 'EntryPoint3';
        const epFieldName = `entryPoint${entryDetails + 1}`;
        const selectedEntry = this.dataArray.find(
          (e: any) => e.hasOwnProperty(epKey) && e[epKey]?.Level1 === lvl1,
        );
        if (selectedEntry) {
          const selectedEPNames: string[] =
            selectedEntry[epKey]?.Level2?.[0]?.MetricOptions?.map(
              (mo: any) => mo.Name,
            ).filter(Boolean) || [];
          const selectedEPCodes: string[] =
            selectedEntry[epKey]?.Level2?.[0]?.MetricOptions?.map(
              (mo: any) => mo.responseCode,
            ).filter(Boolean) || [];

          if (selectedEPNames.length > 0 || selectedEPCodes.length > 0) {
            const filteredRows =
              epKey === 'EntryPoint1'
                ? this.filterTopicsRowsForDefaultBrands(
                    this._configService.topicsConfigurationBySnapshot.rows,
                    selectedEPNames,
                    [],
                    [],
                    selectedEPCodes,
                  )
                : this._configService.topicsConfigurationBySnapshot.rows.filter(
                    (row: any) => {
                      const epConfig = row[epKey] || row[epFieldName];
                      if (!epConfig) {
                        return true;
                      }
                      return this.entryPointMetricOptionsMatchSelected(
                        epConfig,
                        selectedEPNames,
                        selectedEPCodes,
                      );
                    },
                  );
            epFilteredBrandList = [
              ...new Set(
                filteredRows.flatMap((row: any) => row.brandList || []),
              ),
            ];
          }
        }
      }

      for (const metric of MetricOptions) {
        if (
          lvl2 === 'Default' &&
          epFilteredBrandList?.length > 0 &&
          !epFilteredBrandList.includes(metric.MetricOption)
        ) {
          continue;
        }
        options.push({
          Level: entryDetails,
          Level1: lvl1,
          Level2: lvl2,
          MetricOptions: metric.MetricOption,
          responseCode: metric.ResponseCode,
          isActive: false,
          variableCode: metric.VariableCode,
          e1_variable_code: metric.e1_variable_code,
          e2_variable_code: metric.e2_variable_code,
          e3_variable_code: metric.e3_variable_code,
          mandatory_variable_mapping: metric.mandatory_variable_mapping,
          dimension: metric.dimension,
        });
      }
    }

    return this.restrictAudienceOptionsForPlanParticipantsSnapshot(options);
  }

  private getSelectedLevel2ForEntryPoint(
    entryDetails: number,
    lvl1: string,
  ): string {
    const entryPointKey =
      entryDetails === 0
        ? 'EntryPoint1'
        : entryDetails === 1
          ? 'EntryPoint2'
          : 'EntryPoint3';
    const entry = this.dataArray.find(
      (e) =>
        e.hasOwnProperty(entryPointKey) && e[entryPointKey]?.Level1 === lvl1,
    );
    return entry?.[entryPointKey]?.Level2?.[0]?.Parent || '';
  }

  private getLevel2OptionsForEntryPoint(lvl1: string): string[] {
    let lvl2Update = this.entryPointsData.filter(
      (a: any) => a.Level1 === lvl1 && a.study == this.selected_study,
    );
    lvl2Update = _.sortBy(lvl2Update, 'sortid');
    return _.uniq(
      _.map(
        _.filter(
          lvl2Update,
          (item) =>
            item.Level2 !== null && item.Level2 !== '' && item.Level1 == lvl1,
        ),
        'Level2',
      ),
    ).filter((l2) => l2 !== 'Default');
  }

  private hasSingleEntryPointLastLevelOption(): boolean {
    if (this.isMultiSelectEP || this.entryPanel.length === 0) {
      return false;
    }

    for (let i = 0; i < this.entryPanel.length; i++) {
      const lvl1 = this.entryPanel[i].Level1;
      const level2Options = this.getLevel2OptionsForEntryPoint(lvl1);
      if (level2Options.length !== 1) {
        return false;
      }

      let entryDetails = i;
      if (
        this.selectedcompareacrossOption == 'Multiple Markets' &&
        entryDetails != 0
      ) {
        entryDetails += 1;
      }

      if (
        this.buildEntryPanelLvl3Options(entryDetails, lvl1, level2Options[0])
          .length !== 1
      ) {
        return false;
      }
    }

    return true;
  }

  private hasEntryPointSelectionInDataArray(): boolean {
    return this.dataArray.some((entry) =>
      Object.keys(entry).some(
        (key) =>
          key.startsWith('EntryPoint') &&
          entry[key]?.Level1 &&
          entry[key]?.Level2?.length > 0 &&
          entry[key]?.Level2[0]?.MetricOptions?.length > 0,
      ),
    );
  }

  private shouldHideEntryPointPanelAfterLoad(): boolean {
    if (
      this.isProductCategorySection ||
      this.isAudienceEntryPointHiddenBySingleOption
    ) {
      return false;
    }

    if (this.isMultiSelectEP || this.entryPanel.length === 0) {
      return false;
    }

    for (let i = 0; i < this.entryPanel.length; i++) {
      const lvl1 = this.entryPanel[i].Level1;
      const lvl2 = this.getSelectedLevel2ForEntryPoint(i, lvl1);
      if (!lvl2) {
        return false;
      }

      let entryDetails = i;
      if (
        this.selectedcompareacrossOption == 'Multiple Markets' &&
        entryDetails != 0
      ) {
        entryDetails += 1;
      }

      if (
        this.buildEntryPanelLvl3Options(entryDetails, lvl1, lvl2).length !== 1
      ) {
        return false;
      }
    }

    return true;
  }

  private shouldPreserveEntryPointOnReset(): boolean {
    return (
      this.isEntryPointHiddenBySingleOption ||
      this.isAudienceEntryPointHiddenBySingleOption ||
      this.isSingleEntryPointAutoLoaded ||
      this.hasSingleEntryPointLastLevelOption()
    );
  }

  private captureAutoLoadedEntryPointSnapshot(): void {
    if (!this.shouldPreserveEntryPointOnReset()) {
      this.autoLoadedEntryPointSnapshot = null;
      return;
    }

    this.autoLoadedEntryPointSnapshot = {
      dataArray: _.cloneDeep(this.dataArray),
      variableListEpForOutput: _.cloneDeep(this.variableListEpForOutput),
      selectedEP1: this.selectedEP1,
      selectedEP2: this.selectedEP2,
      selectedEP3: this.selectedEP3,
    };
  }

  private restoreAutoLoadedEntryPointSnapshot(): void {
    if (!this.autoLoadedEntryPointSnapshot) {
      return;
    }

    this.dataArray = _.cloneDeep(this.autoLoadedEntryPointSnapshot.dataArray);
    this.variableListEpForOutput = _.cloneDeep(
      this.autoLoadedEntryPointSnapshot.variableListEpForOutput,
    );
    this.selectedEP1 = this.autoLoadedEntryPointSnapshot.selectedEP1;
    this.selectedEP2 = this.autoLoadedEntryPointSnapshot.selectedEP2;
    this.selectedEP3 = this.autoLoadedEntryPointSnapshot.selectedEP3;
    this._rebuildToggleStatusCache();
    if (this.isMultiMarketOrCateg) {
      this.dataListChange.emit(this.dataArray_Multiple);
    } else {
      this.dataListChange.emit(this.dataArray);
    }
  }

  private selectSingleEntryPointOptions(): boolean {
    const savedDataArray = _.cloneDeep(this.dataArray);

    try {
      for (let i = 0; i < this.entryPanel.length; i++) {
        const lvl1 = this.entryPanel[i].Level1;
        const level2Options = this.getLevel2OptionsForEntryPoint(lvl1);
        if (level2Options.length !== 1) {
          this.dataArray = savedDataArray;
          return false;
        }

        let entryDetails = i;
        if (
          this.selectedcompareacrossOption == 'Multiple Markets' &&
          entryDetails != 0
        ) {
          entryDetails += 1;
        }

        const options = this.buildEntryPanelLvl3Options(
          entryDetails,
          lvl1,
          level2Options[0],
        );
        if (options.length !== 1) {
          this.dataArray = savedDataArray;
          return false;
        }

        const item = options[0];
        this.EPRadioClick(
          0,
          i,
          this.EntryPointHeader,
          item.Level1,
          item.Level2,
          item.MetricOptions,
          item.variableCode,
          item.responseCode,
          item.mandatory_variable_mapping,
          false,
          item.e1_variable_code,
          item.e2_variable_code,
          item.e3_variable_code,
          item.dimension,
        );
      }
    } catch {
      this.dataArray = savedDataArray;
      return false;
    }

    return true;
  }

  private ensureSingleEntryPointSelected(): void {
    if (
      !this.hasSingleEntryPointLastLevelOption() ||
      this.hasEntryPointSelectionInDataArray()
    ) {
      return;
    }

    this.selectSingleEntryPointOptions();
  }

  private reloadSingleEntryPointAfterReset(epSnapshot: {
    dataArray: any[];
    selectedEP1: string;
    selectedEP2: string;
    selectedEP3: string;
  }): void {
    this.dataArray = _.cloneDeep(epSnapshot.dataArray);
    this.selectedEP1 = epSnapshot.selectedEP1;
    this.selectedEP2 = epSnapshot.selectedEP2;
    this.selectedEP3 = epSnapshot.selectedEP3;
    this.ensureSingleEntryPointSelected();

    this._rebuildToggleStatusCache();

    this.isSingleEntryPointAutoLoaded = true;
    this.captureAutoLoadedEntryPointSnapshot();

    if (this.shouldAutoHideAudienceForProductCategorySection()) {
      this.isAudienceEntryPointHiddenBySingleOption = true;
      this.isEntryPointHiddenBySingleOption = false;

      const selectionsAlreadyLoaded =
        Array.isArray(this.variableList) && this.variableList.length > 0;

      if (selectionsAlreadyLoaded) {
        this.isVariableTab = true;
        this.is_load_btn = true;
        this.isEntry_Tab = true;
        this.isEntry_Point = true;
        this.buildProductCategoryPanel();
        document.querySelector('.EntryTab')?.classList.remove('DN');
        document.querySelector('.btn-load')?.classList.remove('DN');
        document.querySelector('.variableTab')?.classList.remove('DN');
      } else {
        this.showProductCategoryAfterAutoAudience();
      }

      if (this.isMultiMarketOrCateg) {
        this.dataListChange.emit(this.dataArray_Multiple);
      } else {
        this.dataListChange.emit(this.dataArray);
      }
      this.cdr.detectChanges();
      return;
    }

    this.isEntryPointHiddenBySingleOption = true;
    this.isVariableTab = true;
    this.is_load_btn = false;
    this.isEntry_Tab = false;
    this.hideEntryPointPanel();

    const variableTab = document.querySelector('.variableTab');
    if (variableTab) {
      variableTab.classList.remove('DN');
    }

    if (this.isMultiMarketOrCateg) {
      this.dataListChange.emit(this.dataArray_Multiple);
    } else {
      this.dataListChange.emit(this.dataArray);
    }

    this.loadBtnClick(true, true, false);
  }

  private shouldAutoHideAudienceForProductCategorySection(): boolean {
    return (
      this.isProductCategorySection &&
      !!this.productCategoryLabel &&
      this.hasSingleEntryPointLastLevelOption()
    );
  }

  private showProductCategoryAfterAutoAudience(): void {
    this.buildProductCategoryPanel();
    this.is_load_btn = true;
    this.isEntry_Tab = true;
    this.isEntry_Point = true;

    document.querySelector('.EntryTab')?.classList.remove('DN');
    document.querySelector('.btn-load')?.classList.remove('DN');
    document.querySelector('.variableTab')?.classList.add('DN');

    if (!this.isProductCategoryEnabled) {
      this.cdr.detectChanges();
      return;
    }

    this.loadProductCategoryData(() => {
      this.productCategoryExpand(this.productCategoryLabel);
      this.cdr.detectChanges();
    });
  }

  private tryAutoSelectAndLoadSingleEntryPointOptions(): boolean {
    this.isSingleEntryPointAutoLoaded = false;
    this.isAudienceEntryPointHiddenBySingleOption = false;

    if (
      this.isSavedScenarioSelected ||
      !this.hasSingleEntryPointLastLevelOption()
    ) {
      return false;
    }

    if (!this.selectSingleEntryPointOptions()) {
      return false;
    }

    this.isSingleEntryPointAutoLoaded = true;
    this.captureAutoLoadedEntryPointSnapshot();

    if (this.shouldAutoHideAudienceForProductCategorySection()) {
      this.isAudienceEntryPointHiddenBySingleOption = true;
      this.isEntryPointHiddenBySingleOption = false;
      this.showProductCategoryAfterAutoAudience();
      return true;
    }

    this.isEntryPointHiddenBySingleOption = true;
    this.hideEntryPointPanel();
    this.loadBtnClick(true);
    return true;
  }

  private hideEntryPointPanel(): void {
    document.querySelector('.EntryTab')?.classList.add('DN');
    document.querySelector('.btn-load')?.classList.add('DN');
    this.isEntryPointHiddenBySingleOption = true;
  }

  // getVariableData(): void {
  //   this.Loader.showLoader();
  //   this.$unSubscribeSubmitData3 = this.crossTabService
  //     .getVariableData(this.dataArray, this.isBrandAnalysis)
  //     .subscribe((result: results) => {
  //       // Response is valid
  //       if (result.HasValidData) {
  //         let JsonData = JSON.parse(result.Data);
  //         if (this.isBrandAnalysis) {
  //           JsonData.forEach((x: any) => {
  //             if (x.is_brandanalysis == 1) {
  //               x.Level2 = '';
  //             } else if (x.is_brandanalysis == 2) {
  //               x.Level3 = '';
  //             } else if (x.is_brandanalysis == 3) {
  //               x.Level4 = '';
  //             } else if (x.is_brandanalysis == 4) {
  //               x.Level5 = '';
  //             }
  //           });
  //         }

  //         this.variableTabData = JsonData;
  //         this.Loader.hideLoader();
  //         if (this.variableTabData.length > 0) {
  //           //this.BindVariableDataLeftPanel(this.variableTabData);
  //           this.crossTabService.setVariableTabData(this.variableTabData);
  //         }
  //       } else {
  //         // this.errorPopup(result.ExceptionMessage);
  //         this.Loader.hideLoader();
  //       }
  //       //hide the loader
  //     });
  // }

  BindVariableDataPanelMultiple(Variableresult: any): void {
    this.variableListMultiMarketAndCateg = [];
    this.isVariableTab = true;
    this.is_load_btn = false;
    this.isEntry_Tab = false;
    this.sidePanelblock = false;
    this.isEntry_Point = false;
    this.entry_items_expand = '';
    this.dimensionList = [];
    this.btnVisible.emit({
      save: true,
      load: true,
      custom_groups: this.isconfigCustomGrpPresent ? true : false,
      custom_calc: false,
      create_table: true,
      weighted_btns: true,
    });
    this.entryListChange.emit(this.entryPanel);
    if (this.isMultiMarketOrCateg) {
      this.dataListChange.emit(this.dataArray_Multiple);
    } else {
      this.dataListChange.emit(this.dataArray);
    }

    const result = _.sortBy(Variableresult, 'sort_id');

    const Level0VariablesAll = _.uniq(
      _.map(
        _.filter(result, (item) => item.Level0),
        'Level0',
      ),
    );

    // Collect entry point variable codes from dataArray to identify EP Level0 values
    // that may differ from level0EP names (e.g., API returns "Alfabeta" instead of "Audience")
    const epVariableCodesMulti: string[] = [];
    for (const entry of this.dataArray) {
      for (const key of Object.keys(entry)) {
        if (key.startsWith('EntryPoint') && entry[key]?.variableCode) {
          epVariableCodesMulti.push(entry[key].variableCode.toLowerCase());
        }
      }
    }

    this.Level0Variables = Level0VariablesAll.filter((item) => {
      const isEPByVariableCode =
        epVariableCodesMulti.length > 0 &&
        !this.level0EP.includes(item) &&
        result.some(
          (r: any) =>
            r.Level0 === item &&
            epVariableCodesMulti.includes(r.data_variable_code?.toLowerCase()),
        );

      if (!this.level0EP.includes(item) && !isEPByVariableCode) {
        if (
          this.singleorMultiSelectMandatory1
            .toLowerCase()
            .includes(item.toLowerCase()) ||
          this.brandMandatory3.toLowerCase().includes(item.toLowerCase()) ||
          this.timeperiodMandatory2.toLowerCase().includes(item.toLowerCase())
        ) {
          return item;
        } else {
          this.level0Filters.push(item);
        }
      } else {
        this.level0EntryForOutput.push(item);
        if (!isEPByVariableCode) {
          // Audience (in level0EP): display under Filters
          this.level0Filters.push(item);
        }
      }
    });

    if (this.Level0Variables.length > 0) {
      for (let i = 0; i < this.Level0Variables.length; i++) {
        if (
          this.Level0Variables[0] == 'Markets' &&
          this.Level0Variables[i] == 'Time Period'
        ) {
          continue;
        }
        const level0 = this.Level0Variables[i];

        let listToUpdate = [];

        listToUpdate = _.sortBy(
          _.filter(result, (item) => item.Level0 === level0),
          'sort_id',
        );

        // Get unique sequence values
        const uniqueSequenceValues = _.uniq(_.map(listToUpdate, 'sequence'));

        let level1Array = [];
        if (
          uniqueSequenceValues.includes(1) ||
          uniqueSequenceValues.includes(3)
        )
          level1Array = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            0,
            true,
          );
        else if (
          uniqueSequenceValues.includes(2) ||
          uniqueSequenceValues.includes(4)
        )
          level1Array = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            1,
            false,
          );

        //Changing the Levels based on FOM for option 1,2,3,4
        // let num = 4;
        // level1Array = this.AdjustLevels(num, level1Array);

        this.variableListMultiMarketAndCateg.push({
          Level0: level0,
          isEntryPoint: level1Array.some((item: any) => item.isEntryPoint),
          hasNextLevel: true,
          is_selected: false,
          Level1: level1Array,
        });
      }
    }
    if (this.selectedcompareacrossOption == 'Multiple Markets') {
      this._configService.brandSortId = _.cloneDeep(
        this.variableListMultiMarketAndCateg
          .filter((v) => v.Level0 == 'Markets')[0]
          .Level1[0].Level2.map((l: any) => ({
            name: l.Level2_value,
            sortId: l.sort_id,
          })),
      );
    }
  }

  level0EntryForOutput: any[] = [];
  variableListEpForOutput: any[] = [];
  audienceTotalSampleList: any[] = [];
  BindLocalStorageVariableDataPanel(): void {
    let localUserdefined: any = localStorage.getItem('leftPanelFilters');
    if (
      localUserdefined != undefined &&
      localUserdefined != null &&
      localUserdefined != ''
    ) {
      const index = this.variableListFilter.findIndex(
        (x) => x.LevelMinus === 'Filters',
      );
      if (index != -1) {
        const useDefinedIndex = this.variableListFilter[index].Level1.findIndex(
          (x) => x.Level0 === 'Custom Percentage Variable - User Defined',
        );
        if (useDefinedIndex != -1) {
          localUserdefined = JSON.parse(localUserdefined);

          //add update item from existing variableListFilter.
          if (
            localUserdefined.addUpdateRecord &&
            localUserdefined.addUpdateRecord.length > 0
          ) {
            localUserdefined.addUpdateRecord.forEach((record: any) => {
              const isExistItem = this.variableListFilter[index].Level1[
                useDefinedIndex
              ].Level1.findIndex((x) => x.Level1_value === record);
              if (isExistItem != -1) {
                var filterItem =
                  this.variableListFilter[index].Level1[useDefinedIndex].Level1[
                    isExistItem
                  ];
                filterItem.Level1_value = record.selection_name;
                filterItem.data_variable_code = record.selection_name;
                filterItem.response_code = record.selection_name;
                filterItem.tooltip = record.selection_name;
                filterItem.kibanaFilterScript = record.selection_query;
                this.variableListFilter[index].Level1[useDefinedIndex].Level1[
                  isExistItem
                ] = filterItem;
              } else {
                let result: any = {
                  Level1_value: record.selection_name,
                  Level2: [],
                  calc_type: '',
                  customCalculationId: '',
                  customGroupId: '00000000-0000-0000-0000-000000000000',
                  dataYearCode: 'Yearcode',
                  data_variable_code: record.selection_name,
                  date: '0001-01-01T00:00:00',
                  derived_metric_calculation: '',
                  hasNextLevel: false,
                  isCustomCalcPresent: false,
                  isCustomGrpPresent: true,
                  isEntryPoint: false,
                  is_brand_analysis: 0,
                  is_derived: false,
                  is_dimension: false,
                  is_multi_punch: 0,
                  is_selected: false,
                  is_time_Period_Present: true,
                  kibanaFilterScript: record.selection_query,
                  response_code: record.selection_name,
                  sort_id: 730854,
                  tooltip: record.selection_name,
                  year_code: null,
                };
                this.variableListFilter[index].Level1[
                  useDefinedIndex
                ].Level1.push(result);
                this.variableList.forEach((level0Item) => {
                  if (level0Item.Level0 === 'Audience') {
                    level0Item.Level1.forEach((level1Item: any) => {
                      if (
                        level1Item.Level0 ===
                        'Custom Percentage Variable - User Defined'
                      ) {
                        const updatedResult = {
                          ...result,
                          Level2_value: result.Level1_value,
                        };

                        delete updatedResult.Level1_value;
                        level1Item.Level2.push(updatedResult); // <-- push here
                      }
                    });
                  }
                });
              }
            });
          }

          //delete item from existing variableListFilter.
          if (
            localUserdefined.deleteRecord &&
            localUserdefined.deleteRecord.length > 0
          ) {
            localUserdefined.deleteRecord.forEach((record: any) => {
              const isExistItem = this.variableListFilter[index].Level1[
                useDefinedIndex
              ].Level1.findIndex((x) => x.Level1_value === record);
              if (isExistItem != -1) {
                const existItem =
                  this.variableListFilter[index].Level1[useDefinedIndex].Level1[
                    isExistItem
                  ];

                this.variableListFilter[index].Level1[useDefinedIndex].Level1 =
                  this.variableListFilter[index].Level1[
                    useDefinedIndex
                  ].Level1.filter((x) => x != existItem);
              }
            });
          }
        }
      }
    }
    localStorage.removeItem('leftPanelFilters');
  }

  BindVariableDataPanel(Variableresult: any): void {
    this.variableList = [];
    this.isVariableTab = true;
    this.is_load_btn = false;
    this.isEntry_Tab = false;
    this.sidePanelblock = false;
    this.isEntry_Point = false;
    this.entry_items_expand = '';
    this.dimensionList = [];
    this.btnVisible.emit({
      save: true,
      load: true,
      custom_groups: this.isconfigCustomGrpPresent ? true : false,
      custom_calc: false,
      create_table: true,
      weighted_btns: true,
    });
    this.entryListChange.emit(this.entryPanel);
    if (this.isMultiMarketOrCateg) {
      // this.dataListChange.emit(this.dataArray_Multiple);
      const dataArray = [...this.dataArray, ...this.dataArray_Multiple];
      this.dataListChange.emit(dataArray);
    } else {
      this.dataListChange.emit(this.dataArray);
    }

    const result = _.sortBy(Variableresult, 'sort_id');

    //contains dimension variable codes
    this.dimensionVariableList = this.snapshotType_details
      .filter(
        (type: any) => type.snapshot_type == this.selectedcompareacrossOption,
      )[0]
      .dimension.map((dim: any) => dim.variable_code.toLowerCase());

    let dimensionData = _.uniq(
      result.filter((res: any) =>
        this.dimensionVariableList.includes(res.variable_code?.toLowerCase()),
      ),
    );
    let level0Dimensions = _.uniq(dimensionData.map((dim: any) => dim.Level0));

    let allDimensionDataExceptDim = _.uniq(
      result.filter(
        (res: any) =>
          level0Dimensions.includes(res.Level0) &&
          !this.dimensionVariableList.includes(
            res.variable_code?.toLowerCase(),
          ),
      ),
    );
    let level0DimensionsExceptDim = allDimensionDataExceptDim.map(
      (dim: any) => dim.Level0,
    );

    let Level0VariablesAll = _.uniq(
      _.map(
        _.filter(result, (item) => item.Level0),
        'Level0',
      ),
    );

    // additional code to add entry point if not there in above code
    // const entrypointnames = _.uniq(_.map(this.dataArray, (entry) => (Object.values(entry)[0] as any).Level1));
    // entrypointnames.forEach((entrypointname) => {
    //   if(!Level0VariablesAll.includes(entrypointname)){
    //     Level0VariablesAll.push(entrypointname);
    //   }
    // });

    Level0VariablesAll.sort((a, b) => {
      if (level0Dimensions.includes(a) && !level0Dimensions.includes(b)) {
        return -1;
      } else if (
        !level0Dimensions.includes(a) &&
        level0Dimensions.includes(b)
      ) {
        return 1;
      } else {
        return 0;
      }
    });

    this.level0Filters = [];
    this.level0EntryForOutput = [];

    // Collect entry point variable codes from dataArray to identify EP Level0 values
    // that may differ from level0EP names (e.g., API returns "Alfabeta" instead of "Audience")
    const epVariableCodes: string[] = [];
    for (const entry of this.dataArray) {
      for (const key of Object.keys(entry)) {
        if (key.startsWith('EntryPoint') && entry[key]?.variableCode) {
          epVariableCodes.push(entry[key].variableCode.toLowerCase());
        }
      }
    }

    this.Level0Variables = Level0VariablesAll.filter((item) => {
      // Check if this Level0 matches level0EP directly OR if items under this Level0
      // have a data_variable_code matching an entry point variable code
      const isEPByVariableCode =
        epVariableCodes.length > 0 &&
        !this.level0EP.includes(item) &&
        result.some(
          (r: any) =>
            r.Level0 === item &&
            epVariableCodes.includes(r.data_variable_code?.toLowerCase()),
        );

      if (!this.level0EP.includes(item) && !isEPByVariableCode) {
        if (
          level0DimensionsExceptDim
            .toString()
            .toLowerCase()
            .includes(item.toLowerCase())
        )
          this.level0Filters.push(item);
        if (
          level0Dimensions.toString().toLowerCase().includes(item.toLowerCase())
        )
          return item;

        if (
          this.singleorMultiSelectMandatory1
            .toLowerCase()
            .includes(item.toLowerCase()) ||
          this.brandMandatory3.toLowerCase().includes(item.toLowerCase()) ||
          (this.timeperiodMandatory2
            .toLowerCase()
            .includes(item.toLowerCase()) &&
            !this._configService.isStaticTimeFrame)
        ) {
          if (
            this.singleorMultiSelectMandatory1
              .toLowerCase()
              .includes(item.toLowerCase()) &&
            item.toLowerCase() == 'audience'
          ) {
            this.isSingleaudienceCohortType =
              this._configService.outputSnapshotData.audienceCohortType.toLowerCase() ==
              'single';
            this.isAudienceTotalSample = this._configService.outputSnapshotData
              .audienceTotalSample
              ? true
              : false;
            this.level0Filters.push(item);
            return item;
          } else {
            return item;
          }
        } else {
          if (
            !(
              this.singleorMultiSelectMandatory1
                .toLowerCase()
                .includes('audience') && item.toLowerCase() == 'brands'
            )
          ) {
            this.level0Filters.push(item);
          }
        }
      } else {
        this.level0EntryForOutput.push(item);
        if (!isEPByVariableCode) {
          // Audience (in level0EP): display under Filters
          this.level0Filters.push(item);
          if (
            this.singleorMultiSelectMandatory1
              .toLowerCase()
              .includes(item.toLowerCase()) &&
            item.toLowerCase() == 'audience'
          ) {
            this.isSingleaudienceCohortType =
              this._configService.outputSnapshotData.audienceCohortType.toLowerCase() ==
              'single';
            this.isAudienceTotalSample = this._configService.outputSnapshotData
              .audienceTotalSample
              ? true
              : false;
            return item; // include in Level0Variables for internal processing, hidden from UI later
          }
        }
      }
    });

    if (this.Level0Variables.length > 0) {
      for (let i = 0; i < this.Level0Variables.length; i++) {
        const level0 = this.Level0Variables[i];

        let listToUpdate = [];
        if (
          this.dimensionVariableList.length > 0 &&
          level0Dimensions.includes(level0)
        ) {
          listToUpdate = _.sortBy(
            _.filter(dimensionData, (item) => item.Level0 === level0),
            'sort_id',
          );
        } else if (level0 == 'Audience') {
          const ats =
            this._configService.outputSnapshotData.audienceTotalSample;
          const compareKeys: string[] =
            ats?.is_selected && ats?.config_name
              ? ats.config_name.split('|').map((s: string) => s.trim())
              : [];
          this.audienceTotalSampleList = _.sortBy(
            _.filter(
              result,
              (item: any) =>
                item.Level0?.trim() === 'Audience' &&
                (!compareKeys.length ||
                  (item.Level1?.trim() === compareKeys[0] &&
                    item.Level2?.trim() === compareKeys[1])),
            ),
            'sort_id',
          ).map((item: any) => ({
            Level0: item.Level0,
            Level1: item.Level2,
            Level2: item.Level3 || item.MetricOption,
            Level3: item.Level3 ? item.Level4 || item.MetricOption : '',
            Level4:
              item.Level3 && item.Level4
                ? item.Level5 || item.MetricOption
                : '',
            Level5:
              item.Level3 && item.Level4 && item.Level5
                ? item.Level6 || item.MetricOption
                : '',
            Weekno_forSigcalculation: item.Weekno_forSigcalculation,
            calc_type: item.calculation_type,
            customGroupId: item.customGroupId,
            dataYearCode: item.dataYearCode,
            date: item.date,
            derived_metric_calculation: item.derived_metric_calculation,
            hasNextLevel: item.hasNextLevel,
            is_CustomGroup: item.is_CustomGroup,
            is_brand_analysis: item.is_brand_analysis,
            is_derived: item.is_derived,
            is_dimension: item.is_dimension,
            is_multi_punch: item.is_multi_punch,
            is_time_Period_Present: item.is_time_Period_Present,
            kibanaFilterScript: item.kibanaFilterScript,
            response_code: item.response_code,
            sort_id: item.sort_id,
            variable_code: item.variable_code,
            variable_label: item.variable_label,
            year_code: item.year_code,
          }));

          const audienceObjIndex = this.selectedObjects.findIndex((obj: any) =>
            obj.hasOwnProperty('Audience'),
          );
          if (audienceObjIndex !== -1) {
            this.selectedObjects[audienceObjIndex]['Audience'] = [
              ...this.audienceTotalSampleList,
            ];
          } else {
            this.selectedObjects.push({
              Audience: [...this.audienceTotalSampleList],
            });
          }
        } else {
          listToUpdate = _.sortBy(
            _.filter(result, (item) => item.Level0 === level0),
            'sort_id',
          );
        }

        // Get unique sequence values
        const uniqueSequenceValues = _.uniq(_.map(listToUpdate, 'sequence'));

        let level1Array = [];
        if (
          (uniqueSequenceValues.includes(1) ||
            uniqueSequenceValues.includes(3)) &&
          level0 != 'Audience'
        )
          level1Array = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            0,
            true,
          );
        else if (
          uniqueSequenceValues.includes(2) ||
          uniqueSequenceValues.includes(4) ||
          level0 == 'Audience'
        )
          level1Array = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            1,
            false,
          );

        //Changing the Levels based on FOM for option 1,2,3,4
        // let num = 4;
        // level1Array = this.AdjustLevels(num, level1Array);

        this.variableList.push({
          Level0: level0,
          isEntryPoint: level1Array.some((item: any) => item.isEntryPoint),
          hasNextLevel: true,
          is_selected: false,
          Level1: level1Array,
        });

        if (this.defaultBrandList?.length > 0) {
          const brandsItem = this.variableList.find(
            (v: any) => v.Level0 === 'Brands',
          );
          if (brandsItem) {
            const defaultLevel1 = brandsItem.Level1?.find(
              (l1: any) => l1.Level1_value === 'Default',
            );
            if (defaultLevel1 && Array.isArray(defaultLevel1.Level2)) {
              defaultLevel1.Level2 = defaultLevel1.Level2.filter((l2: any) =>
                this.defaultBrandList.includes(l2.Level2_value),
              );
            }
          }
        }
      }
    }

    // Remove Audience from variableList — it is handled internally (audienceTotalSampleList / selectedObjects)
    // and must not be rendered in the UI variable panel
    this.variableList = this.variableList.filter(
      (item) => item.Level0 !== 'Audience',
    );

    if (this.isAudienceTotalSample) {
      this.variableList.forEach((item) => {
        if (item.Level0 === 'Audience') {
          const alreadyExists = item.Level1.some(
            (l) => l.Level1_value === 'Total Sample',
          );
          this.totalSampleObj.data_variable_code =
            this._configService?.outputSnapshotData?.audienceTotalSample?.config_name;
          if (!alreadyExists) {
            item.Level1.unshift(this.totalSampleObj);
          }
        }
      });
    }

    // Sort time period Level2 options descending (latest first) for all TP types
    const timePeriod = this.variableList.find(
      (v) => v.Level0 === 'Time Period',
    );
    if (timePeriod?.Level1?.length) {
      const timePeriodTypes = [
        'Month',
        'Quarter',
        'Year',
        '3MMA',
        '4MMA',
        '6MMA',
        '12MMA',
        'Week',
      ];
      timePeriod.Level1.forEach((l1: any) => {
        if (
          !timePeriodTypes.includes(l1.Level1_value) ||
          !Array.isArray(l1.Level2)
        ) {
          return;
        }
        l1.Level2 = l1.Level2.sort((a: any, b: any) => {
          let dateA: Date | null = null;
          let dateB: Date | null = null;
          if (l1.Level1_value === 'Month') {
            dateA = this.parseDate(a.Level2_value);
            dateB = this.parseDate(b.Level2_value);
          } else {
            dateA = a.date ? new Date(a.date) : null;
            dateB = b.date ? new Date(b.date) : null;
            if (dateA && isNaN(dateA.getTime())) dateA = null;
            if (dateB && isNaN(dateB.getTime())) dateB = null;
          }
          if (dateA && dateB) {
            return dateB.getTime() - dateA.getTime(); // latest first
          }
          return 0;
        });
        // First option under each granularity: Most recent (tracks latest data load)
        injectMostRecentIntoSnapshotLevel2(l1);
      });
    }
    if (this.selectedcompareacrossOption == 'Multiple Brands') {
      this._configService.brandSortId = _.cloneDeep(
        this.variableList
          .filter((v) => v.Level0 == 'Brands')[0]
          .Level1[0].Level2.map((l: any) => ({
            name: l.Level2_value,
            sortId: l.sort_id,
          })),
      );
    }
    //for filters
    this.removePreLoadFiltersFromLevel0Filters();
    this.variableListFilter = [];
    if (this.level0Filters.length > 0) {
      let filtersLevel0: {
        LevelMinus: string;
        isEntryPoint: boolean;
        hasNextLevel: boolean;
        is_selected: boolean;
        Level1: any[];
      } = {
        LevelMinus: 'Filters',
        isEntryPoint: false,
        hasNextLevel: true,
        is_selected: false,
        Level1: [],
      };

      let result1 = result.filter((res: any) => {
        return (
          res.Level0 != 'Metrics' ||
          (res.Level0 == 'Metrics' && res.calculation_type != 'mean')
        );
      });

      for (let i = 0; i < this.level0Filters.length; i++) {
        const level0 = this.level0Filters[i];

        let listToUpdate = [];
        if (
          this.dimensionVariableList.length > 0 &&
          level0DimensionsExceptDim.includes(level0)
        ) {
          listToUpdate = _.sortBy(
            _.filter(
              allDimensionDataExceptDim,
              (item) => item.Level0 === level0,
            ),
            'sort_id',
          );
        } else {
          listToUpdate = _.sortBy(
            _.filter(result1, (item) => item.Level0 === level0),
            'sort_id',
          );
        }

        // Get unique sequence values
        const uniqueSequenceValues = _.uniq(_.map(listToUpdate, 'sequence'));

        let level1ArrayItem: any[] = [];
        if (
          uniqueSequenceValues.includes(1) ||
          uniqueSequenceValues.includes(3)
        )
          level1ArrayItem = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            0,
            true,
          );
        else if (
          uniqueSequenceValues.includes(2) ||
          uniqueSequenceValues.includes(4)
        )
          level1ArrayItem = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            1,
            false,
          );

        //Changing the Levels based on FOM for option 1,2,3,4
        // let num = 3;
        // level1ArrayItem = this.AdjustLevels(num, level1ArrayItem);

        filtersLevel0.Level1.push({
          Level0: level0,
          isEntryPoint: false,
          hasNextLevel: true,
          Level1: level1ArrayItem,
          is_selected: false,
        });
      }

      this.variableListFilter.push(filtersLevel0);
    }

    //-------------This is for entry points for output

    let selectedEPAll: any[] = [];
    let selectedEPAllParent: any[] = [];

    let aa = this.dataArray.map(
      (obj) =>
        Object.keys(obj)
          .filter((key) => key.startsWith('EntryPoint'))
          .map((key) => obj[key]), // Access the values of those keys
    );
    for (let i = 0; i < this.dataArray.length; i++) {
      if (aa[i][0] != undefined) {
        selectedEPAll.push(
          ...aa[i][0]?.Level2[0].MetricOptions.map((mo: any) => mo.Name),
        );
        selectedEPAllParent.push(aa[i][0]?.Level2[0].Parent);
      }
    }

    // FAS Total must match the three real FOM audience labels so Filter gets hcategory _2/_3/_4
    selectedEPAll = this.expandFasTotalNames(selectedEPAll);

    if (this.level0EntryForOutput.length > 0) {
      this.variableListEpForOutput = [];
      for (let i = 0; i < this.level0EntryForOutput.length; i++) {
        const level0 = this.level0EntryForOutput[i];
        const listToUpdate = _.sortBy(
          _.filter(result, (item) => item.Level0 === level0),
          'sort_id',
        );

        // Get unique sequence values
        const uniqueSequenceValues = _.uniq(_.map(listToUpdate, 'sequence'));

        let level1Array = [];
        if (
          uniqueSequenceValues.includes(1) ||
          uniqueSequenceValues.includes(3)
        )
          level1Array = this.createNestedLevelsEPForOutput(
            listToUpdate,
            '',
            'Level0',
            level0,
            'Level0',
            0,
            true,
            selectedEPAll,
            selectedEPAllParent,
          );
        else if (
          uniqueSequenceValues.includes(2) ||
          uniqueSequenceValues.includes(4)
        )
          level1Array = this.createNestedLevelsEPForOutput(
            listToUpdate,
            '',
            'Level0',
            level0,
            'Level0',
            1,
            false,
            selectedEPAll,
            selectedEPAllParent,
          );

        //Changing the Levels based on FOM for option 1,2,3,4
        // let num = 4;
        // level1Array = this.AdjustLevels(num, level1Array);
        // this.variableListEpForOutput = [];

        this.variableListEpForOutput.push({
          Level0: level0,
          // isEntryPoint: level1Array.some((item: any) => item.isEntryPoint),
          isEntryPoint: true,
          hasNextLevel: true,
          is_selected: true,
          Level1: level1Array,
        });
      }
    }
    this.AddCustomPercentageToAudience();
  }

  AddCustomPercentageToAudience() {
    // 1. Find Audience in variableList
    const audienceObj = this.variableList.find(
      (x: any) => x.Level0?.toLowerCase() === 'audience',
    );

    if (!audienceObj) return;

    if (!Array.isArray(audienceObj.Level1)) {
      audienceObj.Level1 = [];
    }

    // 2. Get all custom percentage blocks
    const customBlocks = this.variableListFilter[0].Level1.filter((x: any) =>
      x.Level0?.toLowerCase().includes('custom percentage variable'),
    );

    // 3. Process each block
    customBlocks.forEach((block: any) => {
      // Copy all properties of the block
      const newBlock: any = { ...block };

      // Replace Level1 with flattened Level2 array
      newBlock.Level2 = [];
      newBlock.Level1_value = block.Level0; // Keep original Level0 as Level1_value
      delete newBlock.Level1; // remove old Level1 wrapper

      // Flatten all items from original block.Level1
      (block.Level1 || []).forEach((item: any) => {
        const level2Item = { ...item, Level2_value: item.Level1_value };
        delete level2Item.Level1_value;
        newBlock.Level2.push(level2Item);
      });

      audienceObj.Level1.push(newBlock);
    });

    // variableListFilter remains untouched
  }

  parseDate(value: string): Date | null {
    // Extract and parse "Jan_2021" format
    const parts = value?.split('_');
    if (parts?.length === 2) {
      const month = parts[0];
      const year = parts[1];
      return new Date(Date.parse(`${month} 1, ${year}`)); // Convert to a valid Date object
    }
    return null; // Return null for invalid or missing values
  }
  removeLastLevel: boolean = false;
  createNestedLevels(
    data: any[],
    parentParent4Value: String,
    parentLevel4Key: string,
    parentParent3Value: String,
    parentLevel3Key: string,
    parentParent2Value: String,
    parentLevel2Key: string,
    parentParentValue: string,
    parentLevelKey: string,
    parentValue: string,
    levelKey: string,
    level: number,
    isBrandAudience: Boolean,
  ): any[] {
    let nextLevelKey = `Level${level + 1}`;
    const levelVariables = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            (parentLevel4Key == 'Level0' ||
              item[parentLevel4Key] == parentParent4Value) &&
            (parentLevel3Key == 'Level0' ||
              item[parentLevel3Key] == parentParent3Value) &&
            (parentLevel2Key == 'Level0' ||
              item[parentLevel2Key] == parentParent2Value) &&
            (parentLevelKey == 'Level0' ||
              item[parentLevelKey] == parentParentValue) &&
            item[levelKey] === parentValue &&
            item[nextLevelKey],
        ),
        nextLevelKey,
      ),
    );
    if (levelVariables.length > 0) {
      return levelVariables.map((levelVar) => {
        const filteredItems = _.filter(
          data,
          (item) =>
            (parentLevelKey == 'Level0' ||
              item[parentLevelKey] == parentParentValue) &&
            item[levelKey] === parentValue &&
            item[nextLevelKey] === levelVar,
        );
        const nextLevelData = this.createNestedLevels(
          data,
          parentParent3Value,
          parentLevel3Key,
          parentParent2Value,
          parentLevel2Key,
          parentParentValue,
          parentLevelKey,
          parentValue,
          levelKey,
          levelVar,
          nextLevelKey,
          level + 1,
          isBrandAudience,
        );

        if (this.removeLastLevel) {
          this.removeLastLevel = false;
          if (isBrandAudience)
            return {
              [`Level${level + 1}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 2}`]: [],
              hasNextLevel: false,
              ...this.extractAdditionalData(filteredItems),
            };
          else
            return {
              [`Level${level}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 1}`]: [],
              hasNextLevel: false,
              ...this.extractAdditionalData(filteredItems),
            };
        } else {
          if (isBrandAudience)
            return {
              [`Level${level + 1}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 2}`]: nextLevelData,
              hasNextLevel: true,
              ...this.extractAdditionalData(filteredItems),
            };
          else
            return {
              [`Level${level}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 1}`]: nextLevelData,
              hasNextLevel: true,
              ...this.extractAdditionalData(filteredItems),
            };
        }
      });
    } else {
      const filteredItems = _.filter(
        data,
        (item) =>
          (parentLevel4Key == 'Level0' ||
            item[parentLevel4Key] == parentParent4Value) &&
          (parentLevel3Key == 'Level0' ||
            item[parentLevel3Key] == parentParent3Value) &&
          (parentLevel2Key == 'Level0' ||
            item[parentLevel2Key] == parentParent2Value) &&
          (parentLevelKey == 'Level0' ||
            item[parentLevelKey] == parentParentValue) &&
          item[levelKey] === parentValue,
      );
      return filteredItems.map((item) => {
        const metricOption = item.MetricOption || '';

        let num = item.sequence;

        if (isBrandAudience) {
          if (num == 3 || metricOption == '') {
            this.removeLastLevel = true; //for 3
          } else {
            this.removeLastLevel = false; //for 1
          }

          return {
            [`Level${level + 1}_value`]: item[nextLevelKey] || metricOption,
            isEntryPoint: false,
            [`Level${level + 2}`]: [],
            hasNextLevel: false,
            ...this.extractAdditionalData([item]),
          };
        } else {
          if (
            num == 4 ||
            metricOption == '' ||
            (data[0].Level0 == 'Audience' && num == 3)
          ) {
            this.removeLastLevel = true; // for seq=4
          } else {
            this.removeLastLevel = false; //seq =2
          }
          return {
            [`Level${level}_value`]: item[nextLevelKey] || metricOption,
            isEntryPoint: false,
            [`Level${level + 1}`]: [],
            hasNextLevel: false,
            ...this.extractAdditionalData([item]),
          };
        }
      });
    }
  }

  extractAdditionalData(items: any[]): any {
    const firstItem = items[0];
    return {
      is_derived: firstItem.is_derived_variable,
      calc_type: firstItem.calculation_type,
      tooltip: firstItem.tooltip,
      data_variable_code: firstItem.data_variable_code,
      response_code: firstItem.response_code,
      derived_metric_calculation: firstItem.derived_metric_calculation,
      sort_id:
        firstItem.Level0 == 'Time Period'
          ? Number(firstItem.level1_sort_id)
          : Number(firstItem.sort_id),
      is_multi_punch: firstItem.is_multi_punch,
      date: firstItem.date,
      year_code: firstItem.year_code,
      is_dimension: firstItem.is_dimension,
      isCustomGrpPresent: firstItem.is_CustomGroup,
      isCustomCalcPresent: firstItem.is_CustomCalculation,
      // kibanaFilterScript: firstItem.customGroupQuery,
      kibanaFilterScript: firstItem.is_CustomGroup
        ? firstItem.customGroupQuery
        : firstItem.customCalculation
          ? firstItem.customCalculationQuery
          : '',
      dataYearCode: firstItem.dataYearCode,
      is_time_Period_Present: firstItem.is_time_Period_Present,
      customGroupId: firstItem.customGroupId,
      customCalculationId: firstItem.customCalculationId,
      is_brand_analysis: firstItem.is_brandanalysis,
      is_selected: false,
      Weekno_forSigcalculation: firstItem.Weekno_forSigcalculation,
    };
  }

  createNestedLevelsEPForOutput(
    data: any[],
    parentParentValue: string,
    parentLevelKey: string,
    parentValue: string,
    levelKey: string,
    level: number,
    isBrandAudience: Boolean,
    selectedEPAll: any[],
    selectedEPAllParent: any[],
  ): any[] {
    const nextLevelKey = `Level${level + 1}`;
    const levelVariables = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            (parentLevelKey == 'Level0' ||
              item[parentLevelKey] == parentParentValue) &&
            item[levelKey] === parentValue &&
            item[nextLevelKey],
        ),
        nextLevelKey,
      ),
    );

    if (levelVariables.length > 0) {
      return levelVariables.map((levelVar) => {
        const filteredItems = _.filter(
          data,
          (item) =>
            (parentLevelKey == 'Level0' ||
              item[parentLevelKey] == parentParentValue) &&
            item[levelKey] === parentValue &&
            item[nextLevelKey] === levelVar,
        );
        const nextLevelData = this.createNestedLevelsEPForOutput(
          data,
          parentValue,
          levelKey,
          levelVar,
          nextLevelKey,
          level + 1,
          isBrandAudience,
          selectedEPAll,
          selectedEPAllParent,
        );

        if (this.removeLastLevel) {
          this.removeLastLevel = false;
          if (isBrandAudience)
            return {
              [`Level${level + 1}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 2}`]: [],
              hasNextLevel: false,
              ...this.extractAdditionalDataEPForOutput(
                filteredItems,
                selectedEPAll,
                selectedEPAllParent,
                levelVar,
                '',
              ),
            };
          else
            return {
              [`Level${level}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 1}`]: [],
              hasNextLevel: false,
              ...this.extractAdditionalDataEPForOutput(
                filteredItems,
                selectedEPAll,
                selectedEPAllParent,
                levelVar,
                '',
              ),
            };
        } else {
          if (isBrandAudience)
            return {
              [`Level${level + 1}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 2}`]: nextLevelData,
              hasNextLevel: true,
              ...this.extractAdditionalDataEPForOutput(
                filteredItems,
                selectedEPAll,
                selectedEPAllParent,
                levelVar,
                levelVar,
              ),
            };
          else
            return {
              [`Level${level}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 1}`]: nextLevelData,
              hasNextLevel: true,
              ...this.extractAdditionalDataEPForOutput(
                filteredItems,
                selectedEPAll,
                selectedEPAllParent,
                levelVar,
                levelVar,
              ),
            };
        }
      });
    } else {
      const filteredItems = _.filter(
        data,
        (item) =>
          (parentLevelKey == 'Level0' ||
            item[parentLevelKey] == parentParentValue) &&
          item[levelKey] === parentValue,
      );
      return filteredItems.map((item) => {
        const metricOption = item.MetricOption || '';
        let num = item.sequence;

        if (isBrandAudience) {
          if (num == 3 || metricOption == '') {
            this.removeLastLevel = true;
          } else {
            this.removeLastLevel = false;
          }

          return {
            [`Level${level + 1}_value`]: item[nextLevelKey] || metricOption,
            isEntryPoint: false,
            [`Level${level + 2}`]: [],
            hasNextLevel: false,
            ...this.extractAdditionalDataEPForOutput(
              [item],
              selectedEPAll,
              selectedEPAllParent,
              item[nextLevelKey] || metricOption,
              '',
            ),
          };
        } else {
          if (num == 4 || metricOption == '') {
            this.removeLastLevel = true;
          } else {
            this.removeLastLevel = false;
          }
          return {
            [`Level${level}_value`]: item[nextLevelKey] || metricOption,
            isEntryPoint: false,
            [`Level${level + 1}`]: [],
            hasNextLevel: false,
            ...this.extractAdditionalDataEPForOutput(
              [item],
              selectedEPAll,
              selectedEPAllParent,
              item[nextLevelKey] || metricOption,
              '',
            ),
          };
        }
      });
    }
  }

  extractAdditionalDataEPForOutput(
    items: any[],
    selectedEPAll: any,
    selectedEPAllParent: any,
    levelValue: any,
    levelParentValue: any,
  ): any {
    const firstItem = items[0];

    return {
      is_derived: firstItem.is_derived_variable,
      calc_type: firstItem.calculation_type,
      tooltip: firstItem.tooltip,
      data_variable_code: firstItem.data_variable_code,
      response_code: firstItem.response_code,
      derived_metric_calculation: firstItem.derived_metric_calculation,
      sort_id: firstItem.sort_id,
      is_multi_punch: firstItem.is_multi_punch,
      date: firstItem.date,
      year_code: firstItem.year_code,
      is_dimension: firstItem.is_dimension,
      isCustomGrpPresent: firstItem.is_CustomGroup,
      kibanaFilterScript: firstItem.customGroupQuery,
      dataYearCode: firstItem.dataYearCode,
      is_time_Period_Present: firstItem.is_time_Period_Present,
      customGroupId: firstItem.customGroupId,
      is_brand_analysis: firstItem.is_brandanalysis,
      is_selected:
        selectedEPAll.includes(levelValue) ||
        selectedEPAllParent.includes(levelParentValue),
    };
  }

  AdjustLevels(number: number, filtersLevel0: any) {
    if (number == 4) {
      let lastlev1: boolean = false;
      let lastlev2: boolean = false;
      let lastlev3: boolean = false;
      let lastlev4: boolean = false;
      let lastlev5: boolean = false;
      for (let level1 of filtersLevel0) {
        for (let level2 of level1.Level2) {
          for (let level3 of level2.Level3) {
            for (let level4 of level3.Level4) {
              for (let level5 of level4.Level5) {
                // level5.Level6.forEach((level6: any) => {
                // });
                if (level5.hasNextLevel) {
                  level5.Level6 = [];
                  level5.hasNextLevel = false;
                  lastlev5 = true;
                }
              }
              if (lastlev5) continue;
              else lastlev5 = false;

              if (level4.hasNextLevel) {
                level4.Level5 = [];
                level4.hasNextLevel = false;
                lastlev4 = true;
              }
            }
            if (lastlev4) continue;
            else lastlev4 = false;
            if (level3.hasNextLevel) {
              level3.Level4 = [];
              level3.hasNextLevel = false;
              lastlev3 = true;
            }
          }
          if (lastlev3) continue;
          else lastlev3 = false;
          if (level2.hasNextLevel) {
            level2.Level3 = [];
            level2.hasNextLevel = false;
            lastlev2 = true;
          }
        }
        if (lastlev2) continue;
        else lastlev2 = false;
        if (level1.hasNextLevel) {
          level1.Level2 = [];
          level1.hasNextLevel = false;
        }
      }
    } else if (number == 3) {
      let lastlev1: boolean = false;
      let lastlev2: boolean = false;
      let lastlev3: boolean = false;
      let lastlev4: boolean = false;
      let lastlev5: boolean = false;
      for (let level1 of filtersLevel0) {
        for (let level2 of level1.Level2) {
          for (let level3 of level2.Level3) {
            for (let level4 of level3.Level4) {
              for (let level5 of level4.Level5) {
                if (level5.hasNextLevel) {
                  level5.Level6 = [];
                  level5.hasNextLevel = false;
                  lastlev5 = true;
                }
              }
              if (lastlev5) continue;
              else lastlev5 = false;

              if (level4.hasNextLevel) {
                level4.Level5 = [];
                level4.hasNextLevel = false;
                lastlev4 = true;
              }
            }
            if (lastlev4) continue;
            else lastlev4 = false;

            if (level3.hasNextLevel) {
              level3.Level4 = [];
              level3.hasNextLevel = false;
              lastlev3 = true;
            }
          }
          if (lastlev3) continue;
          else lastlev3 = false;

          if (level2.hasNextLevel) {
            level2.Level3 = [];
            level2.hasNextLevel = false;
            lastlev2 = true;
          }
        }
        if (lastlev2) continue;
        else lastlev2 = false;

        if (level1.hasNextLevel) {
          level1.Level2 = [];
          level1.hasNextLevel = false;
          lastlev1 = true;
        }
      }
    }

    return filtersLevel0;
  }

  IsDimension(parentOption: any) {
    return this.dimensionList.includes(parentOption);
  }

  ClearAll(): void {
    this.isVariableTab = false;
    this.is_load_btn = true;
    this.isClearEverything.emit();
  }

  private isClickInside(event: Event, className: string): boolean {
    return !!(event.target as Element)?.closest(className);
  }

  selectAll(Parent: string, Selection: string) {
    this.isSelectAll = !this.isSelectAll;
    let selectedList: any[] = [];
    let callback: ((item: any) => void) | undefined = undefined;
    selectedList = this.entryPanel_Lvl3;
    callback = (item) =>
      this.checkBoxClick(
        0,
        item.Level,
        '',
        item.Level1,
        item.Level2,
        item.MetricOptions,
        item.variableCode,
        item.responseCode,
        item.mandatory_variable_mapping,
        this.isSelectAll,
        item.e1_variable_code,
        item.e2_variable_code,
        item.e3_variable_code,
        item.dimension,
      );
    if (selectedList && callback) {
      this.processSelectedList(selectedList, callback);
    }
  }
  private processSelectedList(
    selectedList: any[],
    callback: (item: any) => void,
  ): void {
    for (const item of selectedList) {
      callback(item);
    }
  }

  private isSameSelectedItem(a: any, b: any): boolean {
    return (
      a.response_code === b.response_code &&
      a.variable_label === b.variable_label &&
      a.Level0 === b.Level0 &&
      a.Level1 === b.Level1 &&
      a.Level2 === b.Level2 &&
      (a.Level3 ?? '') === (b.Level3 ?? '') &&
      (a.Level4 ?? '') === (b.Level4 ?? '') &&
      (a.Level5 ?? '') === (b.Level5 ?? '')
    );
  }

  private getAllSelectedItemsFromObjects(): any[] {
    return this.selectedObjects.flatMap((obj) => {
      const key = Object.keys(obj)[0];
      const values = obj[key];
      return Array.isArray(values) ? values : [];
    });
  }

  private isRadioTrackedSelection(item: any): boolean {
    return (
      item?.Level0 === 'Time Period' ||
      item?.Level0 === '' ||
      (item?.Level0 === 'Audience' && this.isSingleaudienceCohortType)
    );
  }

  private isFilteresSelection(item: any): boolean {
    return item?.Level0 === '';
  }

  private summaryLevelsMatch(a: any, b: any, upToLevel: number): boolean {
    for (let i = 0; i <= upToLevel; i++) {
      if ((a?.[`Level${i}`] ?? '') !== (b?.[`Level${i}`] ?? '')) {
        return false;
      }
    }
    return true;
  }

  private getSummaryDeepestLevel(obj: any): number {
    for (let i = 9; i >= 0; i--) {
      if ((obj?.[`Level${i}`] ?? '') !== '') {
        return i;
      }
    }
    return -1;
  }

  private formatSummaryLevelsFrom(obj: any, fromLevel: number): string {
    const parts: string[] = [];
    for (let i = fromLevel; i <= 9; i++) {
      const value = `${obj?.[`Level${i}`] ?? ''}`.trim();
      if (value) {
        parts.push(value);
      }
    }
    return parts.join(': ');
  }

  private clearSummaryLevelsFrom(obj: any, fromLevel: number): void {
    for (let i = fromLevel; i <= 9; i++) {
      obj[`Level${i}`] = '';
    }
  }

  /**
   * Brand/Product-dependent filters (e.g. Attributes) store Brand + response
   * on Level6/Level7. Merge those leaf values, then fold them into Level5 so
   * the existing L0–L5 selection-summary nesting/formatters include them.
   */
  private prepareDeepFilterLevelsForSummary(items: any[]): any[] {
    const source = structuredClone(items || []);
    const deepItems = source.filter(
      (item: any) => this.getSummaryDeepestLevel(item) >= 6,
    );
    const shallowItems = source.filter(
      (item: any) => this.getSummaryDeepestLevel(item) < 6,
    );

    const mergedDeep = deepItems.reduce((acc: any[], obj: any) => {
      const deep = this.getSummaryDeepestLevel(obj);
      const leafKey = `Level${deep}`;
      const existingObj = acc.find(
        (o: any) =>
          this.summaryLevelsMatch(o, obj, deep - 1) &&
          this.getSummaryDeepestLevel(o) === deep,
      );

      if (existingObj) {
        existingObj[leafKey] = existingObj[leafKey]
          ? `${existingObj[leafKey]}, ${obj[leafKey]}`
          : obj[leafKey];
      } else {
        acc.push(obj);
      }
      return acc;
    }, []);

    return [
      ...mergedDeep.map((item: any) => {
        item.Level5 = this.formatSummaryLevelsFrom(item, 5);
        this.clearSummaryLevelsFrom(item, 6);
        return item;
      }),
      ...shallowItems,
    ];
  }

  private syncVariablesSummaryFromSelectedObjects(): void {
    let allSelectedItems = this.getAllSelectedItemsFromObjects();
    allSelectedItems = allSelectedItems.filter(
      (item) => item.Level0 !== 'Audience',
    );
    this.variablesSummaryObj = allSelectedItems.filter(
      (item: any) =>
        item?.Level0 &&
        !this.isRadioTrackedSelection(item) &&
        item.Level0 !== 'Audience' &&
        (item.Level0 !== 'Brands' ||
          item.Level1 === 'Brands' ||
          (this.defaultBrandList?.length > 0 && item.Level1 === 'Default')),
    );

    //Adding filters selection to summary object
    let allFilters = allSelectedItems.filter((item: any) =>
      this.isFilteresSelection(item),
    );

    for (let i = 0; i < allFilters.length; i++) {
      this.variablesSummaryObj.push(allFilters[i]);
    }

    const radioSelections = allSelectedItems.filter((item: any) =>
      this.isRadioTrackedSelection(item),
    );
    if (radioSelections.length > 0) {
      this.variablesSummaryObjRadio = radioSelections;
    } else {
      this.variablesSummaryObjRadio = this.variablesSummaryObjRadio.filter(
        (item: any) =>
          allSelectedItems.some((selected) =>
            this.isSameSelectedItem(selected, item),
          ),
      );
    }
  }

  private removeDuplicateAudienceFromFilterSummary(
    variableSelectionSummary: string,
    variableFilterSelectionSummary: string,
  ): string {
    if (
      !variableFilterSelectionSummary ||
      !/audience\s*:/i.test(variableSelectionSummary)
    ) {
      return variableFilterSelectionSummary;
    }

    return variableFilterSelectionSummary
      .split(';')
      .map((entry) => entry.trim())
      .filter((entry) => entry && !/^audience\s*:/i.test(entry))
      .join('; ');
  }

  UpdateSelectionSummary() {
    this.syncVariablesSummaryFromSelectedObjects();
    const infoRibbonDiv = document.querySelector(
      '.InforRibbonEntireSummary',
    ) as HTMLDivElement;
    const infoRibbonTextValuesDiv = document.querySelector(
      '.InforRibbonTextValues',
    ) as HTMLDivElement;

    let entryPoints1Level1 = this.dataArray[0].EntryPoint1?.hasOwnProperty(
      'Level1',
    )
      ? this.dataArray[0].EntryPoint1.Level1
      : [];
    let entryPoints1Level2 = this.dataArray[0].EntryPoint1?.hasOwnProperty(
      'Level2',
    )
      ? this.dataArray[0].EntryPoint1.Level2[0].MetricOptions.map(
          (a: any) => a.Name,
        ).join(', ')
      : '';

    let entryPoints2Level1 =
      this.dataArray.length > 1 &&
      this.dataArray[1].EntryPoint2?.hasOwnProperty('Level1')
        ? this.dataArray[1].EntryPoint2.Level1
        : [];
    let entryPoints2Level2 =
      this.dataArray.length > 1 &&
      this.dataArray[1].EntryPoint2?.hasOwnProperty('Level2')
        ? this.dataArray[1].EntryPoint2.Level2[0].MetricOptions.map(
            (a: any) => a.Name,
          ).join(', ')
        : '';

    let entryPoints3Level1 =
      this.dataArray.length > 2 &&
      this.dataArray[2].EntryPoint3?.hasOwnProperty('Level1')
        ? this.dataArray[2].EntryPoint3.Level1
        : [];
    let entryPoints3Level2 =
      this.dataArray.length > 2 &&
      this.dataArray[2].EntryPoint3?.hasOwnProperty('Level2')
        ? this.dataArray[2].EntryPoint3.Level2[0].MetricOptions.map(
            (a: any) => a.Name,
          ).join(', ')
        : '';
    let variablesSummaryObjAll = structuredClone(this.variablesSummaryObj);

    variablesSummaryObjAll = variablesSummaryObjAll.filter(
      (item: any, index: number, self: any[]) =>
        index ===
        self.findIndex(
          (other: any) =>
            other.Level0 === item.Level0 &&
            other.Level1 === item.Level1 &&
            other.Level2 === item.Level2 &&
            other.Level3 === item.Level3 &&
            other.Level4 === item.Level4 &&
            other.Level5 === item.Level5 &&
            other.Level6 === item.Level6 &&
            other.Level7 === item.Level7 &&
            other.Level8 === item.Level8 &&
            other.Level9 === item.Level9,
        ),
    );

    variablesSummaryObjAll = variablesSummaryObjAll.filter(
      (item: any) => item.Level0 !== 'Brands' || item.Level1 !== 'Default',
    );

    // Attributes (PB-dependent) etc.: fold Brand + response (L6+) into Level5
    variablesSummaryObjAll =
      this.prepareDeepFilterLevelsForSummary(variablesSummaryObjAll);

    let variablesSummaryObjLastLevel = variablesSummaryObjAll.reduce(
      (acc: any, obj: any) => {
        if (obj.Level5 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2 &&
              o.Level3 === obj.Level3 &&
              o.Level4 === obj.Level4,
          );

          if (existingObj) {
            const separator =
              `${existingObj.Level5}`.includes(':') ||
              `${obj.Level5}`.includes(':')
                ? '; '
                : ', ';
            existingObj.Level5 = existingObj.Level5
              ? `${existingObj.Level5}${separator}${obj.Level5}`
              : obj.Level5;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level4 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2 &&
              o.Level3 === obj.Level3,
          );

          if (existingObj) {
            existingObj.Level4 = existingObj.Level4
              ? `${existingObj.Level4}, ${obj.Level4}`
              : obj.Level4;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level3 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2,
          );

          if (existingObj) {
            existingObj.Level3 = existingObj.Level3
              ? `${existingObj.Level3}, ${obj.Level3}`
              : obj.Level3;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1,
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}, ${obj.Level2}`
              : obj.Level2;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}, ${obj.Level1}`
              : obj.Level1;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }

        return acc;
      },
      [],
    );

    let variablesSummaryObjLastLevelAll = structuredClone(
      variablesSummaryObjLastLevel,
    );

    let variablesSummaryObjSecondLastLevel =
      variablesSummaryObjLastLevelAll.reduce((acc: any, obj: any) => {
        if (obj.Level4 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2 &&
              o.Level3 === obj.Level3,
          );

          if (existingObj) {
            const existingTail = this.formatSummaryLevelsFrom(existingObj, 5);
            const objTail = this.formatSummaryLevelsFrom(obj, 5);
            existingObj.Level4 = existingObj.Level4
              ? `${existingObj.Level4}: ${existingTail}; ${obj.Level4}: ${objTail}`
              : obj.Level4;
            this.clearSummaryLevelsFrom(existingObj, 5);
          } else {
            acc.push(obj);
          }
        } else if (obj.Level3 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2,
          );

          if (existingObj) {
            existingObj.Level3 = existingObj.Level3
              ? `${existingObj.Level3}: ${existingObj.Level4}; ${obj.Level3}: ${obj.Level4}`
              : obj.Level3;
            existingObj.Level4 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1,
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}: ${existingObj.Level3}; ${obj.Level2}: ${obj.Level3}`
              : obj.Level2;
            existingObj.Level3 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}: ${existingObj.Level2}; ${obj.Level1}: ${obj.Level2}`
              : obj.Level1;
            existingObj.Level2 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }

        return acc;
      }, []);

    let variablesSummaryObjSecondLastLevelAll = structuredClone(
      variablesSummaryObjSecondLastLevel,
    );

    let variablesSummaryObjThirdLevel =
      variablesSummaryObjSecondLastLevelAll.reduce((acc: any, obj: any) => {
        if (obj.Level4 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2 &&
              o.Level3 === obj.Level3,
          );

          if (existingObj) {
            const existingTail = this.formatSummaryLevelsFrom(existingObj, 5);
            const objTail = this.formatSummaryLevelsFrom(obj, 5);
            existingObj.Level4 = existingObj.Level4
              ? `${existingObj.Level4}: ${existingTail}; ${obj.Level4}: ${objTail}`
              : obj.Level4;
            this.clearSummaryLevelsFrom(existingObj, 5);
          } else {
            acc.push(obj);
          }
        } else if (obj.Level3 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2,
          );

          if (existingObj) {
            existingObj.Level3 = existingObj.Level3
              ? `${existingObj.Level3}: ${existingObj.Level4}; ${obj.Level3}: ${obj.Level4}`
              : obj.Level3;
            existingObj.Level4 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1,
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}: ${existingObj.Level3}; ${obj.Level2}: ${obj.Level3}`
              : obj.Level2;
            existingObj.Level3 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}: ${existingObj.Level2}; ${obj.Level1}: ${obj.Level2}`
              : obj.Level1;
            existingObj.Level2 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }
        return acc;
      }, []);

    let variablesSummaryObjThirdLevelAll = structuredClone(
      variablesSummaryObjThirdLevel,
    );

    let variablesSummaryObjsecondLevel =
      variablesSummaryObjThirdLevelAll.reduce((acc: any, obj: any) => {
        if (obj.Level3 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2,
          );

          if (existingObj) {
            existingObj.Level3 = existingObj.Level3
              ? `${existingObj.Level3}: ${existingObj.Level4}; ${obj.Level3}: ${obj.Level4}`
              : obj.Level3;
            existingObj.Level4 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1,
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}: ${existingObj.Level3}; ${obj.Level2}: ${obj.Level3}`
              : obj.Level2;
            existingObj.Level3 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}: ${existingObj.Level2}; ${obj.Level1}: ${obj.Level2}`
              : obj.Level1;
            existingObj.Level2 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }
        return acc;
      }, []);

    let variablesSummaryObjSecondLevelAll = structuredClone(
      variablesSummaryObjsecondLevel,
    );

    let variablesSummaryObjFirstLevel =
      variablesSummaryObjSecondLevelAll.reduce((acc: any, obj: any) => {
        if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1,
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}: ${existingObj.Level3}; ${obj.Level2}: ${obj.Level3}`
              : obj.Level2;
            existingObj.Level3 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}: ${existingObj.Level2}; ${obj.Level1}: ${obj.Level2}`
              : obj.Level1;
            existingObj.Level2 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }
        return acc;
      }, []);

    let variableSelectionSummary = '';
    let variableFilterSelectionSummary = '';

    for (let i = 0; i < this.variableList.length; i++) {
      let checkRadioMet = this.variablesSummaryObjRadio.map(
        (a: any) => a.Level0,
      );
      let checkboxesMet = variablesSummaryObjsecondLevel.map(
        (a: any) => a.Level1,
      );

      if (
        i != 0 &&
        (checkRadioMet.includes(this.variableList[i].Level0) ||
          checkboxesMet.includes(this.variableList[i].Level0) ||
          checkboxesMet.includes(this.variableList[i].Level1[0].Level1_value))
      )
        variableSelectionSummary += ' | ';

      this.variablesSummaryObj = this.variablesSummaryObj.filter(
        (item: any, index: number, self: any[]) =>
          index ===
          self.findIndex(
            (other: any) =>
              other.Level0 === item.Level0 &&
              other.Level1 === item.Level1 &&
              other.Level2 === item.Level2 &&
              other.Level3 === item.Level3 &&
              other.Level4 === item.Level4 &&
              other.Level5 === item.Level5 &&
              other.Level6 === item.Level6 &&
              other.Level7 === item.Level7 &&
              other.Level8 === item.Level8 &&
              other.Level9 === item.Level9,
          ),
      );
      if (this.selectedcompareacrossOption == 'Multiple Markets') {
        this.variablesSummaryObj.forEach((item: any, index: number) => {
          if (this.variableListMultiMarketAndCateg.length > i) {
            if (this.variableListMultiMarketAndCateg[i].Level0 == item.Level0) {
              if (
                index != 0 &&
                !(
                  variableSelectionSummary == '' ||
                  variableFilterSelectionSummary == '' ||
                  variableSelectionSummary.trim().endsWith(':') ||
                  variableSelectionSummary.trim().endsWith('|')
                )
              )
                variableSelectionSummary += '; ';

              if (item.Level5 != '' || item.Level6 != '' || item.Level7 != '') {
                variableSelectionSummary +=
                  `${this.formatSummaryLevelsFrom(item, 0)} `;
              } else if (item.Level4 != '') {
                variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4} `;
              } else if (item.Level3 != '') {
                variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3} `;
              } else if (item.Level2 != '') {
                variableSelectionSummary +=
                  index == 0
                    ? `${item.Level0}:${item.Level2},`
                    : `${item.Level2 + ','}`; //`${item.Level0} : ${item.Level1}: ${item.Level2} `;
              } else if (item.Level1 != '') {
                variableSelectionSummary += `${item.Level0}: ${item.Level1} `;
              } else if (item.Level0 != '') {
                variableSelectionSummary += `${item.Level0} `;
              }
            }
          }
        });
        //remove the last character from variableSelectionSummary
        variableSelectionSummary = variableSelectionSummary.slice(0, -1);
        variableSelectionSummary += ' | ';
      }

      this.variablesSummaryObjRadio.forEach((item: any, index: Number) => {
        if (this.variableList[i].Level0 == item.Level0) {
          if (
            index != 0 &&
            !(
              variableSelectionSummary == '' ||
              variableFilterSelectionSummary == '' ||
              variableSelectionSummary.trim().endsWith(':') ||
              variableSelectionSummary.trim().endsWith('|')
            )
          )
            variableSelectionSummary += '; ';

          if (item.Level5 != '') {
            variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4}: ${item.Level5} `;
          } else if (item.Level4 != '') {
            variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4} `;
          } else if (item.Level3 != '') {
            variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3} `;
          } else if (item.Level2 != '') {
            const level2Label =
              item.Level0 === 'Time Period' &&
              (item.isMostRecent || isMostRecentTimePeriodLabel(item.Level2))
                ? formatMostRecentSelectionLabel(
                    resolveSnapshotMostRecentSelection(item, this.variableList)
                      ?.Level2,
                  )
                : item.Level2;
            variableSelectionSummary += `${item.Level0} : ${item.Level1}: ${level2Label} `;
          } else if (item.Level1 != '') {
            variableSelectionSummary += `${item.Level0}: ${item.Level1} `;
          } else if (item.Level0 != '') {
            variableSelectionSummary += `${item.Level0} `;
          }
        }
      });

      if (this.selectedcompareacrossOption == 'Multiple Markets') {
        //search where level0 is "brands" in variablesSummaryObjFirstLevel
        let brands = variablesSummaryObjFirstLevel.filter(
          (a: any) => a.Level0 == 'Brands',
        );
        if (brands.length > 0) {
          brands[0].Level2 = brands[0].Level2.split(',')[0];
        }
      }

      variablesSummaryObjFirstLevel.forEach((item: any, index: Number) => {
        let lev0Val = variableFilterSelectionSummary.includes(
          item.Level0 + ': ',
        )
          ? ''
          : item.Level0 + ': ';

        if (
          this.variableList[i].Level0 == item.Level1 ||
          this.variableList[i].Level1[0].Level1_value == item.Level1
        ) {
          if (
            index != 0 &&
            !(
              variableSelectionSummary == '' ||
              variableSelectionSummary.trim().endsWith(':') ||
              variableSelectionSummary.trim().endsWith('|')
            )
          )
            variableSelectionSummary += '; ';

          if (item.Level5 != '' || item.Level6 != '' || item.Level7 != '') {
            variableSelectionSummary +=
              lev0Val + `${this.formatSummaryLevelsFrom(item, 1)} `;
          } else if (item.Level4 != '') {
            variableSelectionSummary +=
              lev0Val +
              `${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4} `;
          } else if (item.Level3 != '') {
            variableSelectionSummary +=
              lev0Val + `${item.Level1}: ${item.Level2}: ${item.Level3} `;
          } else if (item.Level2 != '') {
            variableSelectionSummary +=
              lev0Val + `${item.Level1}: ${item.Level2} `;
          } else if (item.Level1 != '') {
            variableSelectionSummary += lev0Val + `${item.Level1} `;
          } else if (item.Level0 != '') {
            variableSelectionSummary += `${item.Level0} `;
          }
        }
      });
    }

    for (let i = 0; i < this.variableListFilter[0].Level1.length; i++) {
      let checkRadioMet = this.variablesSummaryObjRadio.map(
        (a: any) => a.Level0,
      );
      let checkboxesMet = variablesSummaryObjsecondLevel.map(
        (a: any) => a.Level1,
      );

      if (
        i != 0 &&
        (checkRadioMet.includes(this.variableListFilter[0].Level1[i].Level0) ||
          checkboxesMet.includes(
            this.variableListFilter[0].Level1[i].Level0,
          )) &&
        variableFilterSelectionSummary != ''
      )
        variableFilterSelectionSummary += ' | ';

      this.variablesSummaryObjRadio.forEach((item: any, index: Number) => {
        if (this.variableListFilter[0].Level1[i].Level0 == item.Level0) {
          if (
            index != 0 &&
            !(
              variableFilterSelectionSummary.trim().endsWith(':') ||
              variableFilterSelectionSummary.trim().endsWith('|')
            )
          )
            variableFilterSelectionSummary += '; ';

          if (item.Level5 != '' || item.Level6 != '' || item.Level7 != '') {
            variableFilterSelectionSummary +=
              `${this.formatSummaryLevelsFrom(item, 0)} `;
          } else if (item.Level4 != '') {
            variableFilterSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4} `;
          } else if (item.Level3 != '') {
            variableFilterSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3} `;
          } else if (item.Level2 != '') {
            variableFilterSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2} `;
          } else if (item.Level1 != '') {
            variableFilterSelectionSummary += `${item.Level0}: ${item.Level1} `;
          } else if (item.Level0 != '') {
            variableFilterSelectionSummary += `${item.Level0} `;
          }
        }
      });

      variablesSummaryObjsecondLevel.forEach((item: any, index: Number) => {
        if (this.variableListFilter[0].Level1[i].Level0 == item.Level1) {
          if (
            index != 0 &&
            !(
              variableFilterSelectionSummary == '' ||
              variableFilterSelectionSummary.trim().endsWith(':') ||
              variableFilterSelectionSummary.trim().endsWith('|')
            )
          )
            variableFilterSelectionSummary += '; ';

          let lev1Val = variableFilterSelectionSummary.includes(
            item.Level1 + ': ',
          )
            ? ''
            : item.Level1 + ': ';

          if (item.Level5 != '' || item.Level6 != '' || item.Level7 != '') {
            variableFilterSelectionSummary +=
              lev1Val + `${this.formatSummaryLevelsFrom(item, 2)} `;
          } else if (item.Level4 != '') {
            variableFilterSelectionSummary +=
              lev1Val + `${item.Level2}: ${item.Level3}: ${item.Level4} `;
          } else if (item.Level3 != '') {
            variableFilterSelectionSummary +=
              lev1Val + `${item.Level2}: ${item.Level3} `;
          } else if (item.Level2 != '') {
            variableFilterSelectionSummary += lev1Val + `${item.Level2} `;
          } else if (item.Level1 != '') {
            variableFilterSelectionSummary += `${item.Level1} `;
          } else if (item.Level0 != '') {
            variableFilterSelectionSummary += `${item.Level0} `;
          }
        }
      });
    }

    variableFilterSelectionSummary =
      this.removeDuplicateAudienceFromFilterSummary(
        variableSelectionSummary,
        variableFilterSelectionSummary,
      );

    const productCategorySummary = this.getProductCategorySummaryParts();

    this._configService.selectedSnapshotType = this.selectedcompareacrossOption;

    this.selectionSummary =
      `<span class="summary-label">Compare Across:</span> ${this.selectedcompareacrossOption} : ${this.selectedSection}` +
      (this.selectedSubSection != 'NA' ? ` : ${this.selectedSubSection}` : ``) +
      (entryPoints1Level1.length == 0
        ? ''
        : `<span class="grey-separator" > ||  </span>` +
          (this.isCustomSnapshot
            ? ''
            : `<span class="summary-label">Entry Point:</span> `) +
          `${entryPoints1Level1} ` +
          `: ` +
          (this.entrypointColorService.checkForEntryPoint(entryPoints1Level1)
            ? `${this.entrypointColorService.getSnapshotHighlightColorForSummary(entryPoints1Level1, entryPoints1Level2)}`
            : entryPoints1Level2)) +
      (entryPoints2Level1.length == 0
        ? ''
        : `</span><span class="summary-label"> | </span> ${entryPoints2Level1} ` +
          `: ` +
          `${entryPoints2Level2}  `) +
      (entryPoints3Level1.length == 0
        ? ''
        : `</span><span class="summary-label"> | </span> ${entryPoints3Level1} ` +
          `: ` +
          `${entryPoints3Level2}  `) +
      productCategorySummary.html +
      `<span class="grey-separator"> ||  </span> <span class="summary-label">Selections: </span>` +
      variableSelectionSummary +
      (variableFilterSelectionSummary != ''
        ? `<span class="grey-separator"> || </span> <span class="summary-label">Filters: </span>` +
          variableFilterSelectionSummary
        : '');

    this._configService.selectionSummaryText = this.selectionSummary;

    this._configService.audienceSummary = this.audienceTooltip;
    this.selectionSummaryTitle =
      'Compare Across: ' +
      this.selectedcompareacrossOption +
      ': ' +
      this.selectedSection +
      (this.selectedSubSection != 'NA' ? ': ' + this.selectedSubSection : '') +
      (entryPoints1Level1.length == 0
        ? ''
        : (this.isCustomSnapshot ? ' || ' : ' || Entry Point: ') +
          entryPoints1Level1 +
          ': ' +
          entryPoints1Level2) +
      (entryPoints2Level1.length == 0
        ? ''
        : '; ' + entryPoints2Level1 + ': ' + entryPoints2Level2) +
      (entryPoints3Level1.length == 0
        ? ''
        : '; ' + entryPoints3Level1 + ': ' + entryPoints3Level2) +
      productCategorySummary.title +
      ' || Selections: ' +
      variableSelectionSummary +
      (variableFilterSelectionSummary != ''
        ? '| Filters: ' + variableFilterSelectionSummary
        : '');

    // Display-only: MMA → Rolling Ave (computation/Child values stay MMA)
    this.selectionSummary = formatMmaLabelForDisplay(this.selectionSummary);
    this.selectionSummaryTitle = formatMmaLabelForDisplay(
      this.selectionSummaryTitle,
    );

    this._configService.selectionSummaryText = this.selectionSummary;
    this._configService.selectionSummaryTextTitle = this.selectionSummaryTitle;

    if (infoRibbonDiv != null) {
      infoRibbonDiv.innerHTML = this.selectionSummary;
      infoRibbonDiv.title = this.selectionSummaryTitle;
    }

    if (infoRibbonTextValuesDiv != null) {
      infoRibbonTextValuesDiv.innerHTML = this.selectionSummary;
      infoRibbonTextValuesDiv.title = this.selectionSummaryTitle;
    }

    // const toggleLeftPanelDiv = document.querySelector(
    //   '.toggleLeftPanel'
    // ) as HTMLDivElement;
    // toggleLeftPanelDiv.click();
  }

  colNest: any;
  Level1: any;
  Level2: any;
  Level3: any;
  Level4: any;
  Level5: any;
  selectedArray: any[] = [];
  outputArray() {
    // ;
    // for (let i = 0; i < this.variableList.length; i++) {
    //   if (this.variableList[i].Level0 == 'Time Period') {
    //     for (let j = 0; j < this.variableList[i].Level1.length; j++) {
    //       if (this.variableList[i].Level1[j].is_selected == true) {
    //         this.Level1 = this.variableList[i].Level1[j];
    //         this.findLevel(this.Level1, 2)
    //       }
    //     }
    //   }
    // }
  }
  findLevel(obj: any, level: any) {
    let x: any;
    if (_.keys(obj).indexOf('Level' + level) != -1) {
      //level5, 6
      for (let i = 0; i < obj['Level' + level].length; i++) {
        if (obj['Level' + level][i].is_selected == true) {
          x = obj['Level' + level][i];
        }
        // ;
      }
      this.findLevel(x, level + 1);
    } else {
      //level5
      // ;
      return level;
    }
  }

  private isWaveTimePeriod() {
    if (
      this.mandatoryVariableMapping == undefined ||
      this.mandatoryVariableMapping == null
    )
      return false;
    else {
      let timePeriodEntries: any = this.mandatoryVariableMapping.filter(
        (entry: any) =>
          entry.variable_label === 'Time Period' &&
          entry.variable_code &&
          entry.variable_code.trim() !== '',
      );

      let isWaveTimePeriod =
        timePeriodEntries.length === 0 ||
        timePeriodEntries.every(
          (entry: any) =>
            entry.variable_code === timePeriodEntries[0].variable_code,
        );

      return isWaveTimePeriod;
    }
  }

  significance = '';
  isFilteringActive = false;
  DefaultConfidenceLevel = '';
  isTotalBase = false;
  selectedWeight = '';
  weightColumnName = '';
  SignificanceVsReference = '';
  isAggregatedData: boolean = false;
  isSemiAggregatedData: boolean = false;
  isRespondentLevel: boolean = false;
  aggregatedVariables: any = [];
  columnLength = 0;
  previewData: DataObjectSnapshot = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
  };
  widegtconfigdetails: any = {
    section: '',
    subSection: '',
    snapshotType: '',
    snapshotName: '',
    clientName: '',
    study: '',
    IsCustomSnapshot: false,
  };

  updatedDataForSubmit(data: any) {
    return data.map((item: any) => {
      // Extract Level0 to Level5 values
      let levels = [];
      levels = [
        item.Level1,
        item.Level2,
        item.Level3,
        item.Level4,
        item.Level5,
        item.Level6,
        item.Level7,
        item.Level8,
        item.Level9,
      ];
      if (item.Level0 == 'Audience') {
        levels = [
          item.Level0,
          item.Level1,
          item.Level2,
          item.Level3,
          item.Level4,
          item.Level5,
        ];
      }
      // Adding these field in existing array
      let parent = '';
      let isTimePeriod = false;
      let isMarket = false;
      let isRolling = false;

      // Filter out empty values and join with |
      let child = levels.filter((level) => level).join('|');
      let arr = child.split('|');

      if (item.Level0 == 'Time Period') {
        isTimePeriod = true;
      } else {
        isTimePeriod = false;
      }

      if (item.Level0 == 'Markets') {
        isMarket = true;
      } else {
        isMarket = false;
      }

      if (
        item.Level1 == '3MMA' ||
        item.Level1 == '4MMA' ||
        item.Level1 == '6MMA' ||
        item.Level1 == '12MMA'
      ) {
        isRolling = true;
      } else {
        isRolling = false;
      }

      parent = arr[arr.length - 2];

      let multiPunchMetric = '';
      if (item.is_multi_punch == 0 || item.is_multi_punch == '0') {
        multiPunchMetric = '';
      } else {
        multiPunchMetric = parent;
      }
      // Adding all extra created variable in existing data-item
      return {
        ...item,
        child: child,
        parent: parent,
        isTimePeriod: isTimePeriod,
        isMarket: isMarket,
        isRolling: isRolling,
        multiPunchMetric: multiPunchMetric,
      };
    });
  }

  previewDataCreation(
    data: any,
  ): checkboxSelectionWithParentSnapshot | undefined {
    for (let i = 0; i < data.length; i++) {
      const checkboxSelection = [];

      for (let j = 0; j < data.length; j++) {
        checkboxSelection.push({
          CheckboxStatus: false,
          Child: data[j].child ?? '',
          variablecode: data[j].variable_code ?? '',
          responsecode:
            (data[j].calc_type.toLowerCase() == 'respgrp'
              ? data[j].derived_metric_calculation
              : data[j].response_code) ?? '',
          // isDerviedVariable: data[j].is_derived == null ? false : Boolean(data[j].is_derived),
          isDerviedVariable: false,
          CalculationType: data[j].calc_type ?? '',
          sort_id: data[j].sort_id == null ? 0 : Number(data[j].sort_id),
          year_response_code: data[j].year_code ?? '',
          year_variable_code: data[j].dataYearCode ?? '',
          Date: data[j].date ?? '',
          // isMultiPunch: data[j].is_multi_punch == null ? 0 : Number(data[j].is_multi_punch),
          isMultiPunch:
            data[j].is_multi_punch == null ? 0 : Number(data[j].is_multi_punch),
          isTimePeriod:
            data[j].isTimePeriod == null
              ? false
              : Boolean(data[j].isTimePeriod),
          isMarket:
            data[j].isMarket == null ? false : Boolean(data[j].isMarket),
          multiPunchMetric: data[j].multiPunchMetric,
          MultiPunchNumber:
            data[j].is_multi_punch == null ? 0 : Number(data[j].is_multi_punch),
          isCustomGroup:
            data[j].is_CustomGroup == null
              ? false
              : data[j].is_CustomGroup === 'true',
          // isCustomGroup: false,
          kibanaFilterScript: data[j].kibanaFilterScript ?? '',
          //kibanaFilterScript: '',
          customGroupId: data[j].customGroupId ?? '',
          // customGroupId: '',
          customGroupRowOrder: 0,
          isRolling:
            data[j].isRolling == null ? false : Boolean(data[j].isRolling),
          Weekno_forSigcalculation:
            Number(data[j].Weekno_forSigcalculation) ?? null,
        });
        //;
      }
      // ;
      const columnData: checkboxSelectionWithParentSnapshot = {
        Parent: data[i].parent == null ? '' : data[i].parent,
        SortId: data[i].sort_id == null ? 0 : Number(data[i].sort_id),
        Data: checkboxSelection,
        isMultiPunch:
          data[i].is_multi_punch == null ||
          data[i].is_multi_punch == 0 ||
          data[i].is_multi_punch == '0'
            ? false
            : Boolean(data[i].is_multi_punch),
        //isMultiPunch: false,
        MultiPunchNumber:
          data[i].is_multi_punch == null ? 0 : Number(data[i].is_multi_punch),
        //MultiPunchNumber: 0,
        isCustomGroup:
          data[i].is_CustomGroup == null
            ? false
            : data[i].is_CustomGroup === 'true',
        //isCustomGroup: false,
        customGroupId:
          data[i].customGroupId == null ? '' : data[i].customGroupId,
        // customGroupId: '',
        brandanalysisCode:
          data[i].is_brand_analysis == null
            ? 0
            : Number(data[i].is_brand_analysis),
      };

      // ;
      return columnData;
      break;
    }

    // Return undefined if data.length === 0
    return undefined;
  }
  opData: any;
  sortedOPdata: any;
  indexVsBrandReference: checkboxSelectionWithParentSnapshot[] = [];
  significanceVsBrandReference: checkboxSelectionWithParentSnapshot[] = [];
  selectedBrand: any[] = [];
  selectedTimePeriod: any[] = [];
  selectedMarket: any[] = [];
  selectedCategory: any[] = [];
  selectedAudience: any[] = [];
  selectedTotalSample: any[] = [];
  SubmitClicked(
    load: boolean,
    isDefaultPanel: boolean = false,
    globalSelection: boolean = false,
    innerSelection: any = {},
  ) {
    this._configService.showGlobalDefaultPopup = globalSelection;
    if (this.snapshotDataConfig.audienceCohortType == 'multiple') {
      this.multiCohort = true;

      this._configService.multiCohort = true;
    }
    //this.collapsePanel();////
    if (isDefaultPanel) {
      this.selectedSection = sessionStorage.getItem('sectionName') ?? '';
      this.selectedSubSection = sessionStorage.getItem('subsectionName') ?? '';
    }
    this._configService.pageCounter.next(1);
    this._configService.page2ToggleSubject.next(1);
    this.previewData.ColNesting = [];
    this.previewData.Column = [];
    this.previewData.Filter = [];
    this.previewData.Row = [];
    this.previewData.RowNesting = [];
    this.selectedTimePeriod = [];

    let timePeriodData = this.selectedObjects.find((item) =>
      item.hasOwnProperty('Time Period'),
    )?.['Time Period'];
    if (timePeriodData) {
      // Resolve "Most recent" to current latest concrete period for output only;
      // selectedObjects keep the sentinel for save selection / display.
      const tpForSubmit = timePeriodData.map((item: any) =>
        resolveSnapshotMostRecentSelection(
          _.cloneDeep(item),
          this.variableList,
        ),
      );
      for (let i = 0; i < tpForSubmit.length; i++) {
        this.selectedTimePeriod.push(tpForSubmit[i].Level2);
      }
      // Non-trend widgets filter on this exact Child key from API rows
      if (tpForSubmit[0]) {
        this._configService.selectedTPforNonTrendView =
          `${tpForSubmit[0].Level1}|${tpForSubmit[0].Level2}`;
      }
      timePeriodData = this.updatedDataForSubmit(tpForSubmit); //adding child and parent key
      this._configService.selectedTimePeriod = timePeriodData.child;
      const x = this.previewDataCreation(timePeriodData);
      if (x !== undefined) {
        this.previewData.ColNesting.push(x);
        if (this.selectedcompareacrossOption === 'Audience Snapshot') {
          this.previewData.Column.push(x);
        }
      }
    }
    if (this.selectedcompareacrossOption == 'Multiple Markets') {
      this.selectedMarket = [];
      this.variableListEpForOutput = [];
      let marketData = this.selectedObjects.find((item) =>
        item.hasOwnProperty('Markets'),
      )?.['Markets'];
      //brand which is selected from left panel

      if (marketData) {
        for (let i = 0; i < marketData.length; i++) {
          this.selectedBrand.push(marketData[i].Level2);
        }

        marketData = this.updatedDataForSubmit(marketData);
        const x = this.previewDataCreation(marketData);
        if (x !== undefined) {
          this.previewData.Column.push(x);
        }
      }
      // ;

      const filteredData = this.selectedObjects.filter(
        (item) => !('Time Period' in item || 'Markets' in item),
      );

      for (let i = 0; i < filteredData.length; i++) {
        const item = filteredData[i]; // Access each item in filteredData array
        const key = Object.keys(item)[0]; // Get the key of the current item
        let array = item[key]; // Get the corresponding array
        if (array) {
          array = this.updatedDataForSubmit(array);
          // ;
          const x = this.previewDataCreation(array);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    } else if (this.selectedcompareacrossOption == 'Multiple Categories') {
      this.selectedBrand = [];
      let brandData = this.selectedObjects.find((item) =>
        item.hasOwnProperty('Brands'),
      )?.['Brands'];
      //brand which is selected from left panel
      for (let i = 0; i < brandData.length; i++) {
        this.selectedBrand.push(brandData[i].Level2);
      }

      if (brandData) {
        brandData = this.updatedDataForSubmit(brandData);
        const x = this.previewDataCreation(brandData);
        if (x !== undefined) {
          this.previewData.Column.push(x);
        }
      }
      // ;

      const filteredData = this.selectedObjects.filter(
        (item) => !('Time Period' in item || 'Brands' in item),
      );

      for (let i = 0; i < filteredData.length; i++) {
        const item = filteredData[i]; // Access each item in filteredData array
        const key = Object.keys(item)[0]; // Get the key of the current item
        let array = item[key]; // Get the corresponding array
        if (array) {
          array = this.updatedDataForSubmit(array);
          // ;
          const x = this.previewDataCreation(array);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    } else if (this.selectedcompareacrossOption == 'Audience Snapshot') {
      this.selectedAudience = [];
      let audienceData: any = [];
      if (
        this._configService.outputSnapshotData?.audienceCohortType != 'multiple'
      ) {
        audienceData =
          this.selectedObjects.find((item) =>
            item.hasOwnProperty('Audience'),
          )?.['Audience'] ?? [];
      } else {
        this.selectedObjects?.forEach((obj) => {
          if (!obj || typeof obj !== 'object') return;

          Object.keys(obj).forEach((key) => {
            const value = obj[key];

            if (Array.isArray(value) && key === 'Audience') {
              value.forEach((item) => {
                const isDuplicate = audienceData.some(
                  (existingItem: any) =>
                    existingItem.variable_code === item.variable_code &&
                    existingItem.response_code === item.response_code,
                );

                if (!isDuplicate) {
                  audienceData.push(item);
                }
              });
            }
          });
        });
      }
      //brand which is selected from left panel
      for (let i = 0; i < audienceData.length; i++) {
        this.selectedAudience.push(audienceData[i].Level2);
      }
      this.selectedTotalSample = (audienceData ?? []).filter(
        (a: any) =>
          a.Level1 === 'Total Sample' ||
          a.variable_code === 'total_sample' ||
          a.data_variable_code === 'total_sample',
      );

      if (audienceData) {
        audienceData = this.updatedDataForSubmit(audienceData);
        const x = this.previewDataCreation(audienceData);
        if (x !== undefined) {
          this.previewData.Filter.push(x);
        }
      }
      // ;

      // const filteredData = this.selectedObjects.filter(
      //   (item) => !('Time Period' in item || 'Brands' in item)
      // );
      const filteredData = this.selectedObjects.filter((item) => {
        const key = Object.keys(item)[0];
        return key !== 'Time Period' && key !== 'Brands' && key !== 'Audience';
      });
      for (let i = 0; i < filteredData.length; i++) {
        const item = filteredData[i]; // Access each item in filteredData array
        const key = Object.keys(item)[0]; // Get the key of the current item
        let array = item[key]; // Get the corresponding array
        if (array) {
          array = this.updatedDataForSubmit(array);
          // ;
          const x = this.previewDataCreation(array);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    } else {
      this.selectedBrand = [];
      let brandData = this.selectedObjects
        .find((item) => item.hasOwnProperty('Brands'))
        ?.['Brands']?.filter((b: any) => b.Level1 === 'Brands');
      if (brandData == undefined || brandData.length === 0) {
        brandData = this.selectedObjects
          .find((item) => item.hasOwnProperty('Brand'))
          ?.['Brand']?.filter((b: any) => b.Level1 === 'Brands');
      }
      //brand which is selected from left panel
      for (let i = 0; i < brandData.length; i++) {
        this.selectedBrand.push(brandData[i].Level2);
      }

      if (brandData) {
        brandData = this.updatedDataForSubmit(brandData);
        const x = this.previewDataCreation(brandData);
        if (x !== undefined) {
          this.previewData.Column.push(x);
        }
      }
      // ;

      const filteredData = this.selectedObjects.filter(
        (item) => !('Time Period' in item || 'Brands' in item),
      );

      for (let i = 0; i < filteredData.length; i++) {
        const item = filteredData[i]; // Access each item in filteredData array
        const key = Object.keys(item)[0]; // Get the key of the current item
        let array = item[key]; // Get the corresponding array
        if (array) {
          array = this.updatedDataForSubmit(array);
          // ;
          const x = this.previewDataCreation(array);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    }

    //Entry point binding for filter in Leftpanel submit
    let epArray: any[] = [];
    //added for filtered out entry point
    if (
      this.variableListEpForOutput != undefined &&
      this.variableListEpForOutput.length != 0
    ) {
      for (let i = 0; i < this.variableListEpForOutput.length; i++) {
        this.variableListEpForOutput.forEach((item) => {
          item.Level1.forEach((level1: any) => {
            level1.Level2 = level1.Level2.filter(
              (level2: any) => level2.is_selected,
            );
          });
        });

        epArray = [];
        for (
          let j = 0;
          j < this.variableListEpForOutput[i].Level1[0].Level2.length;
          j++
        ) {
          epArray.push({
            Level0: this.variableListEpForOutput[i].Level0,
            Level1: this.variableListEpForOutput[i].Level1[0].Level1_value,
            Level2:
              this.variableListEpForOutput[i].Level1[0].Level2[j].Level2_value,
            Level3: '',
            Level4: '',
            Level5: '',
            calc_type:
              this.variableListEpForOutput[i].Level1[0].Level2[j].calc_type,
            customGroupId:
              this.variableListEpForOutput[i].Level1[0].Level2[j].customGroupId,
            dataYearCode:
              this.variableListEpForOutput[i].Level1[0].Level2[j].dataYearCode,
            date: this.variableListEpForOutput[i].Level1[0].Level2[j].date,
            hasNextLevel:
              this.variableListEpForOutput[i].Level1[0].Level2[j].hasNextLevel,
            is_CustomGroup:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .isCustomGrpPresent,
            is_brand_analysis:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .is_brand_analysis,
            is_derived:
              this.variableListEpForOutput[i].Level1[0].Level2[j].is_derived,
            is_dimension:
              this.variableListEpForOutput[i].Level1[0].Level2[j].is_dimension,
            is_multi_punch:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .is_multi_punch,
            is_time_Period_Present:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .is_time_Period_Present,
            kibanaFilterScript:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .kibanaFilterScript,
            response_code:
              this.variableListEpForOutput[i].Level1[0].Level2[
                j
              ].calc_type.toLowerCase() == 'respgrp'
                ? this.variableListEpForOutput[i].Level1[0].Level2[j]
                    .derived_metric_calculation
                : this.variableListEpForOutput[i].Level1[0].Level2[j]
                    .response_code,
            sort_id:
              this.variableListEpForOutput[i].Level1[0].Level2[j].sort_id,
            variable_code:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .data_variable_code,
            variable_label: null, //No data available
            year_code:
              this.variableListEpForOutput[i].Level1[0].Level2[0].year_code,
            Weekno_forSigcalculation:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .Weekno_forSigcalculation,
          });
        }

        if (epArray) {
          epArray = this.updatedDataForSubmit(epArray);
          // ;
          const x = this.previewDataCreation(epArray);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    }
    this.selectedWeight =
      innerSelection?.selectedWeight ?? this.getWeightFromConfig();
    //this.outputArray();
    this.significance = load
      ? this.output_data?.significance
      : (innerSelection?.significance ?? 'None');
    this.isFilteringActive = load ? this.output_data?.isFilteringActive : true;
    this.DefaultConfidenceLevel = load
      ? this.output_data?.DefaultConfidenceLevel
      : (innerSelection?.displayConfidenceLevel ?? 'None');
    this.SignificanceVsReference = load
      ? this.output_data?.SignificanceVsReference
      : (innerSelection?.significanceVsReference ?? '');
    this.isTotalBase = load
      ? this.output_data?.isTotalBase
      : (innerSelection?.isTotalBase ?? false);
    this.weightColumnName = load ? this.output_data?.weightColumnName : '';
    let isBoostFactor = load ? this.output_data?.isBoostFactor : false;
    let weightColumnName = load ? this.output_data?.weightColumnName : '';
    var istimePeriodWave = this.isWaveTimePeriod();
    this.widegtconfigdetails.section = load
      ? this.output_data?.widegtconfigdetails.section
      : this.selectedSection;
    this.widegtconfigdetails.subSection = load
      ? this.output_data?.widegtconfigdetails.subSection
      : this.selectedSubSection;
    this.widegtconfigdetails.snapshotType = load
      ? this.output_data?.widegtconfigdetails.snapshotType
      : this.selectedcompareacrossOption;
    this.widegtconfigdetails.snapshotName = load
      ? this.output_data?.widegtconfigdetails.snapshotName
      : this.snapshotName;
    this.widegtconfigdetails.clientName = load
      ? this.output_data?.widegtconfigdetails.clientName
      : this.selected_client;
    this.widegtconfigdetails.study = load
      ? this.output_data?.widegtconfigdetails.study
      : this.selected_study;
    this.widegtconfigdetails.IsCustomSnapshot = load
      ? this.output_data?.widegtconfigdetails.IsCustomSnapshot == undefined
        ? false
        : this.output_data?.widegtconfigdetails.IsCustomSnapshot
      : this._configService.snapshotProductType == 'custom'
        ? true
        : false;
    let isBrandAnalysis = load ? this.output_data?.isBrandAnalysis : true;
    this.indexVsBrandReference = load
      ? this.output_data?.indexVsBrandReference
      : (innerSelection?.indexVsBrandReference ?? this.indexVsBrandReference);
    this.significanceVsBrandReference = load
      ? this.output_data?.significanceVsBrandReference
      : (innerSelection?.significanceVsBrandReference ??
        this.significanceVsBrandReference);
    //API call
    this._configService.selectedSection = this.widegtconfigdetails.section;
    this._configService.selectedSubSection =
      this.widegtconfigdetails.subSection;
    this._loaderService.showLoader();
    let passOutputData: any = {
      previewData: load ? this.output_data?.previewData : this.previewData,
      selectedClient: this.widegtconfigdetails.clientName,
      selectedStudy: this.widegtconfigdetails.study,
      significance: this.significance,
      isFilteringActive: this.isFilteringActive,
      DefaultConfidenceLevel: this.DefaultConfidenceLevel,
      isTotalBase: this.isTotalBase,
      selectedWeight: innerSelection?.selectedWeight ?? this.selectedWeight,
      weightColumnName: weightColumnName,
      isBoostFactor: isBoostFactor,
      SignificanceVsReference:
        this._configService.passdata?.SignificanceVsReference ||
        this.SignificanceVsReference,
      columnLength: load ? this.output_data?.columnLength : this.columnLength,
      dataArray: load ? this.output_data?.dataArray : this.dataArray,
      isBrandAnalysis: isBrandAnalysis,
      isAggregatedData: load
        ? this.output_data?.isAggregatedData
        : this.isAggregatedData,
      isSemiAggregatedData: load
        ? this.output_data?.isSemiAggregatedData
        : this.isSemiAggregatedData,
      isRespondentLevel: load
        ? this.output_data?.isRespondentLevel
        : this.isRespondentLevel,
      aggregatedVariables: load
        ? this.output_data?.aggregatedVariables
        : this.aggregatedVariables,
      istimePeriodWave: load
        ? this.output_data?.istimePeriodWave
        : istimePeriodWave,
      widegtconfigdetails: load
        ? this.output_data?.widegtconfigdetails
        : this.widegtconfigdetails,
      indexVsBrandReference:
        this._configService.passdata?.indexVsBrandReference ||
        this.indexVsBrandReference,
      significanceVsBrandReference:
        this._configService.passdata?.significanceVsBrandReference ||
        this.significanceVsBrandReference,
      LeftPanelSelectedBrand: this.selectedBrand,
      LeftPanelSelectedAudience: this.selectedAudience,
      LeftPanelSelectedTimePeriod: this.selectedTimePeriod,
      LeftPanelAudienceTotalSample: this.selectedTotalSample,
      productName: this.getSelectedProductNameForSubmit(),
    };
    this._configService.isRespondentLevel = this.isRespondentLevel;
    this._configService.isAggregatedData = this.isAggregatedData;
    this._configService.isSemiAggregatedData = this.isSemiAggregatedData;
    // this._configService.PassOutput.next(passOutputData);
    // // ;
    // this._configService.PassOutput.subscribe((data)=>{
    //   // ;
    //   let x=data;
    // })

    this._configService.dataObjectForSaveSelection = this.previewData;
    this._configService.widgetConfigDetails = this.widegtconfigdetails;
    this._configService.passdata = passOutputData;

    let finalLeftPanelSubmitObject = {
      previewData: this.previewData,
      selectedClient: this.selected_client,
      selectedStudy: this.selected_study,
      significance: this.significance,
      isFilteringActive: this.isFilteringActive,
      DefaultConfidenceLevel: this.DefaultConfidenceLevel,
      isTotalBase: this.isTotalBase,
      selectedWeight: this.selectedWeight,
      weightColumnName: weightColumnName,
      isBoostFactor: isBoostFactor,
      SignificanceVsReference:
        this._configService.passdata?.SignificanceVsReference ||
        this.SignificanceVsReference,
      columnLength: this.columnLength,
      dataArray: this.expandFasTotalInEntryPointData(this.dataArray),
      isBrandAnalysis: isBrandAnalysis,
      isAggregatedData: this.isAggregatedData,
      isSemiAggregatedData: this.isSemiAggregatedData,
      isRespondentLevel: this.isRespondentLevel,
      aggregatedVariables: this.aggregatedVariables,
      istimePeriodWave: istimePeriodWave,
      widegtconfigdetails: this.widegtconfigdetails,
      indexVsBrandReference:
        this._configService.passdata?.indexVsBrandReference ||
        this.indexVsBrandReference,
      significanceVsBrandReference:
        this._configService.passdata?.significanceVsBrandReference ||
        this.significanceVsBrandReference,
      isTrend: load
        ? this.output_data.isTrend
        : this._configService.checkTrendEnabled(
            this._configService.widgetAllData,
          ),
      LeftPanelSelectedBrand: this.selectedBrand,
      LeftPanelSelectedAudience: this.selectedAudience,
      LeftPanelSelectedTimePeriod: this.selectedTimePeriod,
      customBaseMetric: !this.isTotalBase
        ? load
          ? this.selectedCustomBaseReference
          : innerSelection.customBaseMetric
        : null,
      productName: this.getSelectedProductNameForSubmit(),
    };
    let finalLeftPanelInputSelectedObject = {
      compareAcross: this.selectedcompareacrossOption,
      entryPoints: epArray,
      selections: this.selectedObjects,
    };
    this._configService.finalLeftPanelInputSelectedObject =
      finalLeftPanelInputSelectedObject;
    this._configService.finalLeftPanelSubmitObject = finalLeftPanelSubmitObject;
    this._configService.entryPointData = this.expandFasTotalInEntryPointData(
      this.dataArray,
    );
    this._configService.passdata = passOutputData;

    // if(this.selectedcompareacrossOption == 'Multiple Brands'){
    //   this.previewData.Column =this.previewData.Column[0].Data.map(item => ({
    //     Data: [item],
    //     MultiPunchNumber: this.previewData.Column[0].MultiPunchNumber,
    //     Parent: this.previewData.Column[0].Parent,
    //     SortId: this.previewData.Column[0].SortId,
    //     brandanalysisCode: this.previewData.Column[0].brandanalysisCode,
    //     customGroupId: this.previewData.Column[0].customGroupId,
    //     isCustomGroup: this.previewData.Column[0].isCustomGroup,
    //     isMultiPunch: this.previewData.Column[0].isMultiPunch
    // }));
    // }

    const rawData = this.selectedScenarioData?.[0]?.output_selection_data;
    const outputSelectionData = rawData ? JSON.parse(rawData) : null;

    const audienceBrand = outputSelectionData?.previewData?.Audiencebrand?.[0];

    let selectedBrandFromConfig = audienceBrand?.data
      ? {
          config_name: `${audienceBrand.data.variable_label}|${audienceBrand.data.response_label}`,
          is_selected: audienceBrand.is_selected ?? true,
          metric_group: audienceBrand.data.metric_group || '',
          response_label: `${audienceBrand.data.variable_label}|${audienceBrand.data.response_label}`,
          variable_label: audienceBrand.data.variable_label,
        }
      : (this._configService.outputSnapshotData?.selectedBrand ?? null);

    if (
      selectedBrandFromConfig &&
      this.selectedcompareacrossOption === 'Audience Snapshot'
    ) {
      const formattedBrandObject = {
        option:
          selectedBrandFromConfig.response_label ||
          selectedBrandFromConfig.value,
        is_selected: true,
        selectOrder: 1,
        value: selectedBrandFromConfig.value
          ? `${selectedBrandFromConfig.value}_${selectedBrandFromConfig.value}`
          : '',
        index: 0,
        data: {
          variable_label: selectedBrandFromConfig.variable_label || 'Brands',
          Is_snapshot: selectedBrandFromConfig.is_snapshot || 1,
          response_label:
            selectedBrandFromConfig.response_label ||
            selectedBrandFromConfig.value,
          metric_group: selectedBrandFromConfig.metric_group || '',
        },
      };

      const audienceBrandArray = [formattedBrandObject];
      (this.previewData as any)['Audiencebrand'] = audienceBrandArray;
    }

    let pageNumber = this._configCustomService.pageCount || 1;
    this._configService
      .getOutPutData(
        this.previewData,
        this.selected_client,
        this.selected_study,
        this.significance,
        this.isFilteringActive,
        this.DefaultConfidenceLevel,
        this.isTotalBase,
        this.selectedWeight,
        weightColumnName,
        isBoostFactor,

        this.SignificanceVsReference,
        this.columnLength,
        this.dataArray,
        isBrandAnalysis,
        this.isAggregatedData,
        this.isSemiAggregatedData,
        this.isRespondentLevel,
        this.aggregatedVariables,
        istimePeriodWave,
        this.widegtconfigdetails,
        this.indexVsBrandReference,
        this.significanceVsBrandReference,
        false, // this._configService.checkTrendEnabled(this._configService.widgetAllData),
        this._configService.widgetPageData,
        this._configService.widgetData,
        pageNumber, //1 //for page wise data fetch,
        false,
        !this.isTotalBase
          ? load
            ? this.selectedCustomBaseReference
            : innerSelection.customBaseMetric
          : null,
        this.multiCohort,
        this.getSelectedProductNameForSubmit(),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (
          result.Data != null &&
          result.Data != undefined &&
          result.Data != ''
        ) {
          this.opData = JSON.parse(result.Data);
          //this._configService.tiggerSelectionSnapshotType = false;
          this.sortedOPdata = _.cloneDeep(
            this.opData.sort(
              (a: any, b: any) => a.widgetNumber - b.widgetNumber,
            ),
          );
          // Store opData globally
          if (typeof window !== undefined) {
            (window as any)['jsonobject'] = this.sortedOPdata;
          }
          this._configService.standardSnapOutputData = this.sortedOPdata;
          this._configService.standardSnapOutputDataWhenSigClicked =
            this.sortedOPdata;
          const outputViewDiv = document.querySelector('.output-view');
          if (outputViewDiv) {
            outputViewDiv?.classList.remove('DN');
            this.showOutput.emit();
          }
        } else {
          //No Output Data
          this._loaderService.hideLoader();
        }
      });

    this.UpdateSelectionSummary();

    //Adding values for Excel export
    this._configService.setDropdownValue(
      'selectionSummary',
      this._configService.selectionSummaryTextTitle,
    );
    this._configService.setDropdownValue('studyName', this.selected_study);
    this._configService.setDropdownValue('clientName', this.selected_client);
    this._configService.setDropdownValue('snapshotName', this.snapshotName);
    this._configService.setDropdownValue(
      'lowBase',
      this._configService.LBthreshold,
    );
    this._configService.setDropdownValue(
      'insufficientBase',
      this._configService.ISthreshold,
    );
    this._configService.setDropdownValue(
      'thresholdIndex',
      this._configService.thresholdIndex,
    );
    this.baseValuesChanged.emit({
      insufficientBase: this._configService.ISthreshold,
      lowBase: this._configService.LBthreshold, // Adjust this based on your logic
    });
    this.usageDataLog('Snapshot Output');
      this._configService.savedPreviewData = this.previewData;
    
    this.isPanelLoaded = false;
  }
  usageDataLog(feature: string) {
    let summarytext = '';
    if (
      this._configService.selectionSummaryTextTitle != undefined &&
      this._configService.selectionSummaryTextTitle != null
    ) {
      // summarytext = this.summaryText?.nativeElement.innerText;
      summarytext = this._configService.selectionSummaryTextTitle;
    } else {
      summarytext = this.selectionSummary.replace(/<[^>]*>/g, '');
    }
    this._usermanagementService.UsageData(
      '3',
      this.selected_client,
      this.selected_study,
      feature,
      summarytext,
      this.snapshotName,
    );
  }
  getWeightFromConfig() {
    const result = this._configService.weights?.find(
      (item: any) => item.is_selected === true,
    );
    const output =
      result && result.variable_label === 'Unweighted'
        ? 'Unweighted'
        : result?.variable_code;
    return output;
  }

  ResetClicked() {
    const isSingleEntryPoint = this.hasSingleEntryPointLastLevelOption();
    const epSnapshot = isSingleEntryPoint
      ? {
          dataArray: _.cloneDeep(this.dataArray),
          selectedEP1: this.selectedEP1,
          selectedEP2: this.selectedEP2,
          selectedEP3: this.selectedEP3,
        }
      : null;

    this.variableListFilter.forEach((item) => {
      item?.Level1?.forEach((level1Item) => {
        level1Item.is_selected = false;
        level1Item?.Level1?.forEach((level2Item: any) => {
          level2Item.is_selected = false;
          level2Item?.Level2?.forEach((level3Item: any) => {
            level3Item.is_selected = false;
            level3Item?.Level3?.forEach((level4Item: any) => {
              level4Item.is_selected = false;
              level4Item?.Level4?.forEach((level5Item: any) => {
                level5Item.is_selected = false;
                level5Item?.Level5?.forEach((level6Item: any) => {
                  level6Item.is_selected = false;
                  level6Item?.Level6?.forEach((level7Item: any) => {
                    level7Item.is_selected = false;
                    level7Item?.Level7?.forEach((level8Item: any) => {
                      level8Item.is_selected = false;
                      level8Item?.Level8?.forEach((level9Item: any) => {
                        level9Item.is_selected = false;
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });

    this.variableList.forEach((item) => {
      item?.Level1?.forEach((level1Item) => {
        level1Item.is_selected = false;
        level1Item?.Level2?.forEach((level2Item: any) => {
          level2Item.is_selected = false;
          level2Item?.Level3?.forEach((level3Item: any) => {
            level3Item.is_selected = false;
            level3Item?.Level4?.forEach((level4Item: any) => {
              level4Item.is_selected = false;
              level4Item?.Level5?.forEach((level5Item: any) => {
                level5Item.is_selected = false;
                level5Item?.Level6?.forEach((level6Item: any) => {
                  level6Item.is_selected = false;
                  level6Item?.Level7?.forEach((level7Item: any) => {
                    level7Item.is_selected = false;
                    level7Item?.Level8?.forEach((level8Item: any) => {
                      level8Item.is_selected = false;
                      level8Item?.Level9?.forEach((level9Item: any) => {
                        level9Item.is_selected = false;
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });

    this.variableListMultiMarketAndCateg.forEach((item) => {
      item?.Level1?.forEach((level1Item) => {
        level1Item.is_selected = false;
        level1Item?.Level2?.forEach((level2Item: any) => {
          level2Item.is_selected = false;
          level2Item?.Level3?.forEach((level3Item: any) => {
            level3Item.is_selected = false;
            level3Item?.Level4?.forEach((level4Item: any) => {
              level4Item.is_selected = false;
              level4Item?.Level5?.forEach((level5Item: any) => {
                level5Item.is_selected = false;
              });
            });
          });
        });
      });
    });

    this.selectedObjects = [];
    this.variablesSummaryObj = [];
    this.variablesSummaryObjRadio = [];
    this.isSavedScenarioSelected = false;
    this.audienceTooltip = 'No selections';

    if (isSingleEntryPoint && epSnapshot) {
      this.reloadSingleEntryPointAfterReset(epSnapshot);
    }

    if (!this._submitButtonEl) {
      this._submitButtonEl = document.getElementById('submitButton');
    }
    this._submitButtonEl?.classList.add('disabled');
    this.issubmitReset.emit(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Fast path: if nothing is open, skip all DOM queries entirely.
    if (
      !this.sidePanelblock &&
      !this.productCategorySidePanelblock &&
      !this.variable_expand &&
      !this.entry_items_expand &&
      !this.productCategory_items_expand &&
      !this.iscompareacrossDropdownOpen
    ) {
      return;
    }

    const clickedInside = this.elRef.nativeElement.contains(event.target);

    // Check toggleLeftPanel first — single closest() instead of multiple
    if (this.isClickInside(event, '.toggleLeftPanel')) {
      this.sidePanelblock = false;
      this.productCategorySidePanelblock = false;
      this.entry_items_expand = '';
      this.productCategory_items_expand = '';
      this._clearAllVariableExpands();
      return;
    }

    if (clickedInside) return; // Inside the panel — nothing to close

    const target = event.target as Element;
    const isElement = target instanceof Element;

    // Only run closest() checks for things that are actually open
    if (this.sidePanelblock || this.productCategorySidePanelblock) {
      const inSidePanel = isElement && target.closest('.side-panel-block');
      const inLvl0 = isElement && target.closest('.leftPanelLvl0');
      if (!inSidePanel && !inLvl0) {
        this.sidePanelblock = false;
        this.productCategorySidePanelblock = false;
        this.entry_items_expand = '';
        this.productCategory_items_expand = '';
      } else if (!inSidePanel) {
        this.sidePanelblock = false;
        this.productCategorySidePanelblock = false;
      }
    }

    if (this.variable_expand) {
      const inSelection =
        isElement && target.closest('.variables-sub-itemsLev1');
      if (!inSelection) {
        this._clearAllVariableExpands();
        this.increaseLeftpanelHeight.emit({ isReset: true });
      }
    }

    if (this.iscompareacrossDropdownOpen) {
      const inDropdown = isElement && target.closest('.custom-options');
      if (!inDropdown) {
        this.iscompareacrossDropdownOpen = false;
        this.isSubSectionDropdownOpen = false;
        this.isSectionDropdownOpen = false;
      }
    }
  }

  private _clearAllVariableExpands(): void {
    this.variable_expand = '';
    this.variable_expandLev1 = '';
    this.variable_expandLev2 = '';
    this.variable_expandLev3 = '';
    this.variable_expandLev4 = '';
    this.variable_expandLev5 = '';
    this.variable_expandLev6 = '';
    this.variable_expandLev7 = '';
    this.variable_expandLev8 = '';
    this.variable_expandLev9 = '';
  }

  LoadSelection(isDefaultLoad: boolean) {
    this._configService.selectedStudy = this.selected_study;
    this.isLoadSelection.emit(isDefaultLoad);
    //this.collapsePanel();
  }

  updateLeftPanel() {
    let option = this.selectedScenarioData[0].snapshotType;
    this.selectedSection = this.selectedScenarioData[0].section;
    this.selectedSubSection = this.selectedScenarioData[0].subSection;
    this._configService.setDropdownValue('compareAcross', option);
    this.compareacross.forEach((c: any) => {
      c.selected = c.name === option ? true : false;
      c.section.forEach((s: any) => {
        s.selected = s.name === this.selectedSection ? true : false;
        if (s.subSection) {
          s.subSection?.forEach(
            (ss: any) =>
              (ss.selected =
                ss.name === this.selectedSubSection ? true : false),
          );
        }
        if (s.subsection) {
          s.subsection?.forEach(
            (ss: any) =>
              (ss.selected =
                ss.name === this.selectedSubSection ? true : false),
          );
        }
      });
    });
    this.selectedcompareacrossOption = option;
    this.selectedType.emit(option);
    this.entry_nested_items_expand = '';

    this.entry_nested_items_expand1 = '';
    this.entry_nested_items_expandParent1 = '';
    this.entry_nested_items_expand2 = '';
    this.entry_nested_items_expandParent2 = '';
    this.entry_nested_items_expand3 = '';
    this.entry_nested_items_expandParent3 = '';
    this.GetMandatorySelectionsList();

    if (this.snapshotDataConfig.snapshotType_details.length > 0) {
      let snapshotTypeEPandD =
        this.snapshotDataConfig.snapshotType_details.find(
          (x: any) => x.snapshot_type === option,
        );

      const entryTabDiv = document.querySelector('.EntryTab');
      const loadDiv = document.querySelector('.btn-load');
      const variableTab = document.querySelector('.variableTab');

      entryTabDiv?.classList.add('DN');
      loadDiv?.classList.add('DN');
      variableTab?.classList.add('DN');

      const submitreset = document.querySelector('.submit-reset-btn disabled');
      if (!submitreset?.classList.contains('disabled'))
        submitreset?.classList.add('disabled');

      let selectedEPs = snapshotTypeEPandD.entry_point.filter(
        (x: any) => x.is_selected === true,
      );
      let selectedEPsVariableCodes = selectedEPs.map(
        (x: any) => x.variable_code,
      );
      this.level0EP = [];
      this.entryPanel = [];
      if (selectedEPs.length > 0) {
        if (entryTabDiv) {
          entryTabDiv.classList.remove('DN');
        }
        if (loadDiv) loadDiv.classList.remove('DN');
        let entryPointsData = this.entryPointsData.filter((a: any) =>
          selectedEPsVariableCodes.includes(a.VariableCode),
        );
        const Leve1 = _.uniq(
          _.map(
            _.filter(
              entryPointsData,
              (item) =>
                item.Level1 !== null &&
                item.Level2 !== '' &&
                item.study == this.selected_study,
            ),
            'Level1',
          ),
        );
        let index = 0;
        let uniqueVariableCode: string[] = [];

        let isEntryPoints = false;
        for (const element of Leve1) {
          this.entryPanel.push({
            Level1: element,
          });

          this.level0EP.push(element);
          if (
            this._configService.isGlobalDefaultSelectionEnabled &&
            this._configService.globalDefaultSelectionFlag &&
            !this.isSavedScenarioSelected &&
            this._configService.tiggerSelectionSnapshotType
          ) {
            let entryPointsDataForSelection = this.entryPointsData.find(
              (a: any) =>
                a.Level1 == element &&
                a.study == this.selected_study &&
                a.MetricOption != '',
            );
            const match = this.EPdataFor_Multiple.find(
              (a: any) =>
                a.variable_code === entryPointsDataForSelection.VariableCode,
            );
            if (
              match &&
              this.selectedcompareacrossOption !== 'Multiple Markets'
            ) {
              uniqueVariableCode.push(entryPointsDataForSelection.VariableCode);
              match.variable_label = `Entry Point ${index + 1}`;
            }

            if (this.isMultiSelectEP) {
              if (entryPointsDataForSelection) {
                isEntryPoints = true;
                this.checkBoxClick(
                  index,
                  0,
                  entryPointsDataForSelection.Header,
                  entryPointsDataForSelection.Level1,
                  entryPointsDataForSelection.Level2,
                  entryPointsDataForSelection.MetricOption,
                  entryPointsDataForSelection.VariableCode,
                  entryPointsDataForSelection.ResponseCode,
                  entryPointsDataForSelection.mandatory_variable_mapping,
                  entryPointsDataForSelection.is_SelectAll_Metrics,
                  entryPointsDataForSelection.e1_variable_code,
                  entryPointsDataForSelection.e2_variable_code,
                  entryPointsDataForSelection.e3_variable_code,
                  entryPointsDataForSelection.dimension,
                );
              }
            } else {
              if (entryPointsDataForSelection) {
                isEntryPoints = true;
                this.EPRadioClick(
                  index,
                  0,
                  entryPointsDataForSelection.Header,
                  entryPointsDataForSelection.Level1,
                  entryPointsDataForSelection.Level2,
                  entryPointsDataForSelection.MetricOption,
                  entryPointsDataForSelection.VariableCode,
                  entryPointsDataForSelection.ResponseCode,
                  entryPointsDataForSelection.mandatory_variable_mapping,
                  entryPointsDataForSelection.is_SelectAll_Metrics,
                  entryPointsDataForSelection.e1_variable_code,
                  entryPointsDataForSelection.e2_variable_code,
                  entryPointsDataForSelection.e3_variable_code,
                  entryPointsDataForSelection.dimension,
                );
              }
            }
            index++;
          }
        }
        if (uniqueVariableCode && uniqueVariableCode.length > 0) {
          this.EPdataFor_Multiple = this.EPdataFor_Multiple.filter(
            (item: any) =>
              item.variable_code === '' ||
              uniqueVariableCode.includes(item.variable_code),
          );
        }
        if (
          isEntryPoints &&
          this._configService.isGlobalDefaultSelectionEnabled &&
          this._configService.globalDefaultSelectionFlag &&
          !this.isSavedScenarioSelected
        ) {
          this.loadBtnClick(true);
        }
      } else {
        this.dataArray = [];
        const clientStudyInfo = {
          clientName: this.clientDetails.clientDetails.client_code,
          studyName: this.selected_study,
          snapshotType: this.selectedcompareacrossOption,
          isMandatoryLoadClicked:
            this.selectedcompareacrossOption == 'Multiple Markets' ||
            this.selectedcompareacrossOption == 'Multiple Categories'
              ? true
              : false,
        };
        this.dataArray.push(clientStudyInfo);
        this.loadBtnClick(selectedEPs.length > 0 ? true : false);

        // const variableTab = document.querySelector('.variableTab');
        // if (variableTab)
        //   variableTab.classList.remove('DN');
      }
      let lvl1 = '';
      let MetricOptionSelected = '';
      if (this.selectedcompareacrossOption != 'Multiple Markets') {
        lvl1 = this.dataArray[0]?.EntryPoint1?.Level1;
        //for multi market
        MetricOptionSelected =
          this.dataArray[0]?.EntryPoint1?.Level2[0]?.MetricOptions[0]?.Name;
      } else {
        lvl1 = this.dataArray[0]?.EntryPoint2?.Level1;
        //for multi market
        MetricOptionSelected =
          this.dataArray[0]?.EntryPoint2?.Level2[0]?.MetricOptions[0]?.Name;
      }
      const BindL1Entry =
        this.entryPanel.find((el) => el.Level1 === lvl1)?.Level1 || '';
      const BindL1Index = this.entryPanel.findIndex((el) => el.Level1 === lvl1);

      this.entryExpand(BindL1Entry);
      const BindL2Entry =
        this.entryPanel_Lvl2.find((el) => el.Level1 === lvl1)?.Level2 || '';
      this.entry_nested_items_expand1 = BindL2Entry;
      this.entry_nested_items_expand2 = BindL2Entry;
      this.entry_nested_items_expand3 = BindL2Entry;
      this.BindSidePanel(BindL1Index, BindL1Entry, BindL2Entry);
      const BindL3Index = this.entryPanel_Lvl3.findIndex(
        (el) => el.Level1 === lvl1 && el.MetricOptions === MetricOptionSelected,
      );
      const BindL3Entry = this.entryPanel_Lvl3.find(
        (el) => el.Level1 === lvl1 && el.MetricOptions === MetricOptionSelected,
      );
      if (BindL3Entry && !this.isMultiSelectEP) {
        this.EPRadioClick(
          BindL3Index,
          BindL1Index,
          this.EntryPointHeader,
          BindL3Entry.Level1,
          BindL3Entry.Level2,
          BindL3Entry.MetricOptions,
          BindL3Entry.variableCode,
          BindL3Entry.responseCode,
          BindL3Entry.mandatory_variable_mapping,
          false,
          BindL3Entry.e1_variable_code,
          BindL3Entry.e2_variable_code,
          BindL3Entry.e3_variable_code,
          BindL3Entry.dimension,
        );
      }
      if (this.selectedcompareacrossOption != 'Multiple Markets') {
        this.loadBtnClick(selectedEPs.length > 0 ? true : false);
      } else if (
        this.selectedcompareacrossOption == 'Multiple Markets' &&
        selectedEPs.length > 0
      ) {
        this.loadBtnClick(selectedEPs.length > 0 ? true : false);
      }

      // const simulatedEvent = new MouseEvent('click', {
      //   bubbles: true,
      //   cancelable: true,
      //   view: window
      // });
      //   let TP = JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)?.selections[0]['Time Period'][0];
      //   let BrandLoad = JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)?.selections[1]['Brands'][0];
      //   let TPData: any = this.variableList?.find((item: any) => item?.Level0 === TP?.Level0);
      //   let TPDataL1: any = TPData?.Level1?.find((item: any) => item?.Level1_value === TP?.Level1);
      //   let BrandLoadData: any = this.variableList?.find((item: any) => item?.Level0 === BrandLoad?.Level0);
      //   let BrandLoadDataL1: any = BrandLoadData?.Level1?.find((item: any) => item?.Level1_value === BrandLoad?.Level1);
      //   this.checkBoxClickNotEPRadio('NOTfilters', simulatedEvent, TP.Level1, TP.Level2, TP.Level3, TP.Level4, TP.Level5, TPDataL1?.Level2, 'Level2', TPDataL1, TP.Level0, true);
      //   this.checkBoxClickNotEPRadio('NOTfilters', simulatedEvent, BrandLoad.Level1, BrandLoad.Level2, BrandLoad.Level3, BrandLoad.Level4, BrandLoad.Level5, BrandLoadDataL1?.Level2, 'Level2', BrandLoadDataL1, BrandLoad.Level0, true);

      //   setTimeout(() => {
      //     let index = this.variableList.indexOf(TPData);
      //     if (index !== -1) {
      //       this.variableList[index].Level1 = TPData.Level1; // Explicitly reassign modified object
      //       this.variableList = [...this.variableList];
      //       this.cdr.detectChanges();
      //     }
      //   }, 0);
      //   setTimeout(() => {
      //     let index = this.variableList.indexOf(BrandLoadData);
      //     if (index !== -1) {
      //       this.variableList[index].Level1 = BrandLoadData.Level1; // Explicitly reassign modified object
      //       this.variableList = [...this.variableList];
      //       this.cdr.detectChanges();
      //     }
      //   }, 0);
    }
  }

  autoSelectDefaultBrands() {
    if (!this.defaultBrandList || this.defaultBrandList.length === 0) return;

    const simulatedEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    });

    const brandsVariable = this.variableList.find(
      (item: any) => item.Level0 === 'Brands',
    );
    if (!brandsVariable) return;

    for (const level1Data of brandsVariable.Level1 || []) {
      for (const level2Data of level1Data.Level2 || []) {
        if (
          this.defaultBrandList.includes(level2Data.Level2_value) &&
          !level2Data.is_selected
        ) {
          const selection = this.buildSelectedObject(
            'Default',
            level1Data,
            level2Data,
            '',
          );
          this.checkBoxClickNotEP(
            'NOTfilters',
            simulatedEvent,
            selection.Level1,
            selection.Level2,
            selection.Level3,
            selection.Level4,
            selection.Level5,
            selection.Level6 || '',
            selection.Level7 || '',
            selection.Level8 || '',
            selection.Level9 || '',
            'Brands',
            true,
            selection,
            true,
          );
        }
      }
    }
  }

  GlobalDefaultSelection() {
    //this.selectedObjects = [];
    this._configService.saveSelectionLoad = true;
    const simulatedEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    });

    if (
      !this.selectedcompareacrossOption.includes('Multiple') &&
      !(
        this.selectedcompareacrossOption === 'Audience Snapshot' &&
        !this.isSingleaudienceCohortType
      )
    ) {
      this.variableList.forEach((item: any) => {
        const level0 = item.Level0;
        const level1List = item.Level1;
        if (!level1List?.length) return;
        const selectedItems = [];
        if (level0 === 'Time Period') {
          const level2Array = level1List[0]?.Level2 || [];
          // Prefer Most recent (first after inject); fallback to latest concrete
          const selectedLevel2 = level2Array[0];

          if (selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1List[0],
                selectedLevel2,
                '',
              ),
            );
          }
        } else if (level0 === 'Brands') {
          level1List.forEach((level1: any) => {
            const level2Items =
              this.defaultBrandList?.length > 0
                ? (level1.Level2 || []).filter((l2: any) =>
                    this.defaultBrandList.includes(l2.Level2_value),
                  )
                : [level1.Level2?.[0]];
            level2Items.forEach((selectedLevel2: any) => {
              if (selectedLevel2) {
                selectedItems.push(
                  this.buildSelectedObject(level0, level1, selectedLevel2, ''),
                );
              }
            });
          });
        } else if (level0 === 'Audience' && this.isSingleaudienceCohortType) {
          const firstAudience = level1List.filter(
            (level1: any) => level1.Level1_value !== 'Total Sample',
          );
          const level1 = firstAudience[0];
          const selectedLevel2 = level1.Level2?.[0]; // first item
          const selectedLevel3 = selectedLevel2.Level3?.[0] ?? {};
          if (selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1,
                selectedLevel2,
                selectedLevel3,
              ),
            );
          }
        } else {
          const level1 = level1List[0];
          const deepest = this.getDeepestLevels(level1?.Level2 || [], 'first');

          if (deepest.selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1,
                deepest.selectedLevel2,
                deepest.selectedLevel3,
                deepest.selectedLevel4,
                deepest.selectedLevel5,
              ),
            );
          }
        }

        if (selectedItems.length > 0) {
          // Remove existing entry for same level0 to prevent duplicates during global default
          this.selectedObjects = this.selectedObjects.filter(
            (obj: any) => !obj.hasOwnProperty(level0),
          );
          this.selectedObjects.push({ [level0]: selectedItems });
        }
      });

      this.selectedObjects.forEach((obj: any) => {
        const level0Key = Object.keys(obj)[0];
        const selection = obj[level0Key]?.[0];
        if (!selection || selection.isFilter) return;

        const level0 = selection.Level0;
        const level1 = selection.Level1;
        const level2 = selection.Level2;
        const level3 = selection.Level3;
        const level4 = selection.Level4;
        const level5 = selection.Level5;

        const variableData = this.variableList.find(
          (item: any) => item.Level0 === level0,
        );
        const level1Data = variableData?.Level1?.find(
          (l1: any) => l1.Level1_value === level1,
        );

        if (!level1Data) return;

        let useLevel = 'Level2';
        let levelData = level1Data?.Level2;
        let currentLevel = level1Data?.Level2?.find(
          (l2: any) => l2.Level2_value === level2,
        );

        if (currentLevel?.Level3?.length > 0) {
          useLevel = 'Level3';
          levelData = currentLevel.Level3;
          currentLevel = currentLevel.Level3?.find(
            (l3: any) => l3.Level3_value === level3,
          );

          if (currentLevel?.Level4?.length > 0) {
            useLevel = 'Level4';
            levelData = currentLevel.Level4;
            currentLevel = currentLevel.Level4?.find(
              (l4: any) => l4.Level4_value === level4,
            );

            if (currentLevel?.Level5?.length > 0) {
              useLevel = 'Level5';
              levelData = currentLevel.Level5;
            }
          }
        }

        if (level0 === 'Time Period' && this._configService.isStaticTimeFrame) {
          return;
        }

        this.checkBoxClickNotEPRadio(
          'NOTfilters',
          simulatedEvent,
          level1,
          level2,
          level3,
          level4,
          level5,
          levelData,
          useLevel,
          level1Data,
          level0,
          true,
        );
      });

      if (
        this._configService.isAggregatedData &&
        this.variableListFilter.length > 0 &&
        this.variableListFilter[0]?.Level1?.length > 0
      ) {
        this.GlobalFilterSelectionForAggregated(simulatedEvent);
      }
      if (
        this.isSingleaudienceCohortType ||
        this.selectedcompareacrossOption != 'Audience Snapshot'
      ) {
        this.SubmitClicked(false, false, true);
      }
    }

    if (
      this.selectedcompareacrossOption == 'Multiple Brands' ||
      (this.selectedcompareacrossOption == 'Audience Snapshot' &&
        !this.isSingleaudienceCohortType)
    ) {
      this.variableList.forEach((item: any) => {
        const level0 = item.Level0;
        const level1List = item.Level1;
        if (!level1List?.length) return;

        const selectedItems = [];

        if (level0 === 'Time Period') {
          const level2Array = level1List[0]?.Level2 || [];
          // Prefer Most recent (first after inject); fallback to latest concrete
          const selectedLevel2 = level2Array[0];
          if (selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1List[0],
                selectedLevel2,
                '',
              ),
            );
          }
        } else if (level0 === 'Brands') {
          const level2Array = level1List?.[0]?.Level2 || [];
          const brandsToSelect =
            this.defaultBrandList?.length > 0
              ? level2Array.filter((l2: any) =>
                  this.defaultBrandList.includes(l2.Level2_value),
                )
              : level2Array.slice(0, 6);
          brandsToSelect.forEach((selectedLevel2: any) => {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1List[0],
                selectedLevel2,
                '',
              ),
            );
          });
        } else if (level0 === 'Audience') {
          const firstAudience = level1List.find(
            (level1: any) => level1.Level1_value !== 'Total Sample',
          );
          if (firstAudience) {
            firstAudience.Level2?.slice(0, 3).forEach((selectedLevel2: any) => {
              selectedItems.push(
                this.buildSelectedObject(
                  level0,
                  firstAudience,
                  selectedLevel2,
                  '',
                ),
              );
            });
          }
        } else {
          const level1 = level1List[0];
          const {
            selectedLevel2,
            selectedLevel3,
            selectedLevel4,
            selectedLevel5,
          } = this.getDeepestLevels(level1.Level2, 'first');
          if (selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1,
                selectedLevel2,
                selectedLevel3,
                selectedLevel4,
                selectedLevel5,
              ),
            );
          }
        }

        if (selectedItems.length > 0) {
          // Remove existing entry for same level0 to prevent duplicates during global default
          this.selectedObjects = this.selectedObjects.filter(
            (obj: any) => !obj.hasOwnProperty(level0),
          );
          this.selectedObjects.push({ [level0]: selectedItems });
        }
      });

      this.selectedObjects.forEach((obj: any) => {
        const level0Key = Object.keys(obj)[0];
        const selections = obj[level0Key];
        if (!selections || selections.isFilter) return;

        const variableData = this.variableList.find(
          (item: any) => item.Level0 === level0Key,
        );
        if (!variableData) return;

        selections.forEach((selection: any) => {
          const level1 = selection.Level1;
          const level2 = selection.Level2;
          const level3 = selection.Level3;
          const level4 = selection.Level4;
          const level5 = selection.Level5;
          const level6 = selection.Level6;
          const level7 = selection.Level7;
          const level8 = selection.Level8;
          const level9 = selection.Level9;

          const level1Data = variableData.Level1?.find(
            (l1: any) => l1.Level1_value === level1,
          );
          if (!level1Data) return;

          const level2Data = level1Data.Level2?.find(
            (l2: any) => l2.Level2_value === level2,
          );
          const level3Data = level2Data?.Level3?.find(
            (l3: any) => l3.Level3_value === level3,
          );
          const level4Data = level3Data?.Level4?.find(
            (l4: any) => l4.Level4_value === level4,
          );
          const level5Data = level4Data?.Level5?.find(
            (l5: any) => l5.Level5_value === level5,
          );
          const level6Data = level5Data?.Level6?.find(
            (l6: any) => l6.Level6_value === level6,
          );
          const level7Data = level6Data?.Level7?.find(
            (l7: any) => l7.Level7_value === level7,
          );
          const level8Data = level7Data?.Level8?.find(
            (l8: any) => l8.Level8_value === level8,
          );
          const level9Data = level8Data?.Level7?.find(
            (l9: any) => l9.Level9_value === level9,
          );

          let useLevel = 'Level2';
          let levelData = level1Data.Level2;

          if (level2Data?.Level3?.length > 0) {
            useLevel = 'Level3';
            levelData = level2Data.Level3;
          }
          if (level3Data?.Level4?.length > 0) {
            useLevel = 'Level4';
            levelData = level3Data.Level4;
          }
          if (level4Data?.Level5?.length > 0) {
            useLevel = 'Level5';
            levelData = level4Data.Level5;
          }
          if (level5Data?.Level6?.length > 0) {
            useLevel = 'Level6';
            levelData = level5Data.Level6;
          }
          if (level6Data?.Level7?.length > 0) {
            useLevel = 'Level7';
            levelData = level6Data.Level7;
          }
          if (level7Data?.Level8?.length > 0) {
            useLevel = 'Level8';
            levelData = level7Data.Level8;
          }
          if (level8Data?.Level8?.length > 0) {
            useLevel = 'Level8';
            levelData = level8Data.Level9;
          }

          if (
            level0Key === 'Time Period' &&
            this._configService.isStaticTimeFrame
          ) {
            return;
          }

          if (level0Key === 'Brands' || level0Key === 'Audience') {
            this.checkBoxClickNotEP(
              'NOTfilters',
              simulatedEvent,
              level1,
              level2,
              level3,
              level4,
              level5,
              level6,
              level7,
              level8,
              level9,
              level0Key,
              true,
              selection,
              true,
            );
          } else {
            this.checkBoxClickNotEPRadio(
              'NOTfilters',
              simulatedEvent,
              level1,
              level2,
              level3,
              level4,
              level5,
              levelData,
              useLevel,
              level1Data,
              level0Key,
              true,
            );
          }
        });
      });

      if (
        this._configService.isAggregatedData &&
        this.variableListFilter.length > 0 &&
        this.variableListFilter[0]?.Level1?.length > 0
      ) {
        this.GlobalFilterSelectionForAggregated(simulatedEvent);
      }
      this.SubmitClicked(false, false, true);
    }

    //   if (this.selectedcompareacrossOption == 'Audience Snapshot'&& this.snapshotcohortType == 'multiple') {
    //   this.variableList.forEach((item: any) => {
    //     const level0 = item.Level0;
    //     const level1List = item.Level1;
    //     if (!level1List?.length) return;

    //     const selectedItems = [];

    //     if (level0 === 'Time Period') {
    //       const level2Array = level1List[0]?.Level2 || [];
    //       const selectedLevel2 = level2Array.at(-1);
    //       if (selectedLevel2) {
    //         selectedItems.push(
    //           this.buildSelectedObject(
    //             level0,
    //             level1List[0],
    //             selectedLevel2,
    //             ''
    //           )
    //         );
    //       }
    //     } else if (level0 === 'Audience') {

    //       const level2Array = level1List?.[1]?.Level2 || [];
    //       level2Array.slice(0, 3).forEach((selectedLevel2: any) => {
    //         selectedItems.push(
    //           this.buildSelectedObject(
    //             level0,
    //             level1List[1],
    //             selectedLevel2,
    //             ''
    //           )
    //         );
    //       });
    //     } else {
    //       const level1 = level1List[0];
    //       const {
    //         selectedLevel2,
    //         selectedLevel3,
    //         selectedLevel4,
    //         selectedLevel5,
    //       } = this.getDeepestLevels(level1.Level2, 'first');
    //       if (selectedLevel2) {
    //         selectedItems.push(
    //           this.buildSelectedObject(
    //             level0,
    //             level1,
    //             selectedLevel2,
    //             selectedLevel3,
    //             selectedLevel4,
    //             selectedLevel5
    //           )
    //         );
    //       }
    //     }

    //     if (selectedItems.length > 0) {
    //       this.selectedObjects.push({ [level0]: selectedItems });
    //     }
    //   });

    //   this.selectedObjects.forEach((obj: any) => {
    //     const level0Key = Object.keys(obj)[0];
    //     const selections = obj[level0Key];
    //     if (!selections || selections.isFilter) return;

    //     const variableData = this.variableList.find(
    //       (item: any) => item.Level0 === level0Key
    //     );
    //     if (!variableData) return;

    //     selections.forEach((selection: any) => {
    //       const level1 = selection.Level1;
    //       const level2 = selection.Level2;
    //       const level3 = selection.Level3;
    //       const level4 = selection.Level4;
    //       const level5 = selection.Level5;

    //       const level1Data = variableData.Level1?.find(
    //         (l1: any) => l1.Level1_value === level1
    //       );
    //       if (!level1Data) return;

    //       const level2Data = level1Data.Level2?.find(
    //         (l2: any) => l2.Level2_value === level2
    //       );
    //       const level3Data = level2Data?.Level3?.find(
    //         (l3: any) => l3.Level3_value === level3
    //       );
    //       const level4Data = level3Data?.Level4?.find(
    //         (l4: any) => l4.Level4_value === level4
    //       );
    //       const level5Data = level4Data?.Level5?.find(
    //         (l5: any) => l5.Level5_value === level5
    //       );

    //       let useLevel = 'Level2';
    //       let levelData = level1Data.Level2;

    //       if (level2Data?.Level3?.length > 0) {
    //         useLevel = 'Level3';
    //         levelData = level2Data.Level3;
    //       }
    //       if (level3Data?.Level4?.length > 0) {
    //         useLevel = 'Level4';
    //         levelData = level3Data.Level4;
    //       }
    //       if (level4Data?.Level5?.length > 0) {
    //         useLevel = 'Level5';
    //         levelData = level4Data.Level5;
    //       }

    //       if (
    //         level0Key === 'Time Period' &&
    //         this._configService.isStaticTimeFrame
    //       ) {
    //         return;
    //       }

    //       if (level0Key === 'Audience') {
    //         this.checkBoxClickNotEP(
    //           'NOTfilters',
    //           simulatedEvent,
    //           level1,
    //           level2,
    //           level3,
    //           level4,
    //           level5,
    //           level0Key,
    //           true,
    //           selection,
    //           true
    //         );
    //       } else {
    //         this.checkBoxClickNotEPRadio(
    //           'NOTfilters',
    //           simulatedEvent,
    //           level1,
    //           level2,
    //           level3,
    //           level4,
    //           level5,
    //           levelData,
    //           useLevel,
    //           level1Data,
    //           level0Key,
    //           true
    //         );
    //       }
    //     });
    //   });

    //   if (
    //     this._configService.isAggregatedData &&
    //     this.variableListFilter.length > 0 &&
    //     this.variableListFilter[0]?.Level1?.length > 0
    //   ) {
    //     this.GlobalFilterSelectionForAggregated(simulatedEvent);
    //   }
    //   this.SubmitClicked(false, false, true);
    // }

    if (this.selectedcompareacrossOption == 'Multiple Markets') {
      let entryPointsData = this.entryPointsData.filter(
        (a: any) =>
          a.study == this.selected_study &&
          (a.VariableCode == 'Market' || a.Level1 == 'Markets'),
      );

      entryPointsData = entryPointsData.filter(
        (item: any, index: number, self: any[]) =>
          index ===
          self.findIndex(
            (t: any) =>
              (t.MetricOption || '').toLowerCase() ===
              (item.MetricOption || '').toLowerCase(),
          ),
      );

      if (entryPointsData && entryPointsData.length > 0) {
        const limitEntryPoints =
          entryPointsData.length > 6
            ? entryPointsData.slice(0, 6)
            : entryPointsData;

        const marketLoads = limitEntryPoints.map(
          (item: any, index: number) => ({
            response_code: item.ResponseCode,
            derived_metric_calculation: item.calculation_type || '',
            variable_label: item.MetricOption,
            Level0: item.Level1 === 'Markets' ? 'Markets' : 'Market',
            Level1: item.Level2 === 'Markets' ? 'Markets' : 'Market',
            Level2: item.MetricOption || '',
            Level3: '',
            Level4: '',
            Level5: '',
            year_code: item.year_code || null,
            is_brand_analysis: item.is_brand_analysis ? '1' : '0',
            is_derived: String(item.is_derived_variable ?? false),
            calc_type: item.calculation_type || '',
            hasNextLevel: 'false',
            variable_code: item.VariableCode,
            sort_id: (index + 1).toString(),
            is_multi_punch: item.is_multi_punch ? '1' : '0',
            date: item.date,
            is_dimension: 'false',
            is_CustomGroup: 'false',
            kibanaFilterScript: '',
            customGroupId: null,
            dataYearCode:
              item.mandatory_variable_mapping?.find(
                (m: any) => m.variable_sub_label === 'Year',
              )?.variable_code || '',
            is_time_Period_Present: item.mandatory_variable_mapping?.some(
              (m: any) => m.variable_label === 'Time Period',
            )
              ? 'true'
              : 'false',
          }),
        );

        if (this.dataArray_Multiple.length > 0) {
          this.dataArray_Multiple[0].EntryPoint1 = {};
        }

        if (
          marketLoads.length > 0 &&
          this.dataArray_Multiple.length == 0 &&
          this.variableListMultiMarketAndCateg.length > 0
        ) {
          this.selectedObjects.push({ ['Markets']: marketLoads });
          marketLoads.forEach((MarketLoad: any) => {
            let MarketLoadData: any =
              this.variableListMultiMarketAndCateg?.find(
                (item: any) => item?.Level0 === MarketLoad?.Level0,
              );
            if (MarketLoadData) {
              this.checkBoxClickMultiple(
                simulatedEvent,
                MarketLoad.Level0,
                MarketLoad.Level1,
                MarketLoad.variable_label,
                MarketLoad.variable_code,
                MarketLoad.response_code,
                MarketLoad.Level1,
                MarketLoad.Level2,
                MarketLoad.Level3,
                MarketLoad.Level4,
                MarketLoad.Level5,
                MarketLoad.Level0,
                true,
                MarketLoad,
                0,
                false,
              );
            }
          });
          if (this.dataArray_Multiple.length > 0) {
            this.MultipleloadBtnClick(true, true);
            this.isMultiMarketOrCateg = true;
          }
        }

        if (this.variableList.length > 0) {
          this.variableList.forEach((item: any) => {
            const level0 = item.Level0;
            const level1List = item.Level1;
            if (!level1List?.length) return;
            const selectedItems = [];

            if (level0 === 'Time Period') {
              const level2Array = level1List[0]?.Level2 || [];
              const selectedLevel2 = level2Array.at(-1); // last item

              if (selectedLevel2) {
                selectedItems.push(
                  this.buildSelectedObject(
                    level0,
                    level1List[0],
                    selectedLevel2,
                    '',
                  ),
                );
              }
            } else if (level0 === 'Brands') {
              level1List.forEach((level1: any) => {
                const level2Items =
                  this.defaultBrandList?.length > 0
                    ? (level1.Level2 || []).filter((l2: any) =>
                        this.defaultBrandList.includes(l2.Level2_value),
                      )
                    : [level1.Level2?.[0]];
                level2Items.forEach((selectedLevel2: any) => {
                  if (selectedLevel2) {
                    selectedItems.push(
                      this.buildSelectedObject(
                        level0,
                        level1,
                        selectedLevel2,
                        '',
                      ),
                    );
                  }
                });
              });
            } else {
              const level1 = level1List[0];
              const deepest = this.getDeepestLevels(
                level1?.Level2 || [],
                'first',
              );

              if (deepest.selectedLevel2) {
                selectedItems.push(
                  this.buildSelectedObject(
                    level0,
                    level1,
                    deepest.selectedLevel2,
                    deepest.selectedLevel3,
                    deepest.selectedLevel4,
                    deepest.selectedLevel5,
                  ),
                );
              }
            }

            if (selectedItems.length > 0) {
              this.selectedObjects.push({ [level0]: selectedItems });
            }
          });

          this.selectedObjects.forEach((obj: any) => {
            const level0Key = Object.keys(obj)[0];
            const selection = obj[level0Key]?.[0];
            if (!selection || selection.isFilter) return;

            const level0 = selection.Level0;
            const level1 = selection.Level1;
            const level2 = selection.Level2;
            const level3 = selection.Level3;
            const level4 = selection.Level4;
            const level5 = selection.Level5;

            const variableData = this.variableList.find(
              (item: any) => item.Level0 === level0,
            );
            const level1Data = variableData?.Level1?.find(
              (l1: any) => l1.Level1_value === level1,
            );

            if (!level1Data) return;

            let useLevel = 'Level2';
            let levelData = level1Data?.Level2;
            let currentLevel = level1Data?.Level2?.find(
              (l2: any) => l2.Level2_value === level2,
            );

            if (currentLevel?.Level3?.length > 0) {
              useLevel = 'Level3';
              levelData = currentLevel.Level3;
              currentLevel = currentLevel.Level3?.find(
                (l3: any) => l3.Level3_value === level3,
              );

              if (currentLevel?.Level4?.length > 0) {
                useLevel = 'Level4';
                levelData = currentLevel.Level4;
                currentLevel = currentLevel.Level4?.find(
                  (l4: any) => l4.Level4_value === level4,
                );

                if (currentLevel?.Level5?.length > 0) {
                  useLevel = 'Level5';
                  levelData = currentLevel.Level5;
                }
              }
            }

            if (
              level0 === 'Time Period' &&
              this._configService.isStaticTimeFrame
            ) {
              return;
            }

            this.checkBoxClickNotEPRadio(
              'NOTfilters',
              simulatedEvent,
              level1,
              level2,
              level3,
              level4,
              level5,
              levelData,
              useLevel,
              level1Data,
              level0,
              true,
            );
          });

          if (
            this._configService.isAggregatedData &&
            this.variableListFilter.length > 0 &&
            this.variableListFilter[0]?.Level1?.length > 0
          ) {
            this.GlobalFilterSelectionForAggregated(simulatedEvent);
          }

          let m = this.variableListMultiMarketAndCateg?.find(
            (item: any) => item?.Level0 === 'Markets',
          );
          m?.Level1[0].Level2.forEach((mm: any) => {
            let ispresent = marketLoads.find(
              (l: any) => l.Level2 == mm.Level2_value,
            );
            if (ispresent) {
              mm.is_selected = true;
            } else {
              mm.is_selected = false;
            }
          });
          this.SubmitClicked(false, false, true);
        }
      }
    }
  }

  getDeepestLevels(level2List: any[] = [], pick: 'first' | 'last' = 'last') {
    const getItem = (list: any[]) => {
      if (!list?.length) return undefined;
      return pick === 'first' ? list[0] : list.at(-1);
    };

    const selectedLevel2 = getItem(level2List);
    if (!selectedLevel2) return {};

    const selectedLevel3 = getItem(selectedLevel2.Level3 || []);
    const selectedLevel4 = getItem(selectedLevel3?.Level4 || []);
    const selectedLevel5 = getItem(selectedLevel4?.Level5 || []);

    return {
      selectedLevel2,
      selectedLevel3,
      selectedLevel4,
      selectedLevel5,
    };
  }

  buildSelectedObject(
    level0: string,
    level1: any,
    level2: any,
    level3: any = {},
    level4: any = {},
    level5: any = {},
    isFilter = false,
  ): any {
    // Merge from shallowest to deepest — deepest (level5) has highest priority
    const source = { ...level1, ...level2, ...level3, ...level4, ...level5 };
    if (!isFilter) {
      return {
        response_code: source.response_code || '',
        derived_metric_calculation: source.derived_metric_calculation || '',
        variable_label:
          source.Level5_value ||
          source.Level4_value ||
          source.Level3_value ||
          source.Level2_value ||
          '',
        Level0: level0,
        Level1: source.Level1_value,
        Level2: source.Level2_value || '',
        Level3: source.Level3_value || '',
        Level4: source.Level4_value || '',
        Level5: source.Level5_value || '',
        year_code: source.year_code || '',
        is_brand_analysis: source.is_brand_analysis?.toString() || '',
        is_derived: source.is_derived?.toString() || '',
        calc_type: source.calc_type || '',
        hasNextLevel: source.hasNextLevel?.toString() || '',
        variable_code: source.data_variable_code || '',
        sort_id: source.sort_id?.toString() || '',
        is_multi_punch: source.is_multi_punch?.toString() || '',
        date: source.date || '',
        is_dimension: source.is_dimension?.toString() || '',
        is_CustomGroup: source.isCustomGrpPresent?.toString() || '',
        kibanaFilterScript: source.kibanaFilterScript || '',
        customGroupId: source.customGroupId || '',
        dataYearCode: source.dataYearCode || '',
        is_time_Period_Present: source.is_time_Period_Present?.toString() || '',
        isFilter: isFilter,
        Weekno_forSigcalculation: source.Weekno_forSigcalculation,
        isMostRecent: !!source.isMostRecent,
      };
    } else {
      return {
        response_code: source.response_code || '',
        derived_metric_calculation: source.derived_metric_calculation || '',
        variable_label:
          source.Level5_value ||
          source.Level4_value ||
          source.Level3_value ||
          source.Level2_value ||
          '',
        Level0: '',
        Level1: level0,
        Level2: source.Level1_value,
        Level3: source.Level2_value || '',
        Level4: source.Level3_value || '',
        Level5: source.Level4_value || '',
        // Level5: source.Level5_value || "",
        year_code: source.year_code || '',
        is_brand_analysis: source.is_brand_analysis?.toString() || '',
        is_derived: source.is_derived?.toString() || '',
        calc_type: source.calc_type || '',
        hasNextLevel: source.hasNextLevel?.toString() || '',
        variable_code: source.data_variable_code || '',
        sort_id: source.sort_id?.toString() || '',
        is_multi_punch: source.is_multi_punch?.toString() || '',
        date: source.date || '',
        is_dimension: source.is_dimension?.toString() || '',
        is_CustomGroup: source.isCustomGrpPresent?.toString() || '',
        kibanaFilterScript: source.kibanaFilterScript || '',
        customGroupId: source.customGroupId || '',
        dataYearCode: source.dataYearCode || '',
        is_time_Period_Present: source.is_time_Period_Present?.toString() || '',
        isFilter: isFilter,
        Weekno_forSigcalculation: source.Weekno_forSigcalculation,
        isMostRecent: !!source.isMostRecent,
      };
    }
  }

  GlobalFilterSelectionForAggregated(simulatedEvent: any) {
    this.variableListFilter[0].Level1.forEach((item: any) => {
      const level0 = item.Level0;
      const level1List = item.Level1;
      if (level0 == 'KPI' || !level1List?.length) return;
      const selectedItems = [];

      const level1 = level1List[0];

      if (level1?.Level2?.length > 0) {
        const deepest = this.getDeepestLevels(level1.Level2, 'first');

        if (deepest.selectedLevel2) {
          selectedItems.push(
            this.buildSelectedObject(
              level0,
              level1,
              deepest.selectedLevel2,
              deepest.selectedLevel3,
              deepest.selectedLevel4,
              deepest.selectedLevel5,
              true,
            ),
          );
        }
      } else {
        selectedItems.push(
          this.buildSelectedObject(
            level0,
            level1,
            {}, // level2
            {}, // level3
            {}, // level4
            {},
            true,
          ),
        );
      }
      if (selectedItems.length > 0) {
        this.selectedObjects.push({ [level0]: selectedItems });
      }
    });
    this.selectedObjects.forEach((obj: any) => {
      const level0Key = Object.keys(obj)[0];
      const selection = obj[level0Key]?.[0];
      if (!selection || !selection.isFilter) return;

      this.checkBoxClickNotEP(
        'filters',
        simulatedEvent,
        '',
        selection.Level1,
        selection.Level2,
        selection.Level3,
        selection.Level4,
        selection.Level5,
        selection.Level6,
        selection.Level7,
        selection.Level8,
        '',
        true,
        selection,
        true,
      );
    });
  }
  isCustomBaseSelected: boolean = false;
  selectedCustomBaseReference: string[] = [];
  LoadSelectionVariableData() {
    let dataLoaded = sessionStorage.getItem('dataLoaded');
    if (!dataLoaded || this.isBrowserRefresh) {
      this._configService.isIndexSelected = false;
      const simulatedEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      });

      this.isCustomBaseSelected =
        this._configService.outputSnapshotData?.isCustomBaseSelected !== false;
      if (
        this.isCustomBaseSelected &&
        this.selectedScenarioData[0].selectedCustomBaseReference
      ) {
        this.selectedCustomBaseReference = JSON.parse(
          this.selectedScenarioData[0].selectedCustomBaseReference,
        );
      }

      // this.dataArray[0].EntryPoint1={}
      let selectionsLength = JSON.parse(
        this.selectedScenarioData[0]?.leftpanel_input_data,
      )?.selections.length;
      let selectionsOrder = [];
      for (let i = 0; i < selectionsLength; i++) {
        selectionsOrder.push(
          Object.keys(
            JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
              ?.selections[i],
          )[0],
        );
      }
      if (!this.selectedcompareacrossOption.includes('Multiple')) {
        let TP = JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
          ?.selections[selectionsOrder.indexOf('Time Period')][
          'Time Period'
        ][0];
        let BrandLoad = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data,
        )?.selections[selectionsOrder.indexOf('Brands')]?.['Brands'][0];
        if (BrandLoad == undefined) {
          BrandLoad = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data,
          )?.selections[selectionsOrder.indexOf('Brand')]?.['Brand'][0];
        }
        if (BrandLoad == undefined) {
          BrandLoad = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data,
          )?.selections[selectionsOrder.indexOf('Audience')]?.['Audience'][0];
        }
        let TPData: any = this.variableList?.find(
          (item: any) => item?.Level0 === TP?.Level0,
        );
        let TPDataL1: any = TPData?.Level1?.find(
          (item: any) => item?.Level1_value === TP?.Level1,
        );
        let BrandLoadData: any = this.variableList?.find(
          (item: any) => item?.Level0 === BrandLoad?.Level0,
        );
        let BrandLoadDataL1: any = BrandLoadData?.Level1?.find(
          (item: any) => item?.Level1_value === BrandLoad?.Level1,
        );
        if (!this._configService.isStaticTimeFrame) {
          this.checkBoxClickNotEPRadio(
            'NOTfilters',
            simulatedEvent,
            TP.Level1,
            TP.Level2,
            TP.Level3,
            TP.Level4,
            TP.Level5,
            TPDataL1?.Level2,
            'Level2',
            TPDataL1,
            TP.Level0,
            true,
          );
        }
        if (BrandLoadData) {
          this.checkBoxClickNotEPRadio(
            'NOTfilters',
            simulatedEvent,
            BrandLoad.Level1,
            BrandLoad.Level2,
            BrandLoad.Level3,
            BrandLoad.Level4,
            BrandLoad.Level5,
            BrandLoadDataL1?.Level2,
            'Level2',
            BrandLoadDataL1,
            BrandLoad.Level0,
            true,
          );
        } else if (BrandLoad?.Level0 === 'Audience') {
          // Audience removed from variableList — use audienceTotalSampleList
          const audienceMatch =
            this.audienceTotalSampleList?.find(
              (item: any) =>
                item.Level1 === BrandLoad.Level1 &&
                item.Level2 === BrandLoad.Level2,
            ) || BrandLoad;
          this.checkBoxClickNotEP(
            'NOTfilters',
            simulatedEvent,
            audienceMatch.Level1,
            audienceMatch.Level2,
            audienceMatch.Level3,
            audienceMatch.Level4,
            audienceMatch.Level5,
            audienceMatch.Level6 || '',
            audienceMatch.Level7 || '',
            audienceMatch.Level8 || '',
            audienceMatch.Level9 || '',
            'Audience',
            true,
            audienceMatch,
          );
        }
        this.checkBoxLoadSelectionFilters(simulatedEvent, selectionsOrder);

        this.SubmitClicked(true);
      }
      if (this.selectedcompareacrossOption == 'Multiple Brands') {
        const timePeriodIndex = selectionsOrder.indexOf('Time Period');

        let TP =
          timePeriodIndex !== -1
            ? JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
                ?.selections[timePeriodIndex]?.['Time Period']?.[0]
            : null;

        const brandIndex = selectionsOrder.indexOf('Brands');
        let BrandLoads =
          brandIndex !== -1
            ? JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
                ?.selections[brandIndex]?.['Brands']
            : null;

        if (BrandLoads == undefined) {
          BrandLoads = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data,
          )?.selections[selectionsOrder.indexOf('Brand')]?.['Brand'];
        }
        let TPData: any = this.variableList?.find(
          (item: any) => item?.Level0 === TP?.Level0,
        );
        let TPDataL1: any = TPData?.Level1?.find(
          (item: any) => item?.Level1_value === TP?.Level1,
        );
        BrandLoads.forEach((BrandLoad: any) => {
          let BrandLoadData: any = this.variableList?.find(
            (item: any) => item?.Level0 === BrandLoad?.Level0,
          );

          let BrandLoadDataL1: any = BrandLoadData?.Level1?.find(
            (item: any) => item?.Level1_value === BrandLoad?.Level1,
          );
          this.checkBoxClickNotEP(
            'NOTfilters',
            simulatedEvent,
            BrandLoad.Level1,
            BrandLoad.Level2,
            BrandLoad.Level3,
            BrandLoad.Level4,
            BrandLoad.Level5,
            BrandLoad.Level6,
            BrandLoad.Level7,
            BrandLoad.Level8,
            BrandLoad.Level9,
            BrandLoad.Level0,
            true,
            BrandLoad,
          );
        });
        if (!this._configService.isStaticTimeFrame) {
          this.checkBoxClickNotEPRadio(
            'NOTfilters',
            simulatedEvent,
            TP.Level1,
            TP.Level2,
            TP.Level3,
            TP.Level4,
            TP.Level5,
            TPDataL1?.Level2,
            'Level2',
            TPDataL1,
            TP.Level0,
            true,
          );
        }
        this.checkBoxLoadSelectionFilters(simulatedEvent, selectionsOrder);

        this.SubmitClicked(true);
      }

      if (this.selectedcompareacrossOption == 'Multiple Markets') {
        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];

        if (this.dataArray_Multiple.length > 0) {
          this.dataArray_Multiple[0].EntryPoint1 = {};
        }
        let MarketLoads = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data,
        )?.selections[selectionsOrder.indexOf('Markets')]['Markets'];
        if (
          MarketLoads.length > 0 &&
          this.dataArray_Multiple.length == 0 &&
          this.variableListMultiMarketAndCateg.length > 0
        ) {
          MarketLoads.forEach((MarketLoad: any) => {
            let MarketLoadData: any =
              this.variableListMultiMarketAndCateg?.find(
                (item: any) => item?.Level0 === MarketLoad?.Level0,
              );
            let MarketLoadDataL1: any = MarketLoadData?.Level1?.find(
              (item: any) => item?.Level1_value === MarketLoad?.Level1,
            );
            if (MarketLoadData) {
              this.checkBoxClickMultiple(
                simulatedEvent,
                MarketLoad.Level1,
                MarketLoad.Level2,
                MarketLoad.variable_label,
                MarketLoad.variable_code,
                MarketLoad.response_code,
                MarketLoad.Level1,
                MarketLoad.Level2,
                MarketLoad.Level3,
                MarketLoad.Level4,
                MarketLoad.Level5,
                MarketLoad.Level0,
                true,
                MarketLoad,
                0,
                false,
              );
              //this.SwitchMakeSelectedTrueMultiple(MarketLoadData, 'NOTfilters');
            }
          });
          if (this.dataArray_Multiple.length > 0) {
            this.MultipleloadBtnClick(true);
            this.isMultiMarketOrCateg = true;
          }
        }
        if (this.dataArray_Multiple.length > 0) {
          let TP = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data,
          )?.selections[selectionsOrder.indexOf('Time Period')][
            'Time Period'
          ][0];
          let BrandLoads = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data,
          )?.selections[selectionsOrder.indexOf('Brands')]?.['Brands'];
          if (BrandLoads == undefined) {
            BrandLoads = JSON.parse(
              this.selectedScenarioData[0]?.leftpanel_input_data,
            )?.selections[selectionsOrder.indexOf('Brands')]?.['Brands'];
          }

          let TPData: any = this.variableList?.find(
            (item: any) => item?.Level0 === TP?.Level0,
          );
          let TPDataL1: any = TPData?.Level1?.find(
            (item: any) => item?.Level1_value === TP?.Level1,
          );
          BrandLoads.forEach((BrandLoad: any) => {
            let BrandLoadData: any = this.variableList?.find(
              (item: any) => item?.Level0 === BrandLoad?.Level0,
            );

            let BrandLoadDataL1: any = BrandLoadData?.Level1?.find(
              (item: any) => item?.Level1_value === BrandLoad?.Level1,
            );
            this.checkBoxClickNotEPRadio(
              'NOTfilters',
              simulatedEvent,
              BrandLoad.Level1,
              BrandLoad.Level2,
              BrandLoad.Level3,
              BrandLoad.Level4,
              BrandLoad.Level5,
              BrandLoadDataL1?.Level2,
              'Level2',
              BrandLoadDataL1,
              BrandLoad.Level0,
              true,
            );

            // this.checkBoxClickNotEP(
            //   'NOTfilters',
            //   simulatedEvent,
            //   BrandLoad.Level1,
            //   BrandLoad.Level2,
            //   BrandLoad.Level3,
            //   BrandLoad.Level4,
            //   BrandLoad.Level5,
            //   BrandLoad.Level6,
            //   BrandLoad.Level7,
            //   BrandLoad.Level8,
            //   BrandLoad.Level9,
            //   BrandLoad.Level0,
            //   true,
            //   BrandLoad
            // );
          });
          if (!this._configService.isStaticTimeFrame) {
            this.checkBoxClickNotEPRadio(
              'NOTfilters',
              simulatedEvent,
              TP.Level1,
              TP.Level2,
              TP.Level3,
              TP.Level4,
              TP.Level5,
              TPDataL1?.Level2,
              'Level2',
              TPDataL1,
              TP.Level0,
              true,
            );
          }
          this.checkBoxLoadSelectionFilters(simulatedEvent, selectionsOrder);

          // if(Object.keys(this.dataArray_Multiple[0].EntryPoint1).length !== 0){
          //   MarketLoads.forEach((MarketLoad: any) => {
          //     let MarketLoadData: any = this.variableListMultiMarketAndCateg?.find((item: any) => item?.Level0 === MarketLoad?.Level0);
          //     let MarketLoadDataL1: any = MarketLoadData?.Level1?.find((item: any) => item?.Level1_value === MarketLoad?.Level1);
          //     if (MarketLoadData) {
          //       this.checkBoxClickMultiple(simulatedEvent, MarketLoad.Level1, MarketLoad.Level2, MarketLoad.variable_label, MarketLoad.variable_code, MarketLoad.response_code, MarketLoad.Level1, MarketLoad.Level2, MarketLoad.Level3, MarketLoad.Level4, MarketLoad.Level5, MarketLoad.Level0, true, MarketLoad, 0, false);
          //       //this.SwitchMakeSelectedTrueMultiple(MarketLoadData, 'NOTfilters');
          //     }
          //   })
          // }
          let MarketLoads = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data,
          )?.selections[selectionsOrder.indexOf('Markets')]['Markets'];
          let m = this.variableListMultiMarketAndCateg?.find(
            (item: any) => item?.Level0 === 'Markets',
          );
          m?.Level1[0].Level2.forEach((mm: any) => {
            let ispresent = MarketLoads.find(
              (l: any) => l.Level2 == mm.Level2_value,
            );
            if (ispresent) {
              mm.is_selected = true;
            } else {
              mm.is_selected = false;
            }
          });

          this.SubmitClicked(true);
        }
      }
      if (this.selectedcompareacrossOption == 'Audience Snapshot') {
        let TP = JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
          ?.selections[selectionsOrder.indexOf('Time Period')][
          'Time Period'
        ][0];
        let BrandLoads = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data,
        )?.selections[selectionsOrder.indexOf('Audience')]?.['Audience'];
        if (BrandLoads == undefined) {
          BrandLoads = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data,
          )?.selections[selectionsOrder.indexOf('Audience')]?.['Audience'];
        }
        let TPData: any = this.variableList?.find(
          (item: any) => item?.Level0 === TP?.Level0,
        );
        let TPDataL1: any = TPData?.Level1?.find(
          (item: any) => item?.Level1_value === TP?.Level1,
        );
        BrandLoads.forEach((BrandLoad: any) => {
          let BrandLoadData: any = this.variableList?.find(
            (item: any) => item?.Level0 === BrandLoad?.Level0,
          );
          if (!BrandLoadData && BrandLoad?.Level0 === 'Audience') {
            // Audience removed from variableList — use audienceTotalSampleList
            const audienceMatch =
              this.audienceTotalSampleList?.find(
                (item: any) =>
                  item.Level1 === BrandLoad.Level1 &&
                  item.Level2 === BrandLoad.Level2,
              ) || BrandLoad;
            this.checkBoxClickNotEP(
              'NOTfilters',
              simulatedEvent,
              audienceMatch.Level1,
              audienceMatch.Level2,
              audienceMatch.Level3,
              audienceMatch.Level4,
              audienceMatch.Level5,
              audienceMatch.Level6 || '',
              audienceMatch.Level7 || '',
              audienceMatch.Level8 || '',
              audienceMatch.Level9 || '',
              'Audience',
              true,
              audienceMatch,
            );
            return;
          }
          if (!BrandLoadData) return;
          let BrandLoadDataL1: any = BrandLoadData?.Level1?.find(
            (item: any) => item?.Level1_value === BrandLoad?.Level1,
          );
          this.checkBoxClickNotEP(
            'NOTfilters',
            simulatedEvent,
            BrandLoad.Level1,
            BrandLoad.Level2,
            BrandLoad.Level3,
            BrandLoad.Level4,
            BrandLoad.Level5,
            BrandLoad.Level6,
            BrandLoad.Level7,
            BrandLoad.Level8,
            BrandLoad.Level9,
            BrandLoad.Level0,
            true,
            BrandLoad,
          );
        });
        if (!this._configService.isStaticTimeFrame) {
          this.checkBoxClickNotEPRadio(
            'NOTfilters',
            simulatedEvent,
            TP.Level1,
            TP.Level2,
            TP.Level3,
            TP.Level4,
            TP.Level5,
            TPDataL1?.Level2,
            'Level2',
            TPDataL1,
            TP.Level0,
            true,
          );
        }
        this.checkBoxLoadSelectionFilters(simulatedEvent, selectionsOrder);

        this.SubmitClicked(true);
      }
    }
  }

  checkBoxLoadSelectionFilters(simulatedEvent: any, selectionsOrder: any) {
    for (let i = 0; i < selectionsOrder.length; i++) {
      if (
        selectionsOrder[i] !== 'Brands' &&
        selectionsOrder[i] !== 'Brand' &&
        (this._configService.isStaticTimeFrame ||
          selectionsOrder[i] !== 'Time Period')
      ) {
        let selectionLength = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data,
        )?.selections[i][selectionsOrder[i]].length;
        let SelectionFilterData = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data,
        )?.selections[i][selectionsOrder[i]];
        for (let j = 0; j < selectionLength; j++) {
          this.checkBoxClickNotEP(
            'filters',
            simulatedEvent,
            SelectionFilterData[j].Level1,
            SelectionFilterData[j].Level2,
            SelectionFilterData[j].Level3,
            SelectionFilterData[j].Level4,
            SelectionFilterData[j].Level5,
            SelectionFilterData[j].Level6,
            SelectionFilterData[j].Level7,
            SelectionFilterData[j].Level8,
            SelectionFilterData[j].Level9,
            SelectionFilterData[j].Level0 ? SelectionFilterData[j].Level0 : '',
            true,
            SelectionFilterData[j],
          );
        }
      }
    }
  }

  checkAudienceCount(Group: string): number {
    return this.selectedObjects
      .filter((obj) => Object.keys(obj)[0] !== Group) // remove top-level audience
      .reduce((count, obj) => {
        const key = Object.keys(obj)[0];

        // Count Level0 === 'Audience' inside nested array
        const nestedCount = obj[key].filter(
          (item: any) => item.Level0 === Group,
        ).length;

        return count + nestedCount;
      }, 0);
  }

  //   tooltipText = this.buildTooltip(this.selection);

  // buildTooltip(data: any[]) {
  //   return data
  //     .map(x => `${x.level1} : ${x.level2} : <b>${x.level3.join(', ')}</b>`)
  //     .join('<br>');
  // }

  AdditionalFeatures() {
    this.isadditionalfeatureDropdownOpen =
      !this.isadditionalfeatureDropdownOpen;
  }

  additionalFeaturesOption(option: string) {
    this.isadditionalfeatureDropdownOpen = false;
    this.additionalFeatures.emit(option);
    // this.dataListChange.emit(this.dataArray);
  }

  trackByFn(index: number, item: any) {
    return item.Level0 || item.LevelMinus || index;
  }

  trackByLevel1(index: number, item: any) {
    return item.Level1_value || item.Level0 || index;
  }

  trackByLevel2(index: number, item: any) {
    return item.Level2_value || item.Level1_value || index;
  }

  trackByLevel3(index: number, item: any) {
    return item.Level3_value || item.Level2_value || index;
  }

  trackByLevel4(index: number, item: any) {
    return item.Level4_value || item.Level3_value || index;
  }

  trackByLevel5(index: number, item: any) {
    return item.Level5_value || item.Level4_value || index;
  }

  trackByLevel6(index: number, item: any) {
    return item.Level6_value || item.Level5_value || index;
  }

  trackByLevel7(index: number, item: any) {
    return item.Level7_value || item.Level6_value || index;
  }

  trackByLevel8(index: number, item: any) {
    return item.Level8_value || item.Level7_value || index;
  }

  trackByLevel9(index: number, item: any) {
    return item.Level9_value || item.Level8_value || index;
  }

  ngOnDestroy() {
    this._isDestroyed = true;
    if (this._refreshFrameId !== null) {
      cancelAnimationFrame(this._refreshFrameId);
      this._refreshFrameId = null;
    }

    this.destroy$.next();
    this.destroy$.complete();

    // Clear caches
    this._toggleStatusCache.clear();
    this._varCodeToEntryKeyCache.clear();
    this._lastSelectedTextClickEl = null;
    this._topCache = null;
    this._topLev1Cache = null;
    this._submitButtonEl = null;
    if (this.$unSubscribeSubmitData1) {
      this.$unSubscribeSubmitData1.unsubscribe();
    }
    if (this.$unSubscribeSubmitData2) {
      this.$unSubscribeSubmitData2.unsubscribe();
    }
    // if (this.$unSubscribeSubmitData3) {
    //   this.$unSubscribeSubmitData3.unsubscribe();
    // }
  }

  // Listen for click events on the document.
  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: Event): void {
  //   // Check if the click event occurred outside the <div> block.
  //   if (!this.isClickInside(event, '.sidePanelblock')) {
  //     this.sidePanelblock = false;
  //   }
  // }

  increaseLeftbgpanelWidth(event: any) {
    const parentWidth = window.innerWidth; // Get parent width
    let newWidth = 0;
    if (event?.isReset) {
      this.resetLeftpanelWidth();
    } else {
      if (event?.isIncrease && event?.level >= 3) {
        if (event?.level == 3) {
          newWidth = (80 / 100) * parentWidth; // Calculate 80% of parent
        }
        if (event?.level == 4) {
          newWidth = (100 / 100) * parentWidth; // Calculate 90% of parent
        }
        this.bgWidth = newWidth - 400;
      }
      if (event?.isDecrease && event?.level >= 3) {
        if (event?.level == 3) {
          newWidth = (70 / 100) * parentWidth; // Calculate 80% of parent
        }
        if (event?.level == 4) {
          newWidth = (80 / 100) * parentWidth; // Calculate 90% of parent
        }
        this.bgWidth = newWidth - 400;
      }
    }
  }

  resetLeftpanelWidth() {
    if (!this.isCreateCustomGroup) {
      const parentWidth = window.innerWidth; // Get parent width
      // const currentWidth = this.leftPanel.nativeElement.offsetWidth; // Get current width in pixels
      let newWidth = 0;
      newWidth = (70 / 100) * parentWidth; // Calculate 80% of parent
      this.bgWidth = newWidth - 400;
    }
  }
  public scrollToRightEnd(): void {
    if (this.variablesScroll && this.variablesScroll.nativeElement) {
      // Use the scrollTo method for smooth behavior
      this.variablesScroll.nativeElement.scrollTo({
        left: this.variablesScroll.nativeElement.scrollWidth,
        behavior: 'smooth', // Optional: adds smooth scrolling animation
      });

      // Alternatively, use the scrollLeft property for an immediate jump
      // this.scrollContainer.nativeElement.scrollLeft = this.scrollContainer.nativeElement.scrollWidth;
    }
  }

  filterDefaultBrandsBasedOnProducts(filteredRows: any[]) {
    let SelectedProducts: string[] = [];

    //Get the filtered products from entry point selection to filter default brands in product filters — as per new requirement in snapshot — 10th June 2024
    const productSelectedObj = this.dataArray
      .flatMap((item: any) =>
        Object.keys(item)
          .filter((key) => key.startsWith('EntryPoint'))
          .map((key) => item[key]),
      )
      .find(
        (entryPoint: any) => entryPoint?.variableCode === 'PRODUCT_CATEGORY',
      );

    //If Product Selected
    if (productSelectedObj) {
      this.defaultBrandList = [];
      //Checking Products slected from entry point

      //Getting the selected products
      productSelectedObj.Level2.forEach((s: any) => {
        s.MetricOptions?.forEach((mo: any) => {
          SelectedProducts.push(mo.Name);
        });
      });

      //Filter the default brands based on the selected products and filtered rows from entry point selection
      filteredRows.forEach((row: any) => {
        let productList = row.productList || [];
        if (productList.length > 0) {
          //Checking selected products with the products from filtered rows to filter default brands
          const exists = SelectedProducts.some((item: any) =>
            productList.some(
              (x: any) => x.toLowerCase() === item.toLowerCase(),
            ),
          );

          if (exists) {
            let brands = row.brandList || [];
            if (brands.length > 0) {
              brands.forEach((itm: any) => {
                if (!this.defaultBrandList.includes(itm)) {
                  this.defaultBrandList.push(itm);
                }
              });
            }
          }
        }
      });
    }
  }
}
